
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9d24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9d24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("pyUmM", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $04cd69f16d83c082$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppClient = module.exports.PartialSignature = void 0;

var $1suGZ = parcelRequire("1suGZ");

var $bBRJ3 = parcelRequire("bBRJ3");

var $bUD38 = parcelRequire("bUD38");

var $goh0i = parcelRequire("goh0i");

var $fUsjC = parcelRequire("fUsjC");

var $8GOLq = parcelRequire("8GOLq");
const $04cd69f16d83c082$var$CLA_BTC = 0xe1;
const $04cd69f16d83c082$var$CLA_FRAMEWORK = 0xf8;
const $04cd69f16d83c082$var$CURRENT_PROTOCOL_VERSION = 1; // supported from version 2.1.0 of the app
var $04cd69f16d83c082$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($04cd69f16d83c082$var$BitcoinIns || ($04cd69f16d83c082$var$BitcoinIns = {}));
var $04cd69f16d83c082$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($04cd69f16d83c082$var$FrameworkIns || ($04cd69f16d83c082$var$FrameworkIns = {}));
/**
 * This class represents a partial signature produced by the app during signing.
 * It always contains the `signature` and the corresponding `pubkey` whose private key
 * was used for signing; in the case of taproot script paths, it also contains the
 * tapleaf hash.
 */ class $04cd69f16d83c082$var$PartialSignature {
    constructor(pubkey, signature, tapleafHash){
        this.pubkey = pubkey;
        this.signature = signature;
        this.tapleafHash = tapleafHash;
    }
}
module.exports.PartialSignature = $04cd69f16d83c082$var$PartialSignature;
/**
 * Creates an instance of `PartialSignature` from the returned raw augmented pubkey and signature.
 * @param pubkeyAugm the public key, concatenated with the tapleaf hash in the case of taproot script path spend.
 * @param signature the signature
 * @returns an instance of `PartialSignature`.
 */ function $04cd69f16d83c082$var$makePartialSignature(pubkeyAugm, signature) {
    if (pubkeyAugm.length == 64) // tapscript spend: concatenation of 32-bytes x-only pubkey and 32-bytes tapleaf_hash
    return new $04cd69f16d83c082$var$PartialSignature(pubkeyAugm.slice(0, 32), signature, pubkeyAugm.slice(32, 64));
    else if (pubkeyAugm.length == 32 || pubkeyAugm.length == 33) // legacy, segwit or taproot keypath spend: pubkeyAugm is just the pubkey
    return new $04cd69f16d83c082$var$PartialSignature(pubkeyAugm, signature);
    else throw new Error(`Invalid length for pubkeyAugm: ${pubkeyAugm.length} bytes.`);
}
/**
 * Checks whether a descriptor template contains an `a:` fragment.
 */ function $04cd69f16d83c082$var$containsA(descriptorTemplate) {
    const matches = descriptorTemplate.match(/[asctdvjnlu]+:/g) || [];
    return matches.some((match)=>match.includes("a"));
}
/**
 * This class encapsulates the APDU protocol documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md
 */ class $04cd69f16d83c082$var$AppClient {
    constructor(transport){
        this.transport = transport;
    }
    async makeRequest(ins, data, cci) {
        let response = await this.transport.send($04cd69f16d83c082$var$CLA_BTC, ins, 0, $04cd69f16d83c082$var$CURRENT_PROTOCOL_VERSION, data, [
            0x9000,
            0xe000
        ]);
        while(response.readUInt16BE(response.length - 2) === 0xe000){
            if (!cci) throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
            const hwRequest = response.slice(0, -2);
            const commandResponse = cci.execute(hwRequest);
            response = await this.transport.send($04cd69f16d83c082$var$CLA_FRAMEWORK, $04cd69f16d83c082$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                0x9000,
                0xe000
            ]);
        }
        return response.slice(0, -2); // drop the status word (can only be 0x9000 at this point)
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */ async getAppAndVersion() {
        const r = await this.transport.send(0xb0, 0x01, 0x00, 0x00);
        let i = 0;
        const format = r[i++];
        if (format !== 1) throw new Error("Unexpected response");
        const nameLength = r[i++];
        const name = r.slice(i, i += nameLength).toString("ascii");
        const versionLength = r[i++];
        const version = r.slice(i, i += versionLength).toString("ascii");
        const flagLength = r[i++];
        const flags = r.slice(i, i += flagLength);
        return {
            name: name,
            version: version,
            flags: flags
        };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */ async getExtendedPubkey(path, display = false) {
        const pathElements = (0, $1suGZ.pathStringToArray)(path);
        if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_PUBKEY, $04cd69f16d83c082$require$Buffer.concat([
            $04cd69f16d83c082$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            (0, $1suGZ.pathElementsToBuffer)(pathElements)
        ]));
        return response.toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */ async registerWallet(walletPolicy) {
        await this.validatePolicy(walletPolicy);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const serializedWalletPolicy = walletPolicy.serialize();
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.REGISTER_WALLET, $04cd69f16d83c082$require$Buffer.concat([
            (0, $8GOLq.createVarint)(serializedWalletPolicy.length),
            serializedWalletPolicy
        ]), clientInterpreter);
        if (response.length != 64) throw Error(`Invalid response length. Expected 64 bytes, got ${response.length}`);
        return [
            response.subarray(0, 32),
            response.subarray(32)
        ];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */ async getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
        if (change !== 0 && change !== 1) throw new Error("Change can only be 0 or 1");
        if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error("Invalid address index");
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        await this.validatePolicy(walletPolicy);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const addressIndexBuffer = $04cd69f16d83c082$require$Buffer.alloc(4);
        addressIndexBuffer.writeUInt32BE(addressIndex, 0);
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_WALLET_ADDRESS, $04cd69f16d83c082$require$Buffer.concat([
            $04cd69f16d83c082$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            walletPolicy.getId(),
            walletHMAC || $04cd69f16d83c082$require$Buffer.alloc(32, 0),
            $04cd69f16d83c082$require$Buffer.from([
                change
            ]),
            addressIndexBuffer
        ]), clientInterpreter);
        return response.toString("ascii");
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */ async signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
        await this.validatePolicy(walletPolicy);
        if (typeof psbt === "string") psbt = $04cd69f16d83c082$require$Buffer.from(psbt, "base64");
        if ($04cd69f16d83c082$require$Buffer.isBuffer(psbt)) {
            const psbtObj = new $fUsjC.PsbtV2();
            psbtObj.deserialize(psbt);
            psbt = psbtObj;
        }
        const merkelizedPsbt = new $bUD38.MerkelizedPsbt(psbt);
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter(progressCallback);
        // prepare ClientCommandInterpreter
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
        for (const map of merkelizedPsbt.inputMerkleMaps)clientInterpreter.addKnownMapping(map);
        for (const map of merkelizedPsbt.outputMerkleMaps)clientInterpreter.addKnownMapping(map);
        clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
        const inputMapsRoot = new $goh0i.Merkle(merkelizedPsbt.inputMapCommitments.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
        const outputMapsRoot = new $goh0i.Merkle(merkelizedPsbt.outputMapCommitments.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.SIGN_PSBT, $04cd69f16d83c082$require$Buffer.concat([
            merkelizedPsbt.getGlobalKeysValuesRoot(),
            (0, $8GOLq.createVarint)(merkelizedPsbt.getGlobalInputCount()),
            inputMapsRoot,
            (0, $8GOLq.createVarint)(merkelizedPsbt.getGlobalOutputCount()),
            outputMapsRoot,
            walletPolicy.getId(),
            walletHMAC || $04cd69f16d83c082$require$Buffer.alloc(32, 0)
        ]), clientInterpreter);
        const yielded = clientInterpreter.getYielded();
        const ret = [];
        for (const inputAndSig of yielded){
            // inputAndSig contains:
            // <inputIndex : varint> <pubkeyLen : 1 byte> <pubkey : pubkeyLen bytes (32 or 33)> <signature : variable length>
            const [inputIndex, inputIndexLen] = (0, $8GOLq.parseVarint)(inputAndSig, 0);
            const pubkeyAugmLen = inputAndSig[inputIndexLen];
            const pubkeyAugm = inputAndSig.subarray(inputIndexLen + 1, inputIndexLen + 1 + pubkeyAugmLen);
            const signature = inputAndSig.subarray(inputIndexLen + 1 + pubkeyAugmLen);
            const partialSig = $04cd69f16d83c082$var$makePartialSignature(pubkeyAugm, signature);
            ret.push([
                Number(inputIndex),
                partialSig
            ]);
        }
        return ret;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */ async getMasterFingerprint() {
        const fpr = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_MASTER_FINGERPRINT, $04cd69f16d83c082$require$Buffer.from([]));
        return fpr.toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */ async signMessage(message, path) {
        const pathElements = (0, $1suGZ.pathStringToArray)(path);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        // prepare ClientCommandInterpreter
        const nChunks = Math.ceil(message.length / 64);
        const chunks = [];
        for(let i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
        clientInterpreter.addKnownList(chunks);
        const chunksRoot = new $goh0i.Merkle(chunks.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        const result = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.SIGN_MESSAGE, $04cd69f16d83c082$require$Buffer.concat([
            (0, $1suGZ.pathElementsToBuffer)(pathElements),
            (0, $8GOLq.createVarint)(message.length),
            chunksRoot
        ]), clientInterpreter);
        return result.toString("base64");
    }
    /* Performs any additional checks on the policy before using it.*/ async validatePolicy(walletPolicy) {
        if ($04cd69f16d83c082$var$containsA(walletPolicy.descriptorTemplate)) {
            const appAndVer = await this.getAppAndVersion();
            if ([
                "2.1.0",
                "2.1.1"
            ].includes(appAndVer.version)) // Versions 2.1.0 and 2.1.1 produced incorrect scripts for policies containing
            // the `a:` fragment.
            throw new Error("Please update your Ledger Bitcoin app.");
        }
    }
}
module.exports.AppClient = $04cd69f16d83c082$var$AppClient;
module.exports.default = $04cd69f16d83c082$var$AppClient;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("1suGZ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $110036d6b13dde20$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $110036d6b13dde20$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hardenedPathOf = module.exports.getXpubComponents = module.exports.pubkeyFromXpub = module.exports.pathStringToArray = module.exports.pathArrayToString = module.exports.bip32asBuffer = module.exports.pathElementsToBuffer = void 0;

const $110036d6b13dde20$var$bip32_path_1 = $110036d6b13dde20$var$__importDefault((parcelRequire("4c5Uh"))); // TODO: get rid of this dependency

const $110036d6b13dde20$var$bs58check_1 = $110036d6b13dde20$var$__importDefault((parcelRequire("lpa1P")));
function $110036d6b13dde20$var$pathElementsToBuffer(paths) {
    const buffer = $110036d6b13dde20$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach((element, index)=>{
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
module.exports.pathElementsToBuffer = $110036d6b13dde20$var$pathElementsToBuffer;
function $110036d6b13dde20$var$bip32asBuffer(path) {
    const pathElements = !path ? [] : $110036d6b13dde20$var$pathStringToArray(path);
    return $110036d6b13dde20$var$pathElementsToBuffer(pathElements);
}
module.exports.bip32asBuffer = $110036d6b13dde20$var$bip32asBuffer;
function $110036d6b13dde20$var$pathArrayToString(pathElements) {
    // bippath doesn't handle an empty path.
    if (pathElements.length == 0) return "m";
    return $110036d6b13dde20$var$bip32_path_1.default.fromPathArray(pathElements).toString();
}
module.exports.pathArrayToString = $110036d6b13dde20$var$pathArrayToString;
function $110036d6b13dde20$var$pathStringToArray(path) {
    // bippath doesn't handle an empty path.
    if (path == "m" || path == "") return [];
    return $110036d6b13dde20$var$bip32_path_1.default.fromString(path).toPathArray();
}
module.exports.pathStringToArray = $110036d6b13dde20$var$pathStringToArray;
function $110036d6b13dde20$var$pubkeyFromXpub(xpub) {
    const xpubBuf = $110036d6b13dde20$var$bs58check_1.default.decode(xpub);
    return xpubBuf.slice(xpubBuf.length - 33);
}
module.exports.pubkeyFromXpub = $110036d6b13dde20$var$pubkeyFromXpub;
function $110036d6b13dde20$var$getXpubComponents(xpub) {
    const xpubBuf = $110036d6b13dde20$var$bs58check_1.default.decode(xpub);
    return {
        chaincode: xpubBuf.slice(13, 45),
        pubkey: xpubBuf.slice(xpubBuf.length - 33),
        version: xpubBuf.readUInt32BE(0)
    };
}
module.exports.getXpubComponents = $110036d6b13dde20$var$getXpubComponents;
function $110036d6b13dde20$var$hardenedPathOf(pathElements) {
    for(let i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}
module.exports.hardenedPathOf = $110036d6b13dde20$var$hardenedPathOf;

});
parcelRegister("4c5Uh", function(module, exports) {
/*
 * Bitcoin BIP32 path helpers
 * (C) 2016 Alex Beregszaszi
 */ const $30dcdd5c9ca402d9$var$HARDENED = 0x80000000;
var $30dcdd5c9ca402d9$var$BIPPath = function(path) {
    if (!Array.isArray(path)) throw new Error("Input must be an Array");
    if (path.length === 0) throw new Error("Path must contain at least one level");
    for(var i = 0; i < path.length; i++){
        if (typeof path[i] !== "number") throw new Error("Path element is not a number");
    }
    this.path = path;
};
$30dcdd5c9ca402d9$var$BIPPath.validatePathArray = function(path) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromPathArray(path);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.validateString = function(text, reqRoot) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromString(text, reqRoot);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.fromPathArray = function(path) {
    return new $30dcdd5c9ca402d9$var$BIPPath(path);
};
$30dcdd5c9ca402d9$var$BIPPath.fromString = function(text, reqRoot) {
    // skip the root
    if (/^m\//i.test(text)) text = text.slice(2);
    else if (reqRoot) throw new Error("Root element is required");
    var path = text.split("/");
    var ret = new Array(path.length);
    for(var i = 0; i < path.length; i++){
        var tmp = /(\d+)([hH\']?)/.exec(path[i]);
        if (tmp === null) throw new Error("Invalid input");
        ret[i] = parseInt(tmp[1], 10);
        if (ret[i] >= $30dcdd5c9ca402d9$var$HARDENED) throw new Error("Invalid child index");
        if (tmp[2] === "h" || tmp[2] === "H" || tmp[2] === "'") ret[i] += $30dcdd5c9ca402d9$var$HARDENED;
        else if (tmp[2].length != 0) throw new Error("Invalid modifier");
    }
    return new $30dcdd5c9ca402d9$var$BIPPath(ret);
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toPathArray = function() {
    return this.path;
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toString = function(noRoot, oldStyle) {
    var ret = new Array(this.path.length);
    for(var i = 0; i < this.path.length; i++){
        var tmp = this.path[i];
        if (tmp & $30dcdd5c9ca402d9$var$HARDENED) ret[i] = (tmp & ~$30dcdd5c9ca402d9$var$HARDENED) + (oldStyle ? "h" : "'");
        else ret[i] = tmp;
    }
    return (noRoot ? "" : "m/") + ret.join("/");
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.inspect = function() {
    return "BIPPath <" + this.toString() + ">";
};
module.exports = $30dcdd5c9ca402d9$var$BIPPath;

});

parcelRegister("lpa1P", function(module, exports) {
"use strict";

var $6XnWx = parcelRequire("6XnWx");
var $f953b6354166cf05$require$sha256 = $6XnWx.sha256;

var $bJNmB = parcelRequire("bJNmB");
// SHA256(SHA256(buffer))
function $f953b6354166cf05$var$sha256x2(buffer) {
    return $f953b6354166cf05$require$sha256($f953b6354166cf05$require$sha256(buffer));
}
module.exports = $bJNmB($f953b6354166cf05$var$sha256x2);

});
parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $iYRTw.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$SHA256_IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$SHA256_IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$SHA256_IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$SHA256_IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$SHA256_IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$SHA256_IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$SHA256_IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $iYRTw.Chi)(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + (0, $iYRTw.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
module.exports.sha224 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());

});
parcelRegister("iYRTw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashMD = module.exports.Maj = module.exports.Chi = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// Polyfill for Safari 14
function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Choice: a ? b : c
const $dd17a2ee919821c7$var$Chi = (a, b, c)=>a & b ^ ~a & c;
module.exports.Chi = $dd17a2ee919821c7$var$Chi;
// Majority function, true if any two inpust is true
const $dd17a2ee919821c7$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
module.exports.Maj = $dd17a2ee919821c7$var$Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.HashMD = $dd17a2ee919821c7$var$HashMD;

});
parcelRegister("dNiq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = module.exports.isBytes = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
module.exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
module.exports.bool = $a0ae23f5901291b4$var$bool;
// copied from utils
function $a0ae23f5901291b4$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $a0ae23f5901291b4$var$isBytes;
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!$a0ae23f5901291b4$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(h.outputLen);
    $a0ae23f5901291b4$var$number(h.blockLen);
}
module.exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
module.exports.default = $a0ae23f5901291b4$var$assert;

});

parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.byteSwap32 = module.exports.byteSwapIfBE = module.exports.byteSwap = module.exports.isLE = module.exports.rotl = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = module.exports.isBytes = void 0;

var $dUxV2 = parcelRequire("dUxV2");

var $dNiq9 = parcelRequire("dNiq9");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $29ee4d3171d9809b$var$isBytes;
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
// The rotate left (circular left shift) operation for uint32
const $29ee4d3171d9809b$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
module.exports.rotl = $29ee4d3171d9809b$var$rotl;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const $29ee4d3171d9809b$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
module.exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>(0, module.exports.byteSwap)(n);
// In place byte swap for Uint32Array
function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, module.exports.byteSwap)(arr[i]);
}
module.exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    (0, $dNiq9.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(char) {
    if (char >= $29ee4d3171d9809b$var$asciis._0 && char <= $29ee4d3171d9809b$var$asciis._9) return char - $29ee4d3171d9809b$var$asciis._0;
    if (char >= $29ee4d3171d9809b$var$asciis._A && char <= $29ee4d3171d9809b$var$asciis._F) return char - ($29ee4d3171d9809b$var$asciis._A - 10);
    if (char >= $29ee4d3171d9809b$var$asciis._a && char <= $29ee4d3171d9809b$var$asciis._f) return char - ($29ee4d3171d9809b$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    (0, $dNiq9.bytes)(data);
    return data;
}
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $dNiq9.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === "function") return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("bJNmB", function(module, exports) {
"use strict";

var $bYkMz = parcelRequire("bYkMz");
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $bYkMz.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $bYkMz.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $bYkMz.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("bYkMz", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
const $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});





parcelRegister("bBRJ3", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $873cd33230d94083$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientCommandInterpreter = module.exports.GetMoreElementsCommand = module.exports.GetMerkleLeafIndexCommand = module.exports.GetMerkleLeafProofCommand = module.exports.GetPreimageCommand = module.exports.YieldCommand = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $8rRzQ = parcelRequire("8rRzQ");

var $goh0i = parcelRequire("goh0i");

var $8GOLq = parcelRequire("8GOLq");
var $873cd33230d94083$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($873cd33230d94083$var$ClientCommandCode || ($873cd33230d94083$var$ClientCommandCode = {}));
class $873cd33230d94083$var$ClientCommand {
}
class $873cd33230d94083$var$YieldCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(results, progressCallback){
        super();
        this.progressCallback = progressCallback;
        this.code = $873cd33230d94083$var$ClientCommandCode.YIELD;
        this.results = results;
    }
    execute(request) {
        this.results.push($873cd33230d94083$require$Buffer.from(request.subarray(1)));
        if (this.progressCallback) this.progressCallback();
        return $873cd33230d94083$require$Buffer.from("");
    }
}
module.exports.YieldCommand = $873cd33230d94083$var$YieldCommand;
class $873cd33230d94083$var$GetPreimageCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_preimages, queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_PREIMAGE;
        this.known_preimages = known_preimages;
        this.queue = queue;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        // we expect no more data to read
        if (req.length != 33) throw new Error("Invalid request, unexpected trailing data");
        if (req[0] != 0) throw new Error("Unsupported request, the first byte should be 0");
        // read the hash
        const hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)hash[i] = req[1 + i];
        const req_hash_hex = hash.toString("hex");
        const known_preimage = this.known_preimages.get(req_hash_hex);
        if (known_preimage != undefined) {
            const preimage_len_varint = (0, $8GOLq.createVarint)(known_preimage.length);
            // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
            // the rest will be stored in the queue for GET_MORE_ELEMENTS
            const max_payload_size = 255 - preimage_len_varint.length - 1;
            const payload_size = Math.min(max_payload_size, known_preimage.length);
            if (payload_size < known_preimage.length) for(let i = payload_size; i < known_preimage.length; i++)this.queue.push($873cd33230d94083$require$Buffer.from([
                known_preimage[i]
            ]));
            return $873cd33230d94083$require$Buffer.concat([
                preimage_len_varint,
                $873cd33230d94083$require$Buffer.from([
                    payload_size
                ]),
                $873cd33230d94083$require$Buffer.from(known_preimage.subarray(0, payload_size))
            ]);
        }
        throw Error(`Requested unknown preimage for: ${req_hash_hex}`);
    }
}
module.exports.GetPreimageCommand = $873cd33230d94083$var$GetPreimageCommand;
class $873cd33230d94083$var$GetMerkleLeafProofCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_trees, queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
        this.known_trees = known_trees;
        this.queue = queue;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        if (req.length < 34) throw new Error("Invalid request, expected at least 34 bytes");
        const reqBuf = new $8rRzQ.BufferReader(req);
        const hash = reqBuf.readSlice(32);
        const hash_hex = hash.toString("hex");
        let tree_size;
        let leaf_index;
        try {
            tree_size = (0, $8GOLq.sanitizeBigintToNumber)(reqBuf.readVarInt());
            leaf_index = (0, $8GOLq.sanitizeBigintToNumber)(reqBuf.readVarInt());
        } catch (e) {
            throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
        }
        const mt = this.known_trees.get(hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf proof for unknown tree: ${hash_hex}`);
        if (leaf_index >= tree_size || mt.size() != tree_size) throw Error("Invalid index or tree size.");
        if (this.queue.length != 0) throw Error("This command should not execute when the queue is not empty.");
        const proof = mt.getProof(leaf_index);
        const n_response_elements = Math.min(Math.floor(6.90625), proof.length);
        const n_leftover_elements = proof.length - n_response_elements;
        // Add to the queue any proof elements that do not fit the response
        if (n_leftover_elements > 0) this.queue.push(...proof.slice(-n_leftover_elements));
        return $873cd33230d94083$require$Buffer.concat([
            mt.getLeafHash(leaf_index),
            $873cd33230d94083$require$Buffer.from([
                proof.length
            ]),
            $873cd33230d94083$require$Buffer.from([
                n_response_elements
            ]),
            ...proof.slice(0, n_response_elements)
        ]);
    }
}
module.exports.GetMerkleLeafProofCommand = $873cd33230d94083$var$GetMerkleLeafProofCommand;
class $873cd33230d94083$var$GetMerkleLeafIndexCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_trees){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
        this.known_trees = known_trees;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        if (req.length != 64) throw new Error("Invalid request, unexpected trailing data");
        // read the root hash
        const root_hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
        const root_hash_hex = root_hash.toString("hex");
        // read the leaf hash
        const leef_hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)leef_hash[i] = req.readUInt8(32 + i);
        const leef_hash_hex = leef_hash.toString("hex");
        const mt = this.known_trees.get(root_hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf index for unknown root: ${root_hash_hex}`);
        let leaf_index = 0;
        let found = 0;
        for(let i = 0; i < mt.size(); i++)if (mt.getLeafHash(i).toString("hex") == leef_hash_hex) {
            found = 1;
            leaf_index = i;
            break;
        }
        return $873cd33230d94083$require$Buffer.concat([
            $873cd33230d94083$require$Buffer.from([
                found
            ]),
            (0, $8GOLq.createVarint)(leaf_index)
        ]);
    }
}
module.exports.GetMerkleLeafIndexCommand = $873cd33230d94083$var$GetMerkleLeafIndexCommand;
class $873cd33230d94083$var$GetMoreElementsCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MORE_ELEMENTS;
        this.queue = queue;
    }
    execute(request) {
        if (request.length != 1) throw new Error("Invalid request, unexpected trailing data");
        if (this.queue.length === 0) throw new Error("No elements to get");
        // all elements should have the same length
        const element_len = this.queue[0].length;
        if (this.queue.some((el)=>el.length != element_len)) throw new Error("The queue contains elements with different byte length, which is not expected");
        const max_elements = Math.floor(253 / element_len);
        const n_returned_elements = Math.min(max_elements, this.queue.length);
        const returned_elements = this.queue.splice(0, n_returned_elements);
        return $873cd33230d94083$require$Buffer.concat([
            $873cd33230d94083$require$Buffer.from([
                n_returned_elements
            ]),
            $873cd33230d94083$require$Buffer.from([
                element_len
            ]),
            ...returned_elements
        ]);
    }
}
module.exports.GetMoreElementsCommand = $873cd33230d94083$var$GetMoreElementsCommand;
/**
 * This class will dispatch a client command coming from the hardware device to
 * the appropriate client command implementation. Those client commands
 * typically requests data from a merkle tree or merkelized maps.
 *
 * A ClientCommandInterpreter is prepared by adding the merkle trees and
 * merkelized maps it should be able to serve to the hardware device. This class
 * doesn't know anything about the semantics of the data it holds, it just
 * serves merkle data. It doesn't even know in what context it is being
 * executed, ie SignPsbt, getWalletAddress, etc.
 *
 * If the command yelds results to the client, as signPsbt does, the yielded
 * data will be accessible after the command completed by calling getYielded(),
 * which will return the yields in the same order as they came in.
 */ class $873cd33230d94083$var$ClientCommandInterpreter {
    constructor(progressCallback){
        this.roots = new Map();
        this.preimages = new Map();
        this.yielded = [];
        this.queue = [];
        this.commands = new Map();
        const commands = [
            new $873cd33230d94083$var$YieldCommand(this.yielded, progressCallback),
            new $873cd33230d94083$var$GetPreimageCommand(this.preimages, this.queue),
            new $873cd33230d94083$var$GetMerkleLeafIndexCommand(this.roots),
            new $873cd33230d94083$var$GetMerkleLeafProofCommand(this.roots, this.queue),
            new $873cd33230d94083$var$GetMoreElementsCommand(this.queue)
        ];
        for (const cmd of commands){
            if (this.commands.has(cmd.code)) throw new Error(`Multiple commands with code ${cmd.code}`);
            this.commands.set(cmd.code, cmd);
        }
    }
    getYielded() {
        return this.yielded;
    }
    addKnownPreimage(preimage) {
        this.preimages.set($3wrUl.crypto.sha256(preimage).toString("hex"), preimage);
    }
    addKnownList(elements) {
        for (const el of elements){
            const preimage = $873cd33230d94083$require$Buffer.concat([
                $873cd33230d94083$require$Buffer.from([
                    0
                ]),
                el
            ]);
            this.addKnownPreimage(preimage);
        }
        const mt = new $goh0i.Merkle(elements.map((el)=>(0, $goh0i.hashLeaf)(el)));
        this.roots.set(mt.getRoot().toString("hex"), mt);
    }
    addKnownMapping(mm) {
        this.addKnownList(mm.keys);
        this.addKnownList(mm.values);
    }
    addKnownWalletPolicy(wp) {
        this.addKnownPreimage(wp.serialize());
        this.addKnownList(wp.keys.map((k)=>$873cd33230d94083$require$Buffer.from(k, "ascii")));
        this.addKnownPreimage($873cd33230d94083$require$Buffer.from(wp.descriptorTemplate));
    }
    execute(request) {
        if (request.length == 0) throw new Error("Unexpected empty command");
        const cmdCode = request[0];
        const cmd = this.commands.get(cmdCode);
        if (!cmd) throw new Error(`Unexpected command code ${cmdCode}`);
        return cmd.execute(request);
    }
}
module.exports.ClientCommandInterpreter = $873cd33230d94083$var$ClientCommandInterpreter;

});
parcelRegister("3wrUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initEccLib = module.exports.Transaction = module.exports.opcodes = module.exports.Psbt = module.exports.Block = module.exports.script = module.exports.payments = module.exports.networks = module.exports.crypto = module.exports.address = void 0;

var $d1wHE = parcelRequire("d1wHE");
module.exports.address = $d1wHE;

var $lgTFk = parcelRequire("lgTFk");
module.exports.crypto = $lgTFk;

var $fjh6Q = parcelRequire("fjh6Q");
module.exports.networks = $fjh6Q;

var $j87lX = parcelRequire("j87lX");
module.exports.payments = $j87lX;

var $8wAtk = parcelRequire("8wAtk");
module.exports.script = $8wAtk;

var $huuL7 = parcelRequire("huuL7");
Object.defineProperty(module.exports, "Block", {
    enumerable: true,
    get: function() {
        return $huuL7.Block;
    }
});

var $hXYde = parcelRequire("hXYde");
Object.defineProperty(module.exports, "Psbt", {
    enumerable: true,
    get: function() {
        return $hXYde.Psbt;
    }
});

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, "opcodes", {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $gMJcK = parcelRequire("gMJcK");
Object.defineProperty(module.exports, "Transaction", {
    enumerable: true,
    get: function() {
        return $gMJcK.Transaction;
    }
});

var $f6boC = parcelRequire("f6boC");
Object.defineProperty(module.exports, "initEccLib", {
    enumerable: true,
    get: function() {
        return $f6boC.initEccLib;
    }
});

});
parcelRegister("d1wHE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $97b4bc83495059dc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toOutputScript = module.exports.fromOutputScript = module.exports.toBech32 = module.exports.toBase58Check = module.exports.fromBech32 = module.exports.fromBase58Check = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $db6J2 = parcelRequire("db6J2");

var $lpa1P = parcelRequire("lpa1P");
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE = 40;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION = 16;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF = 0x50;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network) {
    const data = output.slice(2);
    if (data.length < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE || data.length > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) throw new TypeError("Invalid program length for segwit address");
    const version = output[0] - $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF;
    if (version < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION || version > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION) throw new TypeError("Invalid version for segwit address");
    if (output[1] !== data.length) throw new TypeError("Invalid script for segwit address");
    console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
    return $97b4bc83495059dc$var$toBech32(data, version, network.bech32);
}
function $97b4bc83495059dc$var$fromBase58Check(address) {
    const payload = $97b4bc83495059dc$require$Buffer.from($lpa1P.decode(address));
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + " is too short");
    if (payload.length > 21) throw new TypeError(address + " is too long");
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
module.exports.fromBase58Check = $97b4bc83495059dc$var$fromBase58Check;
function $97b4bc83495059dc$var$fromBech32(address) {
    let result;
    let version;
    try {
        result = $db6J2.bech32.decode(address);
    } catch (e) {}
    if (result) {
        version = result.words[0];
        if (version !== 0) throw new TypeError(address + " uses wrong encoding");
    } else {
        result = $db6J2.bech32m.decode(address);
        version = result.words[0];
        if (version === 0) throw new TypeError(address + " uses wrong encoding");
    }
    const data = $db6J2.bech32.fromWords(result.words.slice(1));
    return {
        version: version,
        prefix: result.prefix,
        data: $97b4bc83495059dc$require$Buffer.from(data)
    };
}
module.exports.fromBech32 = $97b4bc83495059dc$var$fromBech32;
function $97b4bc83495059dc$var$toBase58Check(hash, version) {
    (0, $18Mz5.typeforce)((0, $18Mz5.tuple)($18Mz5.Hash160bit, $18Mz5.UInt8), arguments);
    const payload = $97b4bc83495059dc$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $lpa1P.encode(payload);
}
module.exports.toBase58Check = $97b4bc83495059dc$var$toBase58Check;
function $97b4bc83495059dc$var$toBech32(data, version, prefix) {
    const words = $db6J2.bech32.toWords(data);
    words.unshift(version);
    return version === 0 ? $db6J2.bech32.encode(prefix, words) : $db6J2.bech32m.encode(prefix, words);
}
module.exports.toBech32 = $97b4bc83495059dc$var$toBech32;
function $97b4bc83495059dc$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $fjh6Q.bitcoin;
    try {
        return $j87lX.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2tr({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network);
    } catch (e) {}
    throw new Error($8wAtk.toASM(output) + " has no matching Address");
}
module.exports.fromOutputScript = $97b4bc83495059dc$var$fromOutputScript;
function $97b4bc83495059dc$var$toOutputScript(address, network) {
    network = network || $fjh6Q.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $97b4bc83495059dc$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $j87lX.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $j87lX.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $97b4bc83495059dc$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $j87lX.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $j87lX.p2wsh({
                    hash: decodeBech32.data
                }).output;
            } else if (decodeBech32.version === 1) {
                if (decodeBech32.data.length === 32) return $j87lX.p2tr({
                    pubkey: decodeBech32.data
                }).output;
            } else if (decodeBech32.version >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION && decodeBech32.version <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION && decodeBech32.data.length >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE && decodeBech32.data.length <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) {
                console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
                return $8wAtk.compile([
                    decodeBech32.version + $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF,
                    decodeBech32.data
                ]);
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
module.exports.toOutputScript = $97b4bc83495059dc$var$toOutputScript;

});
parcelRegister("fjh6Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.testnet = module.exports.regtest = module.exports.bitcoin = void 0;
module.exports.bitcoin = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
module.exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
module.exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};

});

parcelRegister("j87lX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2tr = module.exports.p2wsh = module.exports.p2wpkh = module.exports.p2sh = module.exports.p2pkh = module.exports.p2pk = module.exports.p2ms = module.exports.embed = void 0;

var $bnRoL = parcelRequire("bnRoL");
Object.defineProperty(module.exports, "embed", {
    enumerable: true,
    get: function() {
        return $bnRoL.p2data;
    }
});

var $c9fEL = parcelRequire("c9fEL");
Object.defineProperty(module.exports, "p2ms", {
    enumerable: true,
    get: function() {
        return $c9fEL.p2ms;
    }
});

var $eSuia = parcelRequire("eSuia");
Object.defineProperty(module.exports, "p2pk", {
    enumerable: true,
    get: function() {
        return $eSuia.p2pk;
    }
});

var $jpa81 = parcelRequire("jpa81");
Object.defineProperty(module.exports, "p2pkh", {
    enumerable: true,
    get: function() {
        return $jpa81.p2pkh;
    }
});

var $4yk7Y = parcelRequire("4yk7Y");
Object.defineProperty(module.exports, "p2sh", {
    enumerable: true,
    get: function() {
        return $4yk7Y.p2sh;
    }
});

var $8P2rG = parcelRequire("8P2rG");
Object.defineProperty(module.exports, "p2wpkh", {
    enumerable: true,
    get: function() {
        return $8P2rG.p2wpkh;
    }
});

var $576Qs = parcelRequire("576Qs");
Object.defineProperty(module.exports, "p2wsh", {
    enumerable: true,
    get: function() {
        return $576Qs.p2wsh;
    }
});

var $bl5DO = parcelRequire("bl5DO");
Object.defineProperty(module.exports, "p2tr", {
    enumerable: true,
    get: function() {
        return $bl5DO.p2tr;
    }
}); // TODO
 // witness commitment

});
parcelRegister("bnRoL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2data = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $849b437e3769f84b$var$OPS = $8wAtk.OPS;
function $849b437e3769f84b$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $849b437e3769f84b$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        data: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "embed",
        network: network
    };
    $4v19v.prop(o, "output", ()=>{
        if (!a.data) return;
        return $8wAtk.compile([
            $849b437e3769f84b$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $4v19v.prop(o, "data", ()=>{
        if (!a.output) return;
        return $8wAtk.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $8wAtk.decompile(a.output);
            if (chunks[0] !== $849b437e3769f84b$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($18Mz5.typeforce.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !$849b437e3769f84b$var$stacksEqual(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2data = $849b437e3769f84b$var$p2data;

});
parcelRegister("8wAtk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $634d9a7855d2b99b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signature = module.exports.number = module.exports.isCanonicalScriptSignature = module.exports.isDefinedHashType = module.exports.isCanonicalPubKey = module.exports.toStack = module.exports.fromASM = module.exports.toASM = module.exports.decompile = module.exports.compile = module.exports.countNonPushOnlyOPs = module.exports.isPushOnly = module.exports.OPS = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, "OPS", {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $dX1I0 = parcelRequire("dX1I0");

var $1mhXk = parcelRequire("1mhXk");

var $loONM = parcelRequire("loONM");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $634d9a7855d2b99b$var$typeforce } = $18Mz5;
const $634d9a7855d2b99b$var$OP_INT_BASE = $l0in9.OPS.OP_RESERVED; // OP_1 - 1
function $634d9a7855d2b99b$var$isOPInt(value) {
    return $18Mz5.Number(value) && (value === $l0in9.OPS.OP_0 || value >= $l0in9.OPS.OP_1 && value <= $l0in9.OPS.OP_16 || value === $l0in9.OPS.OP_1NEGATE);
}
function $634d9a7855d2b99b$var$isPushOnlyChunk(value) {
    return $18Mz5.Buffer(value) || $634d9a7855d2b99b$var$isOPInt(value);
}
function $634d9a7855d2b99b$var$isPushOnly(value) {
    return $18Mz5.Array(value) && value.every($634d9a7855d2b99b$var$isPushOnlyChunk);
}
module.exports.isPushOnly = $634d9a7855d2b99b$var$isPushOnly;
function $634d9a7855d2b99b$var$countNonPushOnlyOPs(value) {
    return value.length - value.filter($634d9a7855d2b99b$var$isPushOnlyChunk).length;
}
module.exports.countNonPushOnlyOPs = $634d9a7855d2b99b$var$countNonPushOnlyOPs;
function $634d9a7855d2b99b$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $l0in9.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $634d9a7855d2b99b$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $l0in9.OPS.OP_1NEGATE;
}
function $634d9a7855d2b99b$var$chunksIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
function $634d9a7855d2b99b$var$chunksIsArray(buf) {
    return $18Mz5.Array(buf);
}
function $634d9a7855d2b99b$var$singleChunkIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
function $634d9a7855d2b99b$var$compile(chunks) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) return chunks;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $634d9a7855d2b99b$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $dX1I0.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $634d9a7855d2b99b$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $dX1I0.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
module.exports.compile = $634d9a7855d2b99b$var$compile;
function $634d9a7855d2b99b$var$decompile(buffer) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsArray(buffer)) return buffer;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $l0in9.OPS.OP_0 && opcode <= $l0in9.OPS.OP_PUSHDATA4) {
            const d = $dX1I0.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $634d9a7855d2b99b$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
module.exports.decompile = $634d9a7855d2b99b$var$decompile;
function $634d9a7855d2b99b$var$toASM(chunks) {
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) chunks = $634d9a7855d2b99b$var$decompile(chunks);
    return chunks.map((chunk)=>{
        // data?
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            const op = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $l0in9.REVERSE_OPS[chunk];
    }).join(" ");
}
module.exports.toASM = $634d9a7855d2b99b$var$toASM;
function $634d9a7855d2b99b$var$fromASM(asm) {
    $634d9a7855d2b99b$var$typeforce($18Mz5.String, asm);
    return $634d9a7855d2b99b$var$compile(asm.split(" ").map((chunkStr)=>{
        // opcode?
        if ($l0in9.OPS[chunkStr] !== undefined) return $l0in9.OPS[chunkStr];
        $634d9a7855d2b99b$var$typeforce($18Mz5.Hex, chunkStr);
        // data!
        return $634d9a7855d2b99b$require$Buffer.from(chunkStr, "hex");
    }));
}
module.exports.fromASM = $634d9a7855d2b99b$var$fromASM;
function $634d9a7855d2b99b$var$toStack(chunks) {
    chunks = $634d9a7855d2b99b$var$decompile(chunks);
    $634d9a7855d2b99b$var$typeforce($634d9a7855d2b99b$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(op)) return op;
        if (op === $l0in9.OPS.OP_0) return $634d9a7855d2b99b$require$Buffer.allocUnsafe(0);
        return $1mhXk.encode(op - $634d9a7855d2b99b$var$OP_INT_BASE);
    });
}
module.exports.toStack = $634d9a7855d2b99b$var$toStack;
function $634d9a7855d2b99b$var$isCanonicalPubKey(buffer) {
    return $18Mz5.isPoint(buffer);
}
module.exports.isCanonicalPubKey = $634d9a7855d2b99b$var$isCanonicalPubKey;
function $634d9a7855d2b99b$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
module.exports.isDefinedHashType = $634d9a7855d2b99b$var$isDefinedHashType;
function $634d9a7855d2b99b$var$isCanonicalScriptSignature(buffer) {
    if (!$634d9a7855d2b99b$require$Buffer.isBuffer(buffer)) return false;
    if (!$634d9a7855d2b99b$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $gDdvx.check(buffer.slice(0, -1));
}
module.exports.isCanonicalScriptSignature = $634d9a7855d2b99b$var$isCanonicalScriptSignature;
module.exports.number = $1mhXk;
module.exports.signature = $loONM;

});
parcelRegister("gDdvx", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c1bac437d9c5804f$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = module.exports.check = void 0;
function $c1bac437d9c5804f$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    const lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    const lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
module.exports.check = $c1bac437d9c5804f$var$check;
function $c1bac437d9c5804f$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    const lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    const lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
module.exports.decode = $c1bac437d9c5804f$var$decode;
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
 */ function $c1bac437d9c5804f$var$encode(r, s) {
    const lenR = r.length;
    const lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    const signature = $c1bac437d9c5804f$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
module.exports.encode = $c1bac437d9c5804f$var$encode;

});

parcelRegister("l0in9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REVERSE_OPS = module.exports.OPS = void 0;
const $f4a7d973a6629c90$var$OPS = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
};
module.exports.OPS = $f4a7d973a6629c90$var$OPS;
const $f4a7d973a6629c90$var$REVERSE_OPS = {};
module.exports.REVERSE_OPS = $f4a7d973a6629c90$var$REVERSE_OPS;
for (const op of Object.keys($f4a7d973a6629c90$var$OPS)){
    const code = $f4a7d973a6629c90$var$OPS[op];
    $f4a7d973a6629c90$var$REVERSE_OPS[code] = op;
}

});

parcelRegister("dX1I0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decode = module.exports.encode = module.exports.encodingLength = void 0;

var $l0in9 = parcelRequire("l0in9");
function $a2821c5ffe705947$var$encodingLength(i) {
    return i < $l0in9.OPS.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
module.exports.encodingLength = $a2821c5ffe705947$var$encodingLength;
function $a2821c5ffe705947$var$encode(buffer, num, offset) {
    const size = $a2821c5ffe705947$var$encodingLength(num);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(num, offset);
    else if (size === 2) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA1, offset);
        buffer.writeUInt8(num, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(num, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(num, offset + 1);
    }
    return size;
}
module.exports.encode = $a2821c5ffe705947$var$encode;
function $a2821c5ffe705947$var$decode(buffer, offset) {
    const opcode = buffer.readUInt8(offset);
    let num;
    let size;
    // ~6 bit
    if (opcode < $l0in9.OPS.OP_PUSHDATA1) {
        num = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        num = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        num = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $l0in9.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        num = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: num,
        size: size
    };
}
module.exports.decode = $a2821c5ffe705947$var$decode;

});

parcelRegister("1mhXk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0fd5c63598aa1719$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = void 0;
function $0fd5c63598aa1719$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
module.exports.decode = $0fd5c63598aa1719$var$decode;
function $0fd5c63598aa1719$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $0fd5c63598aa1719$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $0fd5c63598aa1719$var$scriptNumSize(value);
    const buffer = $0fd5c63598aa1719$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
module.exports.encode = $0fd5c63598aa1719$var$encode;

});

parcelRegister("loONM", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f9433f0a843bc51f$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $f9433f0a843bc51f$var$typeforce } = $18Mz5;
const $f9433f0a843bc51f$var$ZERO = $f9433f0a843bc51f$require$Buffer.alloc(1, 0);
function $f9433f0a843bc51f$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $f9433f0a843bc51f$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $f9433f0a843bc51f$require$Buffer.concat([
        $f9433f0a843bc51f$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $f9433f0a843bc51f$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $f9433f0a843bc51f$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $f9433f0a843bc51f$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const decoded = $gDdvx.decode(buffer.slice(0, -1));
    const r = $f9433f0a843bc51f$var$fromDER(decoded.r);
    const s = $f9433f0a843bc51f$var$fromDER(decoded.s);
    const signature = $f9433f0a843bc51f$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
module.exports.decode = $f9433f0a843bc51f$var$decode;
function $f9433f0a843bc51f$var$encode(signature, hashType) {
    $f9433f0a843bc51f$var$typeforce({
        signature: $18Mz5.BufferN(64),
        hashType: $18Mz5.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const hashTypeBuffer = $f9433f0a843bc51f$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $f9433f0a843bc51f$var$toDER(signature.slice(0, 32));
    const s = $f9433f0a843bc51f$var$toDER(signature.slice(32, 64));
    return $f9433f0a843bc51f$require$Buffer.concat([
        $gDdvx.encode(r, s),
        hashTypeBuffer
    ]);
}
module.exports.encode = $f9433f0a843bc51f$var$encode;

});
parcelRegister("18Mz5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oneOf = module.exports.Null = module.exports.BufferN = module.exports.Function = module.exports.UInt32 = module.exports.UInt8 = module.exports.tuple = module.exports.maybe = module.exports.Hex = module.exports.Buffer = module.exports.String = module.exports.Boolean = module.exports.Array = module.exports.Number = module.exports.Hash256bit = module.exports.Hash160bit = module.exports.Buffer256bit = module.exports.isTaptree = module.exports.isTapleaf = module.exports.TAPLEAF_VERSION_MASK = module.exports.Network = module.exports.ECPoint = module.exports.Satoshi = module.exports.Signer = module.exports.BIP32Path = module.exports.UInt31 = module.exports.isPoint = module.exports.typeforce = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

module.exports.typeforce = (parcelRequire("lYlyf"));
const $0d4c35ca8ad6fd29$var$ZERO32 = $6ZWSX.Buffer.alloc(32, 0);
const $0d4c35ca8ad6fd29$var$EC_P = $6ZWSX.Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
function $0d4c35ca8ad6fd29$var$isPoint(p) {
    if (!$6ZWSX.Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (x.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) return true;
    const y = p.slice(33);
    if (y.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (y.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
module.exports.isPoint = $0d4c35ca8ad6fd29$var$isPoint;
const $0d4c35ca8ad6fd29$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $0d4c35ca8ad6fd29$var$UInt31(value) {
    return module.exports.typeforce.UInt32(value) && value <= $0d4c35ca8ad6fd29$var$UINT31_MAX;
}
module.exports.UInt31 = $0d4c35ca8ad6fd29$var$UInt31;
function $0d4c35ca8ad6fd29$var$BIP32Path(value) {
    return module.exports.typeforce.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
module.exports.BIP32Path = $0d4c35ca8ad6fd29$var$BIP32Path;
$0d4c35ca8ad6fd29$var$BIP32Path.toJSON = ()=>{
    return "BIP32 derivation path";
};
function $0d4c35ca8ad6fd29$var$Signer(obj) {
    return (module.exports.typeforce.Buffer(obj.publicKey) || typeof obj.getPublicKey === "function") && typeof obj.sign === "function";
}
module.exports.Signer = $0d4c35ca8ad6fd29$var$Signer;
const $0d4c35ca8ad6fd29$var$SATOSHI_MAX = 21 * 1e14;
function $0d4c35ca8ad6fd29$var$Satoshi(value) {
    return module.exports.typeforce.UInt53(value) && value <= $0d4c35ca8ad6fd29$var$SATOSHI_MAX;
}
module.exports.Satoshi = $0d4c35ca8ad6fd29$var$Satoshi;
// external dependent types
module.exports.ECPoint = module.exports.typeforce.quacksLike("Point");
// exposed, external API
module.exports.Network = module.exports.typeforce.compile({
    messagePrefix: module.exports.typeforce.oneOf(module.exports.typeforce.Buffer, module.exports.typeforce.String),
    bip32: {
        public: module.exports.typeforce.UInt32,
        private: module.exports.typeforce.UInt32
    },
    pubKeyHash: module.exports.typeforce.UInt8,
    scriptHash: module.exports.typeforce.UInt8,
    wif: module.exports.typeforce.UInt8
});
module.exports.TAPLEAF_VERSION_MASK = 0xfe;
function $0d4c35ca8ad6fd29$var$isTapleaf(o) {
    if (!o || !("output" in o)) return false;
    if (!$6ZWSX.Buffer.isBuffer(o.output)) return false;
    if (o.version !== undefined) return (o.version & module.exports.TAPLEAF_VERSION_MASK) === o.version;
    return true;
}
module.exports.isTapleaf = $0d4c35ca8ad6fd29$var$isTapleaf;
function $0d4c35ca8ad6fd29$var$isTaptree(scriptTree) {
    if (!(0, module.exports.Array)(scriptTree)) return $0d4c35ca8ad6fd29$var$isTapleaf(scriptTree);
    if (scriptTree.length !== 2) return false;
    return scriptTree.every((t)=>$0d4c35ca8ad6fd29$var$isTaptree(t));
}
module.exports.isTaptree = $0d4c35ca8ad6fd29$var$isTaptree;
module.exports.Buffer256bit = module.exports.typeforce.BufferN(32);
module.exports.Hash160bit = module.exports.typeforce.BufferN(20);
module.exports.Hash256bit = module.exports.typeforce.BufferN(32);
module.exports.Number = module.exports.typeforce.Number;
module.exports.Array = module.exports.typeforce.Array;
module.exports.Boolean = module.exports.typeforce.Boolean;
module.exports.String = module.exports.typeforce.String;
module.exports.Buffer = module.exports.typeforce.Buffer;
module.exports.Hex = module.exports.typeforce.Hex;
module.exports.maybe = module.exports.typeforce.maybe;
module.exports.tuple = module.exports.typeforce.tuple;
module.exports.UInt8 = module.exports.typeforce.UInt8;
module.exports.UInt32 = module.exports.typeforce.UInt32;
module.exports.Function = module.exports.typeforce.Function;
module.exports.BufferN = module.exports.typeforce.BufferN;
module.exports.Null = module.exports.typeforce.Null;
module.exports.oneOf = module.exports.typeforce.oneOf;

});
parcelRegister("lYlyf", function(module, exports) {

var $akIbT = parcelRequire("akIbT");

var $heKts = parcelRequire("heKts");
// short-hand
var $ffefeb359bffb323$var$tfJSON = $akIbT.tfJSON;
var $ffefeb359bffb323$var$TfTypeError = $akIbT.TfTypeError;
var $ffefeb359bffb323$var$TfPropertyTypeError = $akIbT.TfPropertyTypeError;
var $ffefeb359bffb323$var$tfSubError = $akIbT.tfSubError;
var $ffefeb359bffb323$var$getValueTypeName = $akIbT.getValueTypeName;
var $ffefeb359bffb323$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $ffefeb359bffb323$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$heKts.Array(array)) return false;
            if ($heKts.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $ffefeb359bffb323$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $ffefeb359bffb323$var$compile(type);
        function _maybe(value, strict) {
            return $heKts.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $ffefeb359bffb323$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $ffefeb359bffb323$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $ffefeb359bffb323$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $ffefeb359bffb323$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $ffefeb359bffb323$var$tfJSON(propertyKeyType) + ": " + $ffefeb359bffb323$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $ffefeb359bffb323$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $ffefeb359bffb323$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $ffefeb359bffb323$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $ffefeb359bffb323$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $ffefeb359bffb323$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _tuple(values, strict) {
            if ($heKts.Nil(values)) return false;
            if ($heKts.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($ffefeb359bffb323$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$ffefeb359bffb323$var$TYPES.oneOf = $ffefeb359bffb323$var$TYPES.anyOf;
function $ffefeb359bffb323$var$compile(type) {
    if ($heKts.String(type)) {
        if (type[0] === "?") return $ffefeb359bffb323$var$TYPES.maybe(type.slice(1));
        return $heKts[type] || $ffefeb359bffb323$var$TYPES.quacksLike(type);
    } else if (type && $heKts.Object(type)) {
        if ($heKts.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $ffefeb359bffb323$var$TYPES.arrayOf(type[0]);
        }
        return $ffefeb359bffb323$var$TYPES.object(type);
    } else if ($heKts.Function(type)) return type;
    return $ffefeb359bffb323$var$TYPES.value(type);
}
function $ffefeb359bffb323$var$typeforce(type, value, strict, surrogate) {
    if ($heKts.Function(type)) {
        if (type(value, strict)) return true;
        throw new $ffefeb359bffb323$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $ffefeb359bffb323$var$typeforce($ffefeb359bffb323$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $ffefeb359bffb323$var$typeName in $heKts)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $heKts[$ffefeb359bffb323$var$typeName];
for($ffefeb359bffb323$var$typeName in $ffefeb359bffb323$var$TYPES)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $ffefeb359bffb323$var$TYPES[$ffefeb359bffb323$var$typeName];

var $8tZX5 = parcelRequire("8tZX5");
for($ffefeb359bffb323$var$typeName in $8tZX5)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $8tZX5[$ffefeb359bffb323$var$typeName];
$ffefeb359bffb323$var$typeforce.compile = $ffefeb359bffb323$var$compile;
$ffefeb359bffb323$var$typeforce.TfTypeError = $ffefeb359bffb323$var$TfTypeError;
$ffefeb359bffb323$var$typeforce.TfPropertyTypeError = $ffefeb359bffb323$var$TfPropertyTypeError;
module.exports = $ffefeb359bffb323$var$typeforce;

});
parcelRegister("akIbT", function(module, exports) {

var $heKts = parcelRequire("heKts");
function $785e0cfecbfb7b1d$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $785e0cfecbfb7b1d$var$getValueTypeName(value) {
    return $heKts.Nil(value) ? "" : $785e0cfecbfb7b1d$var$getTypeName(value.constructor);
}
function $785e0cfecbfb7b1d$var$getValue(value) {
    if ($heKts.Function(value)) return "";
    if ($heKts.String(value)) return JSON.stringify(value);
    if (value && $heKts.Object(value)) return "";
    return value;
}
function $785e0cfecbfb7b1d$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $785e0cfecbfb7b1d$var$tfJSON(type) {
    if ($heKts.Function(type)) return type.toJSON ? type.toJSON() : $785e0cfecbfb7b1d$var$getTypeName(type);
    if ($heKts.Array(type)) return "Array";
    if (type && $heKts.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $785e0cfecbfb7b1d$var$getValue(value);
    return "Expected " + $785e0cfecbfb7b1d$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $785e0cfecbfb7b1d$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
    this.message = $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $785e0cfecbfb7b1d$var$tfErrorString('property "' + $785e0cfecbfb7b1d$var$tfJSON(name) + description + $785e0cfecbfb7b1d$var$tfJSON(type), value, valueTypeName);
}
function $785e0cfecbfb7b1d$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
        this.message = $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfCustomError(expected, actual) {
    return new $785e0cfecbfb7b1d$var$TfTypeError(expected, {}, actual);
}
function $785e0cfecbfb7b1d$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $785e0cfecbfb7b1d$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $785e0cfecbfb7b1d$var$TfTypeError) e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $785e0cfecbfb7b1d$var$TfTypeError,
    TfPropertyTypeError: $785e0cfecbfb7b1d$var$TfPropertyTypeError,
    tfCustomError: $785e0cfecbfb7b1d$var$tfCustomError,
    tfSubError: $785e0cfecbfb7b1d$var$tfSubError,
    tfJSON: $785e0cfecbfb7b1d$var$tfJSON,
    getValueTypeName: $785e0cfecbfb7b1d$var$getValueTypeName
};

});
parcelRegister("heKts", function(module, exports) {
var $c8c7cb41b203218a$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$c8c7cb41b203218a$var$types.Null = $c8c7cb41b203218a$var$types.Nil;
for(var $c8c7cb41b203218a$var$typeName in $c8c7cb41b203218a$var$types)$c8c7cb41b203218a$var$types[$c8c7cb41b203218a$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $c8c7cb41b203218a$var$typeName);
module.exports = $c8c7cb41b203218a$var$types;

});


parcelRegister("8tZX5", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $62d11690565d87ea$require$Buffer = $6ZWSX.Buffer;

var $heKts = parcelRequire("heKts");

var $akIbT = parcelRequire("akIbT");
function $62d11690565d87ea$var$_Buffer(value) {
    return $62d11690565d87ea$require$Buffer.isBuffer(value);
}
function $62d11690565d87ea$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $62d11690565d87ea$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $akIbT.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $62d11690565d87ea$var$_ArrayN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.Array);
var $62d11690565d87ea$var$_BufferN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$_Buffer);
var $62d11690565d87ea$var$_HexN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$Hex);
var $62d11690565d87ea$var$_StringN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.String);
function $62d11690565d87ea$var$Range(a, b, f) {
    f = f || $heKts.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $62d11690565d87ea$var$INT53_MAX = Math.pow(2, 53) - 1;
function $62d11690565d87ea$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $62d11690565d87ea$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $62d11690565d87ea$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $62d11690565d87ea$var$Int32(value) {
    return (value | 0) === value;
}
function $62d11690565d87ea$var$Int53(value) {
    return typeof value === "number" && value >= -$62d11690565d87ea$var$INT53_MAX && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
function $62d11690565d87ea$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $62d11690565d87ea$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $62d11690565d87ea$var$UInt32(value) {
    return value >>> 0 === value;
}
function $62d11690565d87ea$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
var $62d11690565d87ea$var$types = {
    ArrayN: $62d11690565d87ea$var$_ArrayN,
    Buffer: $62d11690565d87ea$var$_Buffer,
    BufferN: $62d11690565d87ea$var$_BufferN,
    Finite: $62d11690565d87ea$var$Finite,
    Hex: $62d11690565d87ea$var$Hex,
    HexN: $62d11690565d87ea$var$_HexN,
    Int8: $62d11690565d87ea$var$Int8,
    Int16: $62d11690565d87ea$var$Int16,
    Int32: $62d11690565d87ea$var$Int32,
    Int53: $62d11690565d87ea$var$Int53,
    Range: $62d11690565d87ea$var$Range,
    StringN: $62d11690565d87ea$var$_StringN,
    UInt8: $62d11690565d87ea$var$UInt8,
    UInt16: $62d11690565d87ea$var$UInt16,
    UInt32: $62d11690565d87ea$var$UInt32,
    UInt53: $62d11690565d87ea$var$UInt53
};
for(var $62d11690565d87ea$var$typeName in $62d11690565d87ea$var$types)$62d11690565d87ea$var$types[$62d11690565d87ea$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $62d11690565d87ea$var$typeName);
module.exports = $62d11690565d87ea$var$types;

});





parcelRegister("4v19v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.value = module.exports.prop = void 0;
function $346af381949c93ee$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
module.exports.prop = $346af381949c93ee$var$prop;
function $346af381949c93ee$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
module.exports.value = $346af381949c93ee$var$value;

});


parcelRegister("c9fEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2ms = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $8d82785ca490385e$var$OPS = $8wAtk.OPS;
const $8d82785ca490385e$var$OP_INT_BASE = $8d82785ca490385e$var$OPS.OP_RESERVED; // OP_1 - 1
function $8d82785ca490385e$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $8d82785ca490385e$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $8wAtk.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $8d82785ca490385e$var$OPS.OP_0) !== undefined;
    }
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        m: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        n: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkeys: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.isPoint)),
        signatures: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf(isAcceptableSignature)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $8wAtk.decompile(output);
        o.m = chunks[0] - $8d82785ca490385e$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $8d82785ca490385e$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $4v19v.prop(o, "output", ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $8wAtk.compile([].concat($8d82785ca490385e$var$OP_INT_BASE + a.m, a.pubkeys, $8d82785ca490385e$var$OP_INT_BASE + o.n, $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG));
    });
    $4v19v.prop(o, "m", ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $4v19v.prop(o, "n", ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $4v19v.prop(o, "pubkeys", ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $4v19v.prop(o, "signatures", ()=>{
        if (!a.input) return;
        return $8wAtk.decompile(a.input).slice(1);
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.signatures) return;
        return $8wAtk.compile([
            $8d82785ca490385e$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    $4v19v.prop(o, "name", ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$18Mz5.typeforce.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$18Mz5.typeforce.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every((x)=>(0, $18Mz5.isPoint)(x))) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !$8d82785ca490385e$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $8d82785ca490385e$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !$8d82785ca490385e$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2ms = $8d82785ca490385e$var$p2ms;

});

parcelRegister("eSuia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2pk = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $ad4d9b2ec8e5b9d4$var$OPS = $8wAtk.OPS;
// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $ad4d9b2ec8e5b9d4$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2pk",
        network: network
    };
    $4v19v.prop(o, "output", ()=>{
        if (!a.pubkey) return;
        return $8wAtk.compile([
            a.pubkey,
            $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature
        ]);
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!(0, $18Mz5.isPoint)(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pk = $ad4d9b2ec8e5b9d4$var$p2pk;

});

parcelRegister("jpa81", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e20835639c8773b0$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2pkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $lpa1P = parcelRequire("lpa1P");
const $e20835639c8773b0$var$OPS = $8wAtk.OPS;
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $e20835639c8773b0$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(25)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _address = $4v19v.value(()=>{
        const payload = $e20835639c8773b0$require$Buffer.from($lpa1P.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2pkh",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $e20835639c8773b0$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $e20835639c8773b0$var$OPS.OP_DUP,
            $e20835639c8773b0$var$OPS.OP_HASH160,
            o.hash,
            $e20835639c8773b0$var$OPS.OP_EQUALVERIFY,
            $e20835639c8773b0$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $e20835639c8773b0$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $e20835639c8773b0$var$OPS.OP_DUP || a.output[1] !== $e20835639c8773b0$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $e20835639c8773b0$var$OPS.OP_EQUALVERIFY || a.output[24] !== $e20835639c8773b0$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!(0, $18Mz5.isPoint)(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $lgTFk.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pkh = $e20835639c8773b0$var$p2pkh;

});
parcelRegister("lgTFk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f7c6459ce559cfe9$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.taggedHash = module.exports.TAGGED_HASH_PREFIXES = module.exports.TAGS = module.exports.hash256 = module.exports.hash160 = module.exports.sha256 = module.exports.sha1 = module.exports.ripemd160 = void 0;

var $j5xzM = parcelRequire("j5xzM");

var $dGR9X = parcelRequire("dGR9X");

var $6XnWx = parcelRequire("6XnWx");
function $f7c6459ce559cfe9$var$ripemd160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)(Uint8Array.from(buffer)));
}
module.exports.ripemd160 = $f7c6459ce559cfe9$var$ripemd160;
function $f7c6459ce559cfe9$var$sha1(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $dGR9X.sha1)(Uint8Array.from(buffer)));
}
module.exports.sha1 = $f7c6459ce559cfe9$var$sha1;
function $f7c6459ce559cfe9$var$sha256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)(Uint8Array.from(buffer)));
}
module.exports.sha256 = $f7c6459ce559cfe9$var$sha256;
function $f7c6459ce559cfe9$var$hash160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash160 = $f7c6459ce559cfe9$var$hash160;
function $f7c6459ce559cfe9$var$hash256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash256 = $f7c6459ce559cfe9$var$hash256;
module.exports.TAGS = [
    "BIP0340/challenge",
    "BIP0340/aux",
    "BIP0340/nonce",
    "TapLeaf",
    "TapBranch",
    "TapSighash",
    "TapTweak",
    "KeyAgg list",
    "KeyAgg coefficient"
];
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ module.exports.TAGGED_HASH_PREFIXES = {
    "BIP0340/challenge": $f7c6459ce559cfe9$require$Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
    ]),
    "BIP0340/aux": $f7c6459ce559cfe9$require$Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
    ]),
    "BIP0340/nonce": $f7c6459ce559cfe9$require$Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
    ]),
    TapLeaf: $f7c6459ce559cfe9$require$Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
    ]),
    TapBranch: $f7c6459ce559cfe9$require$Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
    ]),
    TapSighash: $f7c6459ce559cfe9$require$Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
    ]),
    TapTweak: $f7c6459ce559cfe9$require$Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
    ]),
    "KeyAgg list": $f7c6459ce559cfe9$require$Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
    ]),
    "KeyAgg coefficient": $f7c6459ce559cfe9$require$Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
    ])
};
function $f7c6459ce559cfe9$var$taggedHash(prefix, data) {
    return $f7c6459ce559cfe9$var$sha256($f7c6459ce559cfe9$require$Buffer.concat([
        module.exports.TAGGED_HASH_PREFIXES[prefix],
        data
    ]));
}
module.exports.taggedHash = $f7c6459ce559cfe9$var$taggedHash;

});
parcelRegister("j5xzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $de58877bbb165fd5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((_, i)=>i));
const $de58877bbb165fd5$var$Pi = /* @__PURE__ */ $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = /* @__PURE__ */ $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = /* @__PURE__ */ $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $3Bcdj.rotl)(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$R_BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $3Bcdj.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $3Bcdj.rotl)(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$R_BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $3Bcdj.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$R_BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $3Bcdj.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());

});

parcelRegister("dGR9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha1 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA1 (RFC 3174) was cryptographically broken. It's still used. Don't use it for a new protocol.
// Initial state
const $9f786f0150d7e2f4$var$SHA1_IV = /* @__PURE__ */ new Uint32Array([
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
    0xc3d2e1f0
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $9f786f0150d7e2f4$var$SHA1_W = /* @__PURE__ */ new Uint32Array(80);
class $9f786f0150d7e2f4$var$SHA1 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, false);
        this.A = $9f786f0150d7e2f4$var$SHA1_IV[0] | 0;
        this.B = $9f786f0150d7e2f4$var$SHA1_IV[1] | 0;
        this.C = $9f786f0150d7e2f4$var$SHA1_IV[2] | 0;
        this.D = $9f786f0150d7e2f4$var$SHA1_IV[3] | 0;
        this.E = $9f786f0150d7e2f4$var$SHA1_IV[4] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E } = this;
        return [
            A,
            B,
            C,
            D,
            E
        ];
    }
    set(A, B, C, D, E) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$9f786f0150d7e2f4$var$SHA1_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 80; i++)$9f786f0150d7e2f4$var$SHA1_W[i] = (0, $3Bcdj.rotl)($9f786f0150d7e2f4$var$SHA1_W[i - 3] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 8] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 14] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 16], 1);
        // Compression function main loop, 80 rounds
        let { A: A, B: B, C: C, D: D, E: E } = this;
        for(let i = 0; i < 80; i++){
            let F, K;
            if (i < 20) {
                F = (0, $iYRTw.Chi)(B, C, D);
                K = 0x5a827999;
            } else if (i < 40) {
                F = B ^ C ^ D;
                K = 0x6ed9eba1;
            } else if (i < 60) {
                F = (0, $iYRTw.Maj)(B, C, D);
                K = 0x8f1bbcdc;
            } else {
                F = B ^ C ^ D;
                K = 0xca62c1d6;
            }
            const T = (0, $3Bcdj.rotl)(A, 5) + F + E + K + $9f786f0150d7e2f4$var$SHA1_W[i] | 0;
            E = D;
            D = C;
            C = (0, $3Bcdj.rotl)(B, 30);
            B = A;
            A = T;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        this.set(A, B, C, D, E);
    }
    roundClean() {
        $9f786f0150d7e2f4$var$SHA1_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.sha1 = (0, $3Bcdj.wrapConstructor)(()=>new $9f786f0150d7e2f4$var$SHA1());

});



parcelRegister("4yk7Y", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3509f34e0538f818$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2sh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $lpa1P = parcelRequire("lpa1P");
const $3509f34e0538f818$var$OPS = $8wAtk.OPS;
function $3509f34e0538f818$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $3509f34e0538f818$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(23)),
        redeem: $18Mz5.typeforce.maybe({
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    const _address = $4v19v.value(()=>{
        const payload = $3509f34e0538f818$require$Buffer.from($lpa1P.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const _redeem = $4v19v.value(()=>{
        const chunks = _chunks();
        const lastChunk = chunks[chunks.length - 1];
        return {
            network: network,
            output: lastChunk === $3509f34e0538f818$var$OPS.OP_FALSE ? $3509f34e0538f818$require$Buffer.from([]) : lastChunk,
            input: $8wAtk.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $3509f34e0538f818$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $4v19v.prop(o, "hash", ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $lgTFk.hash160(o.redeem.output);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3509f34e0538f818$var$OPS.OP_HASH160,
            o.hash,
            $3509f34e0538f818$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $4v19v.prop(o, "redeem", ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $8wAtk.compile([].concat($8wAtk.decompile(a.redeem.input), a.redeem.output));
    });
    $4v19v.prop(o, "witness", ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $4v19v.prop(o, "name", ()=>{
        const nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        let hash = $3509f34e0538f818$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $3509f34e0538f818$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $3509f34e0538f818$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $8wAtk.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                if (redeem.output.byteLength > 520) throw new TypeError("Redeem.output unspendable if larger than 520 bytes");
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                const hash2 = $lgTFk.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    const richunks = $8wAtk.decompile(redeem.input);
                    if (!$8wAtk.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$3509f34e0538f818$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$3509f34e0538f818$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2sh = $3509f34e0538f818$var$p2sh;

});

parcelRegister("8P2rG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $66c4fbcaba3cf164$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2wpkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $66c4fbcaba3cf164$var$OPS = $8wAtk.OPS;
const $66c4fbcaba3cf164$var$EMPTY_BUFFER = $66c4fbcaba3cf164$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $66c4fbcaba3cf164$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(22)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $66c4fbcaba3cf164$require$Buffer.from(data)
        };
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2wpkh",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $66c4fbcaba3cf164$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $66c4fbcaba3cf164$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $66c4fbcaba3cf164$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $66c4fbcaba3cf164$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!(0, $18Mz5.isPoint)(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!(0, $18Mz5.isPoint)(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $lgTFk.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wpkh = $66c4fbcaba3cf164$var$p2wpkh;

});
parcelRegister("db6J2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bech32m = module.exports.bech32 = void 0;
const $998184fe7eff6e26$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
const $998184fe7eff6e26$var$ALPHABET_MAP = {};
for(let z = 0; z < $998184fe7eff6e26$var$ALPHABET.length; z++){
    const x = $998184fe7eff6e26$var$ALPHABET.charAt(z);
    $998184fe7eff6e26$var$ALPHABET_MAP[x] = z;
}
function $998184fe7eff6e26$var$polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $998184fe7eff6e26$var$prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $998184fe7eff6e26$var$polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $998184fe7eff6e26$var$convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $998184fe7eff6e26$var$toWords(bytes) {
    return $998184fe7eff6e26$var$convert(bytes, 8, 5, true);
}
function $998184fe7eff6e26$var$fromWordsUnsafe(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $998184fe7eff6e26$var$fromWords(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $998184fe7eff6e26$var$getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        let result = prefix + "1";
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ x;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = $998184fe7eff6e26$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        const split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = $998184fe7eff6e26$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $998184fe7eff6e26$var$toWords,
        fromWordsUnsafe: $998184fe7eff6e26$var$fromWordsUnsafe,
        fromWords: $998184fe7eff6e26$var$fromWords
    };
}
module.exports.bech32 = $998184fe7eff6e26$var$getLibraryFromEncoding("bech32");
module.exports.bech32m = $998184fe7eff6e26$var$getLibraryFromEncoding("bech32m");

});


parcelRegister("576Qs", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3b92ea7f46896519$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2wsh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $3b92ea7f46896519$var$OPS = $8wAtk.OPS;
const $3b92ea7f46896519$var$EMPTY_BUFFER = $3b92ea7f46896519$require$Buffer.alloc(0);
function $3b92ea7f46896519$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
function $3b92ea7f46896519$var$chunkHasUncompressedPubkey(chunk) {
    if ($3b92ea7f46896519$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && (0, $18Mz5.isPoint)(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $3b92ea7f46896519$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        redeem: $18Mz5.typeforce.maybe({
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $3b92ea7f46896519$require$Buffer.from(data)
        };
    });
    const _rchunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $lgTFk.sha256(o.redeem.output);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3b92ea7f46896519$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, "redeem", ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $3b92ea7f46896519$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $4v19v.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $3b92ea7f46896519$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, "witness", ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $8wAtk.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $3b92ea7f46896519$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $4v19v.prop(o, "name", ()=>{
        const nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        let hash = $3b92ea7f46896519$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $3b92ea7f46896519$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty/valid?
            if (a.redeem.output) {
                const decompile = $8wAtk.decompile(a.redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output is invalid");
                if (a.redeem.output.byteLength > 3600) throw new TypeError("Redeem.output unspendable if larger than 3600 bytes");
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                const hash2 = $lgTFk.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (a.redeem.input && !$8wAtk.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !$3b92ea7f46896519$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || a.redeem.output && ($8wAtk.decompile(a.redeem.output) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || ($8wAtk.decompile(wScript) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wsh = $3b92ea7f46896519$var$p2wsh;

});

parcelRegister("bl5DO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2tr = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $f6boC = parcelRequire("f6boC");

var $lzIk8 = parcelRequire("lzIk8");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $8416081c4ea2e910$var$OPS = $8wAtk.OPS;
const $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION = 0x01;
const $8416081c4ea2e910$var$ANNEX_PREFIX = 0x50;
function $8416081c4ea2e910$var$p2tr(a, opts) {
    if (!a.address && !a.output && !a.pubkey && !a.internalPubkey && !(a.witness && a.witness.length > 1)) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        internalPubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        signature: $18Mz5.typeforce.maybe($18Mz5.typeforce.anyOf($18Mz5.typeforce.BufferN(64), $18Mz5.typeforce.BufferN(65))),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer)),
        scriptTree: $18Mz5.typeforce.maybe($18Mz5.isTaptree),
        redeem: $18Mz5.typeforce.maybe({
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number)
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32m.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32m.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $6ZWSX.Buffer.from(data)
        };
    });
    // remove annex if present, ignored by taproot
    const _witness = $4v19v.value(()=>{
        if (!a.witness || !a.witness.length) return;
        if (a.witness.length >= 2 && a.witness[a.witness.length - 1][0] === $8416081c4ea2e910$var$ANNEX_PREFIX) return a.witness.slice(0, -1);
        return a.witness.slice();
    });
    const _hashTree = $4v19v.value(()=>{
        if (a.scriptTree) return (0, $lzIk8.toHashTree)(a.scriptTree);
        if (a.hash) return {
            hash: a.hash
        };
        return;
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2tr",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.pubkey) return;
        const words = $db6J2.bech32m.toWords(o.pubkey);
        words.unshift($8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION);
        return $db6J2.bech32m.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        const hashTree = _hashTree();
        if (hashTree) return hashTree.hash;
        const w = _witness();
        if (w && w.length > 1) {
            const controlBlock = w[w.length - 1];
            const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
            const script = w[w.length - 2];
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: script,
                version: leafVersion
            });
            return (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
        }
        return null;
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.pubkey) return;
        return $8wAtk.compile([
            $8416081c4ea2e910$var$OPS.OP_1,
            o.pubkey
        ]);
    });
    $4v19v.prop(o, "redeemVersion", ()=>{
        if (a.redeemVersion) return a.redeemVersion;
        if (a.redeem && a.redeem.redeemVersion !== undefined && a.redeem.redeemVersion !== null) return a.redeem.redeemVersion;
        return $lzIk8.LEAF_VERSION_TAPSCRIPT;
    });
    $4v19v.prop(o, "redeem", ()=>{
        const witness = _witness(); // witness without annex
        if (!witness || witness.length < 2) return;
        return {
            output: witness[witness.length - 2],
            witness: witness.slice(0, -2),
            redeemVersion: witness[witness.length - 1][0] & $18Mz5.TAPLEAF_VERSION_MASK
        };
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(o.internalPubkey, o.hash);
            if (tweakedKey) return tweakedKey.x;
        }
    });
    $4v19v.prop(o, "internalPubkey", ()=>{
        if (a.internalPubkey) return a.internalPubkey;
        const witness = _witness();
        if (witness && witness.length > 1) return witness[witness.length - 1].slice(1, 33);
    });
    $4v19v.prop(o, "signature", ()=>{
        if (a.signature) return a.signature;
        const witness = _witness(); // witness without annex
        if (!witness || witness.length !== 1) return;
        return witness[0];
    });
    $4v19v.prop(o, "witness", ()=>{
        if (a.witness) return a.witness;
        const hashTree = _hashTree();
        if (hashTree && a.redeem && a.redeem.output && a.internalPubkey) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            const path = (0, $lzIk8.findScriptPath)(hashTree, leafHash);
            if (!path) return;
            const outputKey = (0, $lzIk8.tweakKey)(a.internalPubkey, hashTree.hash);
            if (!outputKey) return;
            const controlBock = $6ZWSX.Buffer.concat([
                $6ZWSX.Buffer.from([
                    o.redeemVersion | outputKey.parity
                ]),
                a.internalPubkey
            ].concat(path));
            return [
                a.redeem.output,
                controlBock
            ];
        }
        if (a.signature) return [
            a.signature
        ];
    });
    // extended validation
    if (opts.validate) {
        let pubkey = $6ZWSX.Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            pubkey = _address().data;
        }
        if (a.pubkey) {
            if (pubkey.length > 0 && !pubkey.equals(a.pubkey)) throw new TypeError("Pubkey mismatch");
            else pubkey = a.pubkey;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $8416081c4ea2e910$var$OPS.OP_1 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            if (pubkey.length > 0 && !pubkey.equals(a.output.slice(2))) throw new TypeError("Pubkey mismatch");
            else pubkey = a.output.slice(2);
        }
        if (a.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(a.internalPubkey, o.hash);
            if (pubkey.length > 0 && !pubkey.equals(tweakedKey.x)) throw new TypeError("Pubkey mismatch");
            else pubkey = tweakedKey.x;
        }
        if (pubkey && pubkey.length) {
            if (!(0, $f6boC.getEccLib)().isXOnlyPoint(pubkey)) throw new TypeError("Invalid pubkey for p2tr");
        }
        const hashTree = _hashTree();
        if (a.hash && hashTree) {
            if (!a.hash.equals(hashTree.hash)) throw new TypeError("Hash mismatch");
        }
        if (a.redeem && a.redeem.output && hashTree) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            if (!(0, $lzIk8.findScriptPath)(hashTree, leafHash)) throw new TypeError("Redeem script not in tree");
        }
        const witness = _witness();
        // compare the provided redeem data with the one computed from witness
        if (a.redeem && o.redeem) {
            if (a.redeem.redeemVersion) {
                if (a.redeem.redeemVersion !== o.redeem.redeemVersion) throw new TypeError("Redeem.redeemVersion and witness mismatch");
            }
            if (a.redeem.output) {
                if ($8wAtk.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // output redeem is constructed from the witness
                if (o.redeem.output && !a.redeem.output.equals(o.redeem.output)) throw new TypeError("Redeem.output and witness mismatch");
            }
            if (a.redeem.witness) {
                if (o.redeem.witness && !$8416081c4ea2e910$var$stacksEqual(a.redeem.witness, o.redeem.witness)) throw new TypeError("Redeem.witness and witness mismatch");
            }
        }
        if (witness && witness.length) {
            if (witness.length === 1) {
                // key spending
                if (a.signature && !a.signature.equals(witness[0])) throw new TypeError("Signature mismatch");
            } else {
                // script path spending
                const controlBlock = witness[witness.length - 1];
                if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
                if ((controlBlock.length - 33) % 32 !== 0) throw new TypeError(`The control-block length of ${controlBlock.length} is incorrect!`);
                const m = (controlBlock.length - 33) / 32;
                if (m > 128) throw new TypeError(`The script path is too long. Got ${m}, expected max 128.`);
                const internalPubkey = controlBlock.slice(1, 33);
                if (a.internalPubkey && !a.internalPubkey.equals(internalPubkey)) throw new TypeError("Internal pubkey mismatch");
                if (!(0, $f6boC.getEccLib)().isXOnlyPoint(internalPubkey)) throw new TypeError("Invalid internalPubkey for p2tr witness");
                const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
                const script = witness[witness.length - 2];
                const leafHash = (0, $lzIk8.tapleafHash)({
                    output: script,
                    version: leafVersion
                });
                const hash = (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
                const outputKey = (0, $lzIk8.tweakKey)(internalPubkey, hash);
                if (!outputKey) // todo: needs test data
                throw new TypeError("Invalid outputKey for p2tr witness");
                if (pubkey.length && !pubkey.equals(outputKey.x)) throw new TypeError("Pubkey mismatch for p2tr witness");
                if (outputKey.parity !== (controlBlock[0] & 1)) throw new Error("Incorrect parity");
            }
        }
    }
    return Object.assign(o, a);
}
module.exports.p2tr = $8416081c4ea2e910$var$p2tr;
function $8416081c4ea2e910$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}

});
parcelRegister("f6boC", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $afe04196d4a8990c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEccLib = module.exports.initEccLib = void 0;
const $afe04196d4a8990c$var$_ECCLIB_CACHE = {};
function $afe04196d4a8990c$var$initEccLib(eccLib) {
    if (!eccLib) // allow clearing the library
    $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    else if (eccLib !== $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) {
        // new instance, verify it
        $afe04196d4a8990c$var$verifyEcc(eccLib);
        $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    }
}
module.exports.initEccLib = $afe04196d4a8990c$var$initEccLib;
function $afe04196d4a8990c$var$getEccLib() {
    if (!$afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) throw new Error("No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance");
    return $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib;
}
module.exports.getEccLib = $afe04196d4a8990c$var$getEccLib;
const $afe04196d4a8990c$var$h = (hex)=>$afe04196d4a8990c$require$Buffer.from(hex, "hex");
function $afe04196d4a8990c$var$verifyEcc(ecc) {
    $afe04196d4a8990c$var$assert(typeof ecc.isXOnlyPoint === "function");
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("0000000000000000000000000000000000000000000000000000000000000001")));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h("0000000000000000000000000000000000000000000000000000000000000000")));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")));
    $afe04196d4a8990c$var$assert(typeof ecc.xOnlyPointAddTweak === "function");
    $afe04196d4a8990c$var$tweakAddVectors.forEach((t)=>{
        const r = ecc.xOnlyPointAddTweak($afe04196d4a8990c$var$h(t.pubkey), $afe04196d4a8990c$var$h(t.tweak));
        if (t.result === null) $afe04196d4a8990c$var$assert(r === null);
        else {
            $afe04196d4a8990c$var$assert(r !== null);
            $afe04196d4a8990c$var$assert(r.parity === t.parity);
            $afe04196d4a8990c$var$assert($afe04196d4a8990c$require$Buffer.from(r.xOnlyPubkey).equals($afe04196d4a8990c$var$h(t.result)));
        }
    });
}
function $afe04196d4a8990c$var$assert(bool) {
    if (!bool) throw new Error("ecc library invalid");
}
const $afe04196d4a8990c$var$tweakAddVectors = [
    {
        pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
        parity: -1,
        result: null
    },
    {
        pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
        tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
        parity: 1,
        result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
    },
    {
        pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
        tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
        parity: 0,
        result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
    }
];

});

parcelRegister("lzIk8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tweakKey = module.exports.tapTweakHash = module.exports.tapleafHash = module.exports.findScriptPath = module.exports.toHashTree = module.exports.rootHashFromPath = module.exports.MAX_TAPTREE_DEPTH = module.exports.LEAF_VERSION_TAPSCRIPT = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $f6boC = parcelRequire("f6boC");

var $lgTFk = parcelRequire("lgTFk");

var $lMPrw = parcelRequire("lMPrw");

var $18Mz5 = parcelRequire("18Mz5");
module.exports.LEAF_VERSION_TAPSCRIPT = 0xc0;
module.exports.MAX_TAPTREE_DEPTH = 128;
const $fb4f3fa2c6b14256$var$isHashBranch = (ht)=>"left" in ht && "right" in ht;
function $fb4f3fa2c6b14256$var$rootHashFromPath(controlBlock, leafHash) {
    if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
    const m = (controlBlock.length - 33) / 32;
    let kj = leafHash;
    for(let j = 0; j < m; j++){
        const ej = controlBlock.slice(33 + 32 * j, 65 + 32 * j);
        if (kj.compare(ej) < 0) kj = $fb4f3fa2c6b14256$var$tapBranchHash(kj, ej);
        else kj = $fb4f3fa2c6b14256$var$tapBranchHash(ej, kj);
    }
    return kj;
}
module.exports.rootHashFromPath = $fb4f3fa2c6b14256$var$rootHashFromPath;
/**
 * Build a hash tree of merkle nodes from the scripts binary tree.
 * @param scriptTree - the tree of scripts to pairwise hash.
 */ function $fb4f3fa2c6b14256$var$toHashTree(scriptTree) {
    if ((0, $18Mz5.isTapleaf)(scriptTree)) return {
        hash: $fb4f3fa2c6b14256$var$tapleafHash(scriptTree)
    };
    const hashes = [
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[0]),
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[1])
    ];
    hashes.sort((a, b)=>a.hash.compare(b.hash));
    const [left, right] = hashes;
    return {
        hash: $fb4f3fa2c6b14256$var$tapBranchHash(left.hash, right.hash),
        left: left,
        right: right
    };
}
module.exports.toHashTree = $fb4f3fa2c6b14256$var$toHashTree;
/**
 * Given a HashTree, finds the path from a particular hash to the root.
 * @param node - the root of the tree
 * @param hash - the hash to search for
 * @returns - array of sibling hashes, from leaf (inclusive) to root
 * (exclusive) needed to prove inclusion of the specified hash. undefined if no
 * path is found
 */ function $fb4f3fa2c6b14256$var$findScriptPath(node, hash) {
    if ($fb4f3fa2c6b14256$var$isHashBranch(node)) {
        const leftPath = $fb4f3fa2c6b14256$var$findScriptPath(node.left, hash);
        if (leftPath !== undefined) return [
            ...leftPath,
            node.right.hash
        ];
        const rightPath = $fb4f3fa2c6b14256$var$findScriptPath(node.right, hash);
        if (rightPath !== undefined) return [
            ...rightPath,
            node.left.hash
        ];
    } else if (node.hash.equals(hash)) return [];
    return undefined;
}
module.exports.findScriptPath = $fb4f3fa2c6b14256$var$findScriptPath;
function $fb4f3fa2c6b14256$var$tapleafHash(leaf) {
    const version = leaf.version || module.exports.LEAF_VERSION_TAPSCRIPT;
    return $lgTFk.taggedHash("TapLeaf", $6ZWSX.Buffer.concat([
        $6ZWSX.Buffer.from([
            version
        ]),
        $fb4f3fa2c6b14256$var$serializeScript(leaf.output)
    ]));
}
module.exports.tapleafHash = $fb4f3fa2c6b14256$var$tapleafHash;
function $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h) {
    return $lgTFk.taggedHash("TapTweak", $6ZWSX.Buffer.concat(h ? [
        pubKey,
        h
    ] : [
        pubKey
    ]));
}
module.exports.tapTweakHash = $fb4f3fa2c6b14256$var$tapTweakHash;
function $fb4f3fa2c6b14256$var$tweakKey(pubKey, h) {
    if (!$6ZWSX.Buffer.isBuffer(pubKey)) return null;
    if (pubKey.length !== 32) return null;
    if (h && h.length !== 32) return null;
    const tweakHash = $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h);
    const res = (0, $f6boC.getEccLib)().xOnlyPointAddTweak(pubKey, tweakHash);
    if (!res || res.xOnlyPubkey === null) return null;
    return {
        parity: res.parity,
        x: $6ZWSX.Buffer.from(res.xOnlyPubkey)
    };
}
module.exports.tweakKey = $fb4f3fa2c6b14256$var$tweakKey;
function $fb4f3fa2c6b14256$var$tapBranchHash(a, b) {
    return $lgTFk.taggedHash("TapBranch", $6ZWSX.Buffer.concat([
        a,
        b
    ]));
}
function $fb4f3fa2c6b14256$var$serializeScript(s) {
    const varintLen = $lMPrw.varuint.encodingLength(s.length);
    const buffer = $6ZWSX.Buffer.allocUnsafe(varintLen); // better
    $lMPrw.varuint.encode(s.length, buffer);
    return $6ZWSX.Buffer.concat([
        buffer,
        s
    ]);
}

});
parcelRegister("lMPrw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fdc5fc2bbe395f08$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.cloneBuffer = module.exports.reverseBuffer = module.exports.writeUInt64LE = module.exports.readUInt64LE = module.exports.varuint = void 0;

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $fdc5fc2bbe395f08$var$typeforce } = $18Mz5;

var $JAEWR = parcelRequire("JAEWR");
module.exports.varuint = $JAEWR;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $fdc5fc2bbe395f08$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $fdc5fc2bbe395f08$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $fdc5fc2bbe395f08$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $fdc5fc2bbe395f08$var$readUInt64LE;
function $fdc5fc2bbe395f08$var$writeUInt64LE(buffer, value, offset) {
    $fdc5fc2bbe395f08$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $fdc5fc2bbe395f08$var$writeUInt64LE;
function $fdc5fc2bbe395f08$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $fdc5fc2bbe395f08$var$reverseBuffer;
function $fdc5fc2bbe395f08$var$cloneBuffer(buffer) {
    const clone = $fdc5fc2bbe395f08$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
module.exports.cloneBuffer = $fdc5fc2bbe395f08$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $fdc5fc2bbe395f08$var$BufferWriter {
    static withCapacity(size) {
        return new $fdc5fc2bbe395f08$var$BufferWriter($fdc5fc2bbe395f08$require$Buffer.alloc(size));
    }
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $fdc5fc2bbe395f08$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
    end() {
        if (this.buffer.length === this.offset) return this.buffer;
        throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
    }
}
module.exports.BufferWriter = $fdc5fc2bbe395f08$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $fdc5fc2bbe395f08$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $fdc5fc2bbe395f08$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $fdc5fc2bbe395f08$var$BufferReader;

});
parcelRegister("JAEWR", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $0890a3e38d1fefe2$require$Buffer = $1U9GM.Buffer;
// Number.MAX_SAFE_INTEGER
var $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER = 9007199254740991;
function $0890a3e38d1fefe2$var$checkUInt53(n) {
    if (n < 0 || n > $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $0890a3e38d1fefe2$var$encode(number, buffer, offset) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    if (!buffer) buffer = $0890a3e38d1fefe2$require$Buffer.allocUnsafe($0890a3e38d1fefe2$var$encodingLength(number));
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        $0890a3e38d1fefe2$var$encode.bytes = 1;
    // 16 bit
    } else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 3;
    // 32 bit
    } else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 5;
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE(number / 0x100000000 | 0, offset + 5);
        $0890a3e38d1fefe2$var$encode.bytes = 9;
    }
    return buffer;
}
function $0890a3e38d1fefe2$var$decode(buffer, offset) {
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 1;
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 3;
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        $0890a3e38d1fefe2$var$decode.bytes = 5;
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        $0890a3e38d1fefe2$var$decode.bytes = 9;
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var number = hi * 0x0100000000 + lo;
        $0890a3e38d1fefe2$var$checkUInt53(number);
        return number;
    }
}
function $0890a3e38d1fefe2$var$encodingLength(number) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    return number < 0xfd ? 1 : number <= 0xffff ? 3 : number <= 0xffffffff ? 5 : 9;
}
module.exports = {
    encode: $0890a3e38d1fefe2$var$encode,
    decode: $0890a3e38d1fefe2$var$decode,
    encodingLength: $0890a3e38d1fefe2$var$encodingLength
};

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});







parcelRegister("huuL7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $cbbd191810e07df9$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Block = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $gmJA7 = parcelRequire("gmJA7");

var $gMJcK = parcelRequire("gMJcK");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $cbbd191810e07df9$var$typeforce } = $18Mz5;
const $cbbd191810e07df9$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
const $cbbd191810e07df9$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
class $cbbd191810e07df9$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const block = new $cbbd191810e07df9$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $gMJcK.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $cbbd191810e07df9$var$Block.fromBuffer($cbbd191810e07df9$require$Buffer.from(hex, "hex"));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $cbbd191810e07df9$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $cbbd191810e07df9$var$typeforce([
            {
                getHash: $18Mz5.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (forWitness && !$cbbd191810e07df9$var$txesHaveWitnessCommit(transactions)) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = (0, $gmJA7.fastMerkleRoot)(hashes, $lgTFk.hash256);
        return forWitness ? $lgTFk.hash256($cbbd191810e07df9$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$cbbd191810e07df9$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($cbbd191810e07df9$require$Buffer.from("6a24aa21a9ed", "hex"))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $cbbd191810e07df9$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $cbbd191810e07df9$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $cbbd191810e07df9$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $lMPrw.varuint.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $lgTFk.hash256(this.toBuffer(true));
    }
    getId() {
        return (0, $lMPrw.reverseBuffer)(this.getHash()).toString("hex");
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $cbbd191810e07df9$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $lMPrw.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $lMPrw.varuint.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $lMPrw.varuint.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString("hex");
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = (0, $lMPrw.reverseBuffer)(this.getHash());
        const target = $cbbd191810e07df9$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        const actualMerkleRoot = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
module.exports.Block = $cbbd191810e07df9$var$Block;
function $cbbd191810e07df9$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $cbbd191810e07df9$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === "object" && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === "object" && input.witness instanceof Array && input.witness.length > 0));
}

});
parcelRegister("gmJA7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bea20efcdc27ef99$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fastMerkleRoot = void 0;
function $bea20efcdc27ef99$var$fastMerkleRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    let length = values.length;
    const results = values.concat();
    while(length > 1){
        let j = 0;
        for(let i = 0; i < length; i += 2, ++j){
            const left = results[i];
            const right = i + 1 === length ? left : results[i + 1];
            const data = $bea20efcdc27ef99$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
}
module.exports.fastMerkleRoot = $bea20efcdc27ef99$var$fastMerkleRoot;

});

parcelRegister("gMJcK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c38431c0153a39cb$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transaction = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $8wAtk = parcelRequire("8wAtk");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $c38431c0153a39cb$var$typeforce } = $18Mz5;
function $c38431c0153a39cb$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $lMPrw.varuint.encodingLength(length) + length;
}
function $c38431c0153a39cb$var$vectorSize(someVector) {
    const length = someVector.length;
    return $lMPrw.varuint.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $c38431c0153a39cb$var$varSliceSize(witness);
    }, 0);
}
const $c38431c0153a39cb$var$EMPTY_BUFFER = $c38431c0153a39cb$require$Buffer.allocUnsafe(0);
const $c38431c0153a39cb$var$EMPTY_WITNESS = [];
const $c38431c0153a39cb$var$ZERO = $c38431c0153a39cb$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
const $c38431c0153a39cb$var$ONE = $c38431c0153a39cb$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
const $c38431c0153a39cb$var$VALUE_UINT64_MAX = $c38431c0153a39cb$require$Buffer.from("ffffffffffffffff", "hex");
const $c38431c0153a39cb$var$BLANK_OUTPUT = {
    script: $c38431c0153a39cb$var$EMPTY_BUFFER,
    valueBuffer: $c38431c0153a39cb$var$VALUE_UINT64_MAX
};
function $c38431c0153a39cb$var$isOutput(out) {
    return out.value !== undefined;
}
class $c38431c0153a39cb$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const tx = new $c38431c0153a39cb$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
        return tx;
    }
    static fromHex(hex) {
        return $c38431c0153a39cb$var$Transaction.fromBuffer($c38431c0153a39cb$require$Buffer.from(hex, "hex"), false);
    }
    static isCoinbaseHash(buffer) {
        $c38431c0153a39cb$var$typeforce($18Mz5.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $c38431c0153a39cb$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Hash256bit, $18Mz5.UInt32, $18Mz5.maybe($18Mz5.UInt32), $18Mz5.maybe($18Mz5.Buffer)), arguments);
        if ($18Mz5.Null(sequence)) sequence = $c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $c38431c0153a39cb$var$EMPTY_BUFFER,
            sequence: sequence,
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $lMPrw.varuint.encodingLength(this.ins.length) + $lMPrw.varuint.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $c38431c0153a39cb$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $c38431c0153a39cb$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $c38431c0153a39cb$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, /* types.UInt8 */ $18Mz5.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $c38431c0153a39cb$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $8wAtk.compile($8wAtk.decompile(prevOutScript).filter((x)=>{
            return x !== $8wAtk.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $c38431c0153a39cb$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $c38431c0153a39cb$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $c38431c0153a39cb$var$EMPTY_BUFFER;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $lgTFk.hash256(buffer);
    }
    hashForWitnessV1(inIndex, prevOutScripts, values, hashType, leafHash, annex) {
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#common-signature-message
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Buffer), $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Satoshi), $18Mz5.UInt32), arguments);
        if (values.length !== this.ins.length || prevOutScripts.length !== this.ins.length) throw new Error("Must supply prevout script and value for all inputs");
        const outputType = hashType === $c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT ? $c38431c0153a39cb$var$Transaction.SIGHASH_ALL : hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK;
        const inputType = hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK;
        const isAnyoneCanPay = inputType === $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY;
        const isNone = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE;
        const isSingle = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE;
        let hashPrevouts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashAmounts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashScriptPubKeys = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashSequences = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashOutputs = $c38431c0153a39cb$var$EMPTY_BUFFER;
        if (!isAnyoneCanPay) {
            let bufferWriter = $lMPrw.BufferWriter.withCapacity(36 * this.ins.length);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(8 * this.ins.length);
            values.forEach((value)=>bufferWriter.writeUInt64(value));
            hashAmounts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(prevOutScripts.map($c38431c0153a39cb$var$varSliceSize).reduce((a, b)=>a + b));
            prevOutScripts.forEach((prevOutScript)=>bufferWriter.writeVarSlice(prevOutScript));
            hashScriptPubKeys = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(4 * this.ins.length);
            this.ins.forEach((txIn)=>bufferWriter.writeUInt32(txIn.sequence));
            hashSequences = $lgTFk.sha256(bufferWriter.end());
        }
        if (!(isNone || isSingle)) {
            const txOutsSize = this.outs.map((output)=>8 + $c38431c0153a39cb$var$varSliceSize(output.script)).reduce((a, b)=>a + b);
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(txOutsSize);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        } else if (isSingle && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        }
        const spendType = (leafHash ? 2 : 0) + (annex ? 1 : 0);
        // Length calculation from:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-14
        // With extension from:
        // https://github.com/bitcoin/bips/blob/master/bip-0342.mediawiki#signature-validation
        const sigMsgSize = 174 - (isAnyoneCanPay ? 49 : 0) - (isNone ? 32 : 0) + (annex ? 32 : 0) + (leafHash ? 37 : 0);
        const sigMsgWriter = $lMPrw.BufferWriter.withCapacity(sigMsgSize);
        sigMsgWriter.writeUInt8(hashType);
        // Transaction
        sigMsgWriter.writeInt32(this.version);
        sigMsgWriter.writeUInt32(this.locktime);
        sigMsgWriter.writeSlice(hashPrevouts);
        sigMsgWriter.writeSlice(hashAmounts);
        sigMsgWriter.writeSlice(hashScriptPubKeys);
        sigMsgWriter.writeSlice(hashSequences);
        if (!(isNone || isSingle)) sigMsgWriter.writeSlice(hashOutputs);
        // Input
        sigMsgWriter.writeUInt8(spendType);
        if (isAnyoneCanPay) {
            const input = this.ins[inIndex];
            sigMsgWriter.writeSlice(input.hash);
            sigMsgWriter.writeUInt32(input.index);
            sigMsgWriter.writeUInt64(values[inIndex]);
            sigMsgWriter.writeVarSlice(prevOutScripts[inIndex]);
            sigMsgWriter.writeUInt32(input.sequence);
        } else sigMsgWriter.writeUInt32(inIndex);
        if (annex) {
            const bufferWriter = $lMPrw.BufferWriter.withCapacity($c38431c0153a39cb$var$varSliceSize(annex));
            bufferWriter.writeVarSlice(annex);
            sigMsgWriter.writeSlice($lgTFk.sha256(bufferWriter.end()));
        }
        // Output
        if (isSingle) sigMsgWriter.writeSlice(hashOutputs);
        // BIP342 extension
        if (leafHash) {
            sigMsgWriter.writeSlice(leafHash);
            sigMsgWriter.writeUInt8(0);
            sigMsgWriter.writeUInt32(0xffffffff);
        }
        // Extra zero byte because:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-19
        return $lgTFk.taggedHash("TapSighash", $c38431c0153a39cb$require$Buffer.concat([
            $c38431c0153a39cb$require$Buffer.from([
                0x00
            ]),
            sigMsgWriter.end()
        ]));
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, $18Mz5.Satoshi, $18Mz5.UInt32), arguments);
        let tbuffer = $c38431c0153a39cb$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $c38431c0153a39cb$var$ZERO;
        let hashPrevouts = $c38431c0153a39cb$var$ZERO;
        let hashSequence = $c38431c0153a39cb$var$ZERO;
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.hash256(tbuffer);
        }
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $lgTFk.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.hash256(tbuffer);
        }
        tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(156 + $c38431c0153a39cb$var$varSliceSize(prevOutScript));
        bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $lgTFk.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $c38431c0153a39cb$require$Buffer.alloc(32, 0);
        return $lgTFk.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return (0, $lMPrw.reverseBuffer)(this.getHash(false)).toString("hex");
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString("hex");
    }
    setInputScript(index, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, $18Mz5.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, [
            $18Mz5.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $lMPrw.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($c38431c0153a39cb$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
module.exports.Transaction = $c38431c0153a39cb$var$Transaction;
$c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT = 0x00;
$c38431c0153a39cb$var$Transaction.SIGHASH_ALL = 0x01;
$c38431c0153a39cb$var$Transaction.SIGHASH_NONE = 0x02;
$c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK = 0x80;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;

});


parcelRegister("hXYde", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d146a75032ca9c85$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Psbt = void 0;

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");

var $d1wHE = parcelRequire("d1wHE");

var $lMPrw = parcelRequire("lMPrw");

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $lzIk8 = parcelRequire("lzIk8");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $7rkx8 = parcelRequire("7rkx8");

var $9txdn = parcelRequire("9txdn");
/**
 * These are the default arguments for a Psbt instance.
 */ const $d146a75032ca9c85$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $fjh6Q.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $d146a75032ca9c85$var$Psbt {
    static fromBase64(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $d146a75032ca9c85$var$transactionFromBuffer);
        const psbt = new $d146a75032ca9c85$var$Psbt(opts, psbtBase);
        $d146a75032ca9c85$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    constructor(opts = {}, data = new $jbkDe.Psbt(new $d146a75032ca9c85$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $d146a75032ca9c85$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Psbt's predecesor (TransactionBuilder - now removed) behavior
            // was to not confirm input values  before signing.
            // Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: (0, $lMPrw.cloneBuffer)(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = (0, $d1wHE.fromOutputScript)(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: (0, $lMPrw.cloneBuffer)(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $d146a75032ca9c85$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $d146a75032ca9c85$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $d146a75032ca9c85$var$check32Bit(version);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $d146a75032ca9c85$var$check32Bit(locktime);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $d146a75032ca9c85$var$check32Bit(sequence);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        (0, $7rkx8.checkTaprootInputFields)(inputData, inputData, "addInput");
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "addInput");
        if (inputData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $d146a75032ca9c85$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
        const { address: address } = outputData;
        if (typeof address === "string") {
            const { network: network } = this.opts;
            const script = (0, $d1wHE.toOutputScript)(address, network);
            outputData = Object.assign(outputData, {
                script: script
            });
        }
        (0, $7rkx8.checkTaprootOutputFields)(outputData, outputData, "addOutput");
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error("Not finalized");
        const c = this.__CACHE;
        if (!disableFeeCheck) $d146a75032ca9c85$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $d146a75032ca9c85$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $d146a75032ca9c85$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $d146a75032ca9c85$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        $d146a75032ca9c85$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, undefined, finalScriptsFunc);
        return this._finalizeInput(inputIndex, input, finalScriptsFunc);
    }
    finalizeTaprootInput(inputIndex, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc);
        throw new Error(`Cannot finalize input #${inputIndex}. Not Taproot.`);
    }
    _finalizeInput(inputIndex, input, finalScriptsFunc = $d146a75032ca9c85$var$getFinalScripts) {
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $d146a75032ca9c85$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    _finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        if (!input.witnessUtxo) throw new Error(`Cannot finalize input #${inputIndex}. Missing withness utxo.`);
        // Check key spend first. Increased privacy and reduced block space.
        if (input.tapKeySig) {
            const payment = $j87lX.p2tr({
                output: input.witnessUtxo.script,
                signature: input.tapKeySig
            });
            const finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        } else {
            const { finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, tapLeafHashToFinalize);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        }
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $d146a75032ca9c85$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $d146a75032ca9c85$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === "raw" ? "" : result.type + "-";
        const mainType = $d146a75032ca9c85$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        return $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        return $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs(validator) {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        const results = $d146a75032ca9c85$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx, validator));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        if ((0, $7rkx8.isTaprootInput)(input)) return this.validateSignaturesOfTaprootInput(inputIndex, validator, pubkey);
        return this._validateSignaturesOfInput(inputIndex, validator, pubkey);
    }
    _validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
        if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $8wAtk.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $d146a75032ca9c85$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $d146a75032ca9c85$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
            results.push(validator(pSig.pubkey, hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    validateSignaturesOfTaprootInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const tapKeySig = (input || {}).tapKeySig;
        const tapScriptSig = (input || {}).tapScriptSig;
        if (!input && !tapKeySig && !(tapScriptSig && !tapScriptSig.length)) throw new Error("No signatures to validate");
        if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
        pubkey = pubkey && (0, $7rkx8.toXOnly)(pubkey);
        const allHashses = pubkey ? $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, pubkey, this.__CACHE) : $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, this.data.inputs, this.__CACHE);
        if (!allHashses.length) throw new Error("No signatures for this pubkey");
        const tapKeyHash = allHashses.find((h)=>!h.leafHash);
        let validationResultCount = 0;
        if (tapKeySig && tapKeyHash) {
            const isValidTapkeySig = validator(tapKeyHash.pubkey, tapKeyHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapKeySig));
            if (!isValidTapkeySig) return false;
            validationResultCount++;
        }
        if (tapScriptSig) for (const tapSig of tapScriptSig){
            const tapSigHash = allHashses.find((h)=>tapSig.pubkey.equals(h.pubkey));
            if (tapSigHash) {
                const isValidTapScriptSig = validator(tapSig.pubkey, tapSigHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapSig.signature));
                if (!isValidTapScriptSig) return false;
                validationResultCount++;
            }
        }
        return validationResultCount > 0;
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const results = [];
            const promises = [];
            for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, undefined, sighashTypes);
        return this._signInput(inputIndex, keyPair, sighashTypes);
    }
    signTaprootInput(inputIndex, keyPair, tapLeafHashToSign, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, sighashTypes);
        throw new Error(`Input #${inputIndex} is not of type Taproot.`);
    }
    _signInput(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $8wAtk.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    _signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes);
        const tapKeySig = hashesForSig.filter((h)=>!h.leafHash).map((h)=>(0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType))[0];
        const tapScriptSig = hashesForSig.filter((h)=>!!h.leafHash).map((h)=>({
                pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                signature: (0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType),
                leafHash: h.leafHash
            }));
        if (tapKeySig) this.data.updateInput(inputIndex, {
            tapKeySig: tapKeySig
        });
        if (tapScriptSig.length) this.data.updateInput(inputIndex, {
            tapScriptSig: tapScriptSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, undefined, sighashTypes);
            return this._signInputAsync(inputIndex, keyPair, sighashTypes);
        });
    }
    signTaprootInputAsync(inputIndex, keyPair, tapLeafHash, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
            throw new Error(`Input #${inputIndex} is not of type Taproot.`);
        });
    }
    _signInputAsync(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
            const partialSig = [
                {
                    pubkey: keyPair.publicKey,
                    signature: $8wAtk.signature.encode(signature, sighashType)
                }
            ];
            this.data.updateInput(inputIndex, {
                partialSig: partialSig
            });
        });
    }
    async _signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
        const signaturePromises = [];
        const tapKeyHash = hashesForSig.filter((h)=>!h.leafHash)[0];
        if (tapKeyHash) {
            const tapKeySigPromise = Promise.resolve(keyPair.signSchnorr(tapKeyHash.hash)).then((sig)=>{
                return {
                    tapKeySig: (0, $7rkx8.serializeTaprootSignature)(sig, input.sighashType)
                };
            });
            signaturePromises.push(tapKeySigPromise);
        }
        const tapScriptHashes = hashesForSig.filter((h)=>!!h.leafHash);
        if (tapScriptHashes.length) {
            const tapScriptSigPromises = tapScriptHashes.map((tsh)=>{
                return Promise.resolve(keyPair.signSchnorr(tsh.hash)).then((signature)=>{
                    const tapScriptSig = [
                        {
                            pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                            signature: (0, $7rkx8.serializeTaprootSignature)(signature, input.sighashType),
                            leafHash: tsh.leafHash
                        }
                    ];
                    return {
                        tapScriptSig: tapScriptSig
                    };
                });
            });
            signaturePromises.push(...tapScriptSigPromises);
        }
        return Promise.all(signaturePromises).then((results)=>{
            results.forEach((v)=>this.data.updateInput(inputIndex, v));
        });
    }
    checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes) {
        if (typeof keyPair.signSchnorr !== "function") throw new Error(`Need Schnorr Signer to sign taproot input #${inputIndex}.`);
        const hashesForSig = $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, keyPair.publicKey, this.__CACHE, tapLeafHashToSign, allowedSighashTypes);
        if (!hashesForSig || !hashesForSig.length) throw new Error(`Can not sign for input #${inputIndex} with the key ${keyPair.publicKey.toString("hex")}`);
        return hashesForSig;
    }
    toBuffer() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(updateData.witnessScript);
        (0, $7rkx8.checkTaprootInputFields)(this.data.inputs[inputIndex], updateData, "updateInput");
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const outputData = this.data.outputs[outputIndex];
        (0, $7rkx8.checkTaprootOutputFields)(outputData, updateData, "updateOutput");
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
module.exports.Psbt = $d146a75032ca9c85$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $d146a75032ca9c85$var$transactionFromBuffer = (buffer)=>new $d146a75032ca9c85$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $d146a75032ca9c85$var$PsbtTransaction {
    constructor(buffer = $d146a75032ca9c85$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $gMJcK.Transaction.fromBuffer(buffer);
        $d146a75032ca9c85$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
        const hash = typeof input.hash === "string" ? (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash, "hex")) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $d146a75032ca9c85$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $d146a75032ca9c85$var$hasSigs(1, input.partialSig);
        case "multisig":
            const p2ms = $j87lX.p2ms({
                output: script
            });
            return $d146a75032ca9c85$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $d146a75032ca9c85$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $d146a75032ca9c85$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $d146a75032ca9c85$var$compressPubkey(pkey);
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $d146a75032ca9c85$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $d146a75032ca9c85$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $d146a75032ca9c85$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $d146a75032ca9c85$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $d146a75032ca9c85$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        const throws = (0, $7rkx8.isTaprootInput)(input) ? (0, $7rkx8.checkTaprootInputForSigs)(input, action) : (0, $9txdn.checkInputForSig)(input, action);
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $d146a75032ca9c85$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $8wAtk.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, action) {
    if (!(0, $9txdn.pubkeyInScript)(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString("hex")}`);
}
function $d146a75032ca9c85$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $d146a75032ca9c85$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $d146a75032ca9c85$var$checkTxInputCache(cache, input);
    });
}
function $d146a75032ca9c85$var$checkTxInputCache(cache, input) {
    const key = (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $d146a75032ca9c85$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $d146a75032ca9c85$var$checkRedeemScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2sh, "Redeem script");
const $d146a75032ca9c85$var$checkWitnessScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2wsh, "Witness script");
function $d146a75032ca9c85$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $d146a75032ca9c85$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $d146a75032ca9c85$var$classifyScript(script);
    if (!$d146a75032ca9c85$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $j87lX.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $j87lX.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(p2wsh.witness);
        else finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $d146a75032ca9c85$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_ALL;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes);
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    const { meaningfulScript: meaningfulScript, type: type } = $d146a75032ca9c85$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript);
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ((0, $9txdn.isP2WPKH)(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $j87lX.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString("hex")}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecesor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, inputs, cache) {
    const allPublicKeys = [];
    if (input.tapInternalKey) {
        const key = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache);
        if (key) allPublicKeys.push(key);
    }
    if (input.tapScriptSig) {
        const tapScriptPubkeys = input.tapScriptSig.map((tss)=>tss.pubkey);
        allPublicKeys.push(...tapScriptPubkeys);
    }
    const allHashes = allPublicKeys.map((pubicKey)=>$d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubicKey, cache));
    return allHashes.flat();
}
function $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return (0, $9txdn.isP2TR)(script) ? script.subarray(2, 34) : null;
}
function $d146a75032ca9c85$var$trimTaprootSig(signature) {
    return signature.length === 64 ? signature : signature.subarray(0, 64);
}
function $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubkey, cache, tapLeafHashToSign, allowedSighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_DEFAULT;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, allowedSighashTypes);
    const prevOuts = inputs.map((i, index)=>$d146a75032ca9c85$var$getScriptAndAmountFromUtxo(index, i, cache));
    const signingScripts = prevOuts.map((o)=>o.script);
    const values = prevOuts.map((o)=>o.value);
    const hashes = [];
    if (input.tapInternalKey && !tapLeafHashToSign) {
        const outputKey = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) || $d146a75032ca9c85$require$Buffer.from([]);
        if ((0, $7rkx8.toXOnly)(pubkey).equals(outputKey)) {
            const tapKeyHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType);
            hashes.push({
                pubkey: pubkey,
                hash: tapKeyHash
            });
        }
    }
    const tapLeafHashes = (input.tapLeafScript || []).filter((tapLeaf)=>(0, $9txdn.pubkeyInScript)(pubkey, tapLeaf.script)).map((tapLeaf)=>{
        const hash = (0, $lzIk8.tapleafHash)({
            output: tapLeaf.script,
            version: tapLeaf.leafVersion
        });
        return Object.assign({
            hash: hash
        }, tapLeaf);
    }).filter((tapLeaf)=>!tapLeafHashToSign || tapLeafHashToSign.equals(tapLeaf.hash)).map((tapLeaf)=>{
        const tapScriptHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, $gMJcK.Transaction.SIGHASH_DEFAULT, tapLeaf.hash);
        return {
            pubkey: pubkey,
            hash: tapScriptHash,
            leafHash: tapLeaf.hash
        };
    });
    return hashes.concat(tapLeafHashes);
}
function $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes) {
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $d146a75032ca9c85$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
}
function $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case "multisig":
            const sigs = $d146a75032ca9c85$var$getSortedSigs(script, partialSig);
            payment = $j87lX.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $j87lX.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $j87lX.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $j87lX.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || (0, $9txdn.isP2WPKH)(res.script)) res.isSegwit = true;
    return res;
}
function $d146a75032ca9c85$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $d146a75032ca9c85$var$getSortedSigs(script, partialSig) {
    const p2ms = $j87lX.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $d146a75032ca9c85$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $d146a75032ca9c85$var$sighashTypeToString(sighashType) {
    let text = sighashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $gMJcK.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $gMJcK.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return script;
}
function $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return {
        script: input.witnessUtxo.script,
        value: input.witnessUtxo.value
    };
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const o = nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index];
        return {
            script: o.script,
            value: o.value
        };
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $8wAtk.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$d146a75032ca9c85$require$Buffer.isBuffer(lastItem) || $d146a75032ca9c85$var$isPubkeyLike(lastItem) || $d146a75032ca9c85$var$isSigLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($d146a75032ca9c85$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$compressPubkey(pubkey) {
    if (pubkey.length === 65) {
        const parity = pubkey[64] & 1;
        const newKey = pubkey.slice(0, 33);
        newKey[0] = 2 | parity;
        return newKey;
    }
    return pubkey.slice();
}
function $d146a75032ca9c85$var$isPubkeyLike(buf) {
    return buf.length === 33 && $8wAtk.isCanonicalPubKey(buf);
}
function $d146a75032ca9c85$var$isSigLike(buf) {
    return $8wAtk.isCanonicalScriptSignature(buf);
}
function $d146a75032ca9c85$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = (0, $9txdn.isP2SHScript)(script);
    const isP2SHP2WSH = isP2SH && redeemScript && (0, $9txdn.isP2WSHScript)(redeemScript);
    const isP2WSH = (0, $9txdn.isP2WSHScript)(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
        $d146a75032ca9c85$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkWitnessScript(index, script, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $d146a75032ca9c85$var$checkInvalidP2WSH(script) {
    if ((0, $9txdn.isP2WPKH)(script) || (0, $9txdn.isP2SHScript)(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $d146a75032ca9c85$var$classifyScript(script) {
    if ((0, $9txdn.isP2WPKH)(script)) return "witnesspubkeyhash";
    if ((0, $9txdn.isP2PKH)(script)) return "pubkeyhash";
    if ((0, $9txdn.isP2MS)(script)) return "multisig";
    if ((0, $9txdn.isP2PK)(script)) return "pubkey";
    return "nonstandard";
}
function $d146a75032ca9c85$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}

});
parcelRegister("jbkDe", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $df6f0c6de5015d92$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kO5Vi = parcelRequire("kO5Vi");

var $8Damr = parcelRequire("8Damr");

var $qpq9i = parcelRequire("qpq9i");

var $geRUU = parcelRequire("geRUU");
class $df6f0c6de5015d92$var$Psbt {
    constructor(tx){
        this.inputs = [];
        this.outputs = [];
        this.globalMap = {
            unsignedTx: tx
        };
    }
    static fromBase64(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromHex(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromBuffer(buffer, txFromBuffer) {
        const results = $8Damr.psbtFromBuffer(buffer, txFromBuffer);
        const psbt = new this(results.globalMap.unsignedTx);
        Object.assign(psbt, results);
        return psbt;
    }
    toBase64() {
        const buffer = this.toBuffer();
        return buffer.toString("base64");
    }
    toHex() {
        const buffer = this.toBuffer();
        return buffer.toString("hex");
    }
    toBuffer() {
        return $8Damr.psbtToBuffer(this);
    }
    updateGlobal(updateData) {
        $geRUU.updateGlobal(updateData, this.globalMap);
        return this;
    }
    updateInput(inputIndex, updateData) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.updateInput(updateData, input);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.updateOutput(updateData, output);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        $geRUU.checkHasKey(keyVal, this.globalMap.unknownKeyVals, $geRUU.getEnumLength($qpq9i.GlobalTypes));
        if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
        this.globalMap.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.checkHasKey(keyVal, input.unknownKeyVals, $geRUU.getEnumLength($qpq9i.InputTypes));
        if (!input.unknownKeyVals) input.unknownKeyVals = [];
        input.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.checkHasKey(keyVal, output.unknownKeyVals, $geRUU.getEnumLength($qpq9i.OutputTypes));
        if (!output.unknownKeyVals) output.unknownKeyVals = [];
        output.unknownKeyVals.push(keyVal);
        return this;
    }
    addInput(inputData) {
        this.globalMap.unsignedTx.addInput(inputData);
        this.inputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = inputData.unknownKeyVals || [];
        const inputIndex = this.inputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToInput(inputIndex, keyVal));
        $geRUU.addInputAttributes(this.inputs, inputData);
        return this;
    }
    addOutput(outputData) {
        this.globalMap.unsignedTx.addOutput(outputData);
        this.outputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = outputData.unknownKeyVals || [];
        const outputIndex = this.outputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToOutput(outputIndex, keyVal));
        $geRUU.addOutputAttributes(this.outputs, outputData);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.inputCheckUncleanFinalized(inputIndex, input);
        for (const key of Object.keys(input))if (![
            "witnessUtxo",
            "nonWitnessUtxo",
            "finalScriptSig",
            "finalScriptWitness",
            "unknownKeyVals"
        ].includes(key)) // @ts-ignore
        delete input[key];
        return this;
    }
    combine(...those) {
        // Combine this with those.
        // Return self for chaining.
        const result = $kO5Vi.combine([
            this
        ].concat(those));
        Object.assign(this, result);
        return this;
    }
    getTransaction() {
        return this.globalMap.unsignedTx.toBuffer();
    }
}
module.exports.Psbt = $df6f0c6de5015d92$var$Psbt;

});
parcelRegister("kO5Vi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8Damr = parcelRequire("8Damr");
function $f25d125ea4ac600e$var$combine(psbts) {
    const self = psbts[0];
    const selfKeyVals = $8Damr.psbtToKeyVals(self);
    const others = psbts.slice(1);
    if (others.length === 0) throw new Error("Combine: Nothing to combine");
    const selfTx = $f25d125ea4ac600e$var$getTx(self);
    if (selfTx === undefined) throw new Error("Combine: Self missing transaction");
    const selfGlobalSet = $f25d125ea4ac600e$var$getKeySet(selfKeyVals.globalKeyVals);
    const selfInputSets = selfKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    const selfOutputSets = selfKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    for (const other of others){
        const otherTx = $f25d125ea4ac600e$var$getTx(other);
        if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) throw new Error("Combine: One of the Psbts does not have the same transaction.");
        const otherKeyVals = $8Damr.psbtToKeyVals(other);
        const otherGlobalSet = $f25d125ea4ac600e$var$getKeySet(otherKeyVals.globalKeyVals);
        otherGlobalSet.forEach($f25d125ea4ac600e$var$keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
        const otherInputSets = otherKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherInputSets.forEach((inputSet, idx)=>inputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx])));
        const otherOutputSets = otherKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherOutputSets.forEach((outputSet, idx)=>outputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx])));
    }
    return $8Damr.psbtFromKeyVals(selfTx, {
        globalMapKeyVals: selfKeyVals.globalKeyVals,
        inputKeyVals: selfKeyVals.inputKeyVals,
        outputKeyVals: selfKeyVals.outputKeyVals
    });
}
module.exports.combine = $f25d125ea4ac600e$var$combine;
function $f25d125ea4ac600e$var$keyPusher(selfSet, selfKeyVals, otherKeyVals) {
    return (key)=>{
        if (selfSet.has(key)) return;
        const newKv = otherKeyVals.filter((kv)=>kv.key.toString("hex") === key)[0];
        selfKeyVals.push(newKv);
        selfSet.add(key);
    };
}
function $f25d125ea4ac600e$var$getTx(psbt) {
    return psbt.globalMap.unsignedTx;
}
function $f25d125ea4ac600e$var$getKeySet(keyVals) {
    const set = new Set();
    keyVals.forEach((keyVal)=>{
        const hex = keyVal.key.toString("hex");
        if (set.has(hex)) throw new Error("Combine: KeyValue Map keys should be unique");
        set.add(hex);
    });
    return set;
}

});
parcelRegister("8Damr", function(module, exports) {
"use strict";
function $648a00b25642ba5f$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$648a00b25642ba5f$var$__export((parcelRequire("8zyJG")));

$648a00b25642ba5f$var$__export((parcelRequire("iWOny")));

});
parcelRegister("8zyJG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $63dc896e08abdb53$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");

var $qpq9i = parcelRequire("qpq9i");
function $63dc896e08abdb53$var$psbtFromBuffer(buffer, txGetter) {
    let offset = 0;
    function varSlice() {
        const keyLen = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.encodingLength(keyLen);
        const key = buffer.slice(offset, offset + keyLen);
        offset += keyLen;
        return key;
    }
    function readUInt32BE() {
        const num = buffer.readUInt32BE(offset);
        offset += 4;
        return num;
    }
    function readUInt8() {
        const num = buffer.readUInt8(offset);
        offset += 1;
        return num;
    }
    function getKeyValue() {
        const key = varSlice();
        const value = varSlice();
        return {
            key: key,
            value: value
        };
    }
    function checkEndOfKeyValPairs() {
        if (offset >= buffer.length) throw new Error("Format Error: Unexpected End of PSBT");
        const isEnd = buffer.readUInt8(offset) === 0;
        if (isEnd) offset++;
        return isEnd;
    }
    if (readUInt32BE() !== 0x70736274) throw new Error("Format Error: Invalid Magic Number");
    if (readUInt8() !== 0xff) throw new Error("Format Error: Magic Number must be followed by 0xff separator");
    const globalMapKeyVals = [];
    const globalKeyIndex = {};
    while(!checkEndOfKeyValPairs()){
        const keyVal = getKeyValue();
        const hexKey = keyVal.key.toString("hex");
        if (globalKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for global keymap: key " + hexKey);
        globalKeyIndex[hexKey] = 1;
        globalMapKeyVals.push(keyVal);
    }
    const unsignedTxMaps = globalMapKeyVals.filter((keyVal)=>keyVal.key[0] === $qpq9i.GlobalTypes.UNSIGNED_TX);
    if (unsignedTxMaps.length !== 1) throw new Error("Format Error: Only one UNSIGNED_TX allowed");
    const unsignedTx = txGetter(unsignedTxMaps[0].value);
    // Get input and output counts to loop the respective fields
    const { inputCount: inputCount, outputCount: outputCount } = unsignedTx.getInputOutputCounts();
    const inputKeyVals = [];
    const outputKeyVals = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const inputKeyIndex = {};
        const input = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (inputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each input: input index " + index + " key " + hexKey);
            inputKeyIndex[hexKey] = 1;
            input.push(keyVal);
        }
        inputKeyVals.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const outputKeyIndex = {};
        const output = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (outputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each output: output index " + index + " key " + hexKey);
            outputKeyIndex[hexKey] = 1;
            output.push(keyVal);
        }
        outputKeyVals.push(output);
    }
    return $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, {
        globalMapKeyVals: globalMapKeyVals,
        inputKeyVals: inputKeyVals,
        outputKeyVals: outputKeyVals
    });
}
module.exports.psbtFromBuffer = $63dc896e08abdb53$var$psbtFromBuffer;
function $63dc896e08abdb53$var$checkKeyBuffer(type, keyBuf, keyNum) {
    if (!keyBuf.equals($63dc896e08abdb53$require$Buffer.from([
        keyNum
    ]))) throw new Error(`Format Error: Invalid ${type} key: ${keyBuf.toString("hex")}`);
}
module.exports.checkKeyBuffer = $63dc896e08abdb53$var$checkKeyBuffer;
function $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, { globalMapKeyVals: globalMapKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals }) {
    // That was easy :-)
    const globalMap = {
        unsignedTx: unsignedTx
    };
    let txCount = 0;
    for (const keyVal of globalMapKeyVals)// If a globalMap item needs pubkey, uncomment
    // const pubkey = convert.globals.checkPubkey(keyVal);
    switch(keyVal.key[0]){
        case $qpq9i.GlobalTypes.UNSIGNED_TX:
            $63dc896e08abdb53$var$checkKeyBuffer("global", keyVal.key, $qpq9i.GlobalTypes.UNSIGNED_TX);
            if (txCount > 0) throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
            txCount++;
            break;
        case $qpq9i.GlobalTypes.GLOBAL_XPUB:
            if (globalMap.globalXpub === undefined) globalMap.globalXpub = [];
            globalMap.globalXpub.push($7H7c4.globals.globalXpub.decode(keyVal));
            break;
        default:
            // This will allow inclusion during serialization.
            if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
            globalMap.unknownKeyVals.push(keyVal);
    }
    // Get input and output counts to loop the respective fields
    const inputCount = inputKeyVals.length;
    const outputCount = outputKeyVals.length;
    const inputs = [];
    const outputs = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const input = {};
        for (const keyVal of inputKeyVals[index]){
            $7H7c4.inputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.InputTypes.NON_WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.NON_WITNESS_UTXO);
                    if (input.nonWitnessUtxo !== undefined) throw new Error("Format Error: Input has multiple NON_WITNESS_UTXO");
                    input.nonWitnessUtxo = $7H7c4.inputs.nonWitnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.WITNESS_UTXO);
                    if (input.witnessUtxo !== undefined) throw new Error("Format Error: Input has multiple WITNESS_UTXO");
                    input.witnessUtxo = $7H7c4.inputs.witnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.PARTIAL_SIG:
                    if (input.partialSig === undefined) input.partialSig = [];
                    input.partialSig.push($7H7c4.inputs.partialSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.SIGHASH_TYPE:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.SIGHASH_TYPE);
                    if (input.sighashType !== undefined) throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
                    input.sighashType = $7H7c4.inputs.sighashType.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.REDEEM_SCRIPT);
                    if (input.redeemScript !== undefined) throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
                    input.redeemScript = $7H7c4.inputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.WITNESS_SCRIPT);
                    if (input.witnessScript !== undefined) throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
                    input.witnessScript = $7H7c4.inputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.BIP32_DERIVATION:
                    if (input.bip32Derivation === undefined) input.bip32Derivation = [];
                    input.bip32Derivation.push($7H7c4.inputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTSIG:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTSIG);
                    input.finalScriptSig = $7H7c4.inputs.finalScriptSig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTWITNESS:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTWITNESS);
                    input.finalScriptWitness = $7H7c4.inputs.finalScriptWitness.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.POR_COMMITMENT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.POR_COMMITMENT);
                    input.porCommitment = $7H7c4.inputs.porCommitment.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_KEY_SIG:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_KEY_SIG);
                    input.tapKeySig = $7H7c4.inputs.tapKeySig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_SCRIPT_SIG:
                    if (input.tapScriptSig === undefined) input.tapScriptSig = [];
                    input.tapScriptSig.push($7H7c4.inputs.tapScriptSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_LEAF_SCRIPT:
                    if (input.tapLeafScript === undefined) input.tapLeafScript = [];
                    input.tapLeafScript.push($7H7c4.inputs.tapLeafScript.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_BIP32_DERIVATION:
                    if (input.tapBip32Derivation === undefined) input.tapBip32Derivation = [];
                    input.tapBip32Derivation.push($7H7c4.inputs.tapBip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_INTERNAL_KEY);
                    input.tapInternalKey = $7H7c4.inputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_MERKLE_ROOT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_MERKLE_ROOT);
                    input.tapMerkleRoot = $7H7c4.inputs.tapMerkleRoot.decode(keyVal);
                    break;
                default:
                    // This will allow inclusion during serialization.
                    if (!input.unknownKeyVals) input.unknownKeyVals = [];
                    input.unknownKeyVals.push(keyVal);
            }
        }
        inputs.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const output = {};
        for (const keyVal of outputKeyVals[index]){
            $7H7c4.outputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.OutputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.REDEEM_SCRIPT);
                    if (output.redeemScript !== undefined) throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
                    output.redeemScript = $7H7c4.outputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.WITNESS_SCRIPT);
                    if (output.witnessScript !== undefined) throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
                    output.witnessScript = $7H7c4.outputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.BIP32_DERIVATION:
                    if (output.bip32Derivation === undefined) output.bip32Derivation = [];
                    output.bip32Derivation.push($7H7c4.outputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.OutputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.TAP_INTERNAL_KEY);
                    output.tapInternalKey = $7H7c4.outputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_TREE:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.TAP_TREE);
                    output.tapTree = $7H7c4.outputs.tapTree.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_BIP32_DERIVATION:
                    if (output.tapBip32Derivation === undefined) output.tapBip32Derivation = [];
                    output.tapBip32Derivation.push($7H7c4.outputs.tapBip32Derivation.decode(keyVal));
                    break;
                default:
                    if (!output.unknownKeyVals) output.unknownKeyVals = [];
                    output.unknownKeyVals.push(keyVal);
            }
        }
        outputs.push(output);
    }
    return {
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    };
}
module.exports.psbtFromKeyVals = $63dc896e08abdb53$var$psbtFromKeyVals;

});
parcelRegister("7H7c4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $2M3mP = parcelRequire("2M3mP");

var $9CSLb = parcelRequire("9CSLb");

var $bHI13 = parcelRequire("bHI13");

var $gsMQz = parcelRequire("gsMQz");

var $fmNoO = parcelRequire("fmNoO");

var $9vZgw = parcelRequire("9vZgw");

var $ckVfp = parcelRequire("ckVfp");

var $eOKUK = parcelRequire("eOKUK");

var $bn4w6 = parcelRequire("bn4w6");

var $gJHsk = parcelRequire("gJHsk");

var $gOgEP = parcelRequire("gOgEP");

var $fvNw3 = parcelRequire("fvNw3");

var $eweRk = parcelRequire("eweRk");

var $jO9dJ = parcelRequire("jO9dJ");

var $7YFpq = parcelRequire("7YFpq");

var $iVrTH = parcelRequire("iVrTH");

var $62Nv9 = parcelRequire("62Nv9");

var $3RTes = parcelRequire("3RTes");

var $1Ya0J = parcelRequire("1Ya0J");

var $kSfZv = parcelRequire("kSfZv");
const $59a221109c575e6a$var$globals = {
    unsignedTx: $9CSLb,
    globalXpub: $2M3mP,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: $iVrTH.makeChecker([])
};
module.exports.globals = $59a221109c575e6a$var$globals;
const $59a221109c575e6a$var$inputs = {
    nonWitnessUtxo: $fmNoO,
    partialSig: $9vZgw,
    sighashType: $eOKUK,
    finalScriptSig: $bHI13,
    finalScriptWitness: $gsMQz,
    porCommitment: $ckVfp,
    witnessUtxo: $eweRk,
    bip32Derivation: $7YFpq.makeConverter($qpq9i.InputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.InputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.InputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.InputTypes.PARTIAL_SIG,
        $qpq9i.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: $bn4w6,
    tapScriptSig: $fvNw3,
    tapLeafScript: $gJHsk,
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.InputTypes.TAP_BIP32_DERIVATION),
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.InputTypes.TAP_INTERNAL_KEY),
    tapMerkleRoot: $gOgEP
};
module.exports.inputs = $59a221109c575e6a$var$inputs;
const $59a221109c575e6a$var$outputs = {
    bip32Derivation: $7YFpq.makeConverter($qpq9i.OutputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.OutputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.OutputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.OutputTypes.TAP_BIP32_DERIVATION),
    tapTree: $jO9dJ,
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.OutputTypes.TAP_INTERNAL_KEY)
};
module.exports.outputs = $59a221109c575e6a$var$outputs;

});
parcelRegister("qpq9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $04f625daf5ade9df$var$GlobalTypes;
(function(GlobalTypes) {
    GlobalTypes[GlobalTypes["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    GlobalTypes[GlobalTypes["GLOBAL_XPUB"] = 1] = "GLOBAL_XPUB";
})($04f625daf5ade9df$var$GlobalTypes = module.exports.GlobalTypes || (module.exports.GlobalTypes = {}));
module.exports.GLOBAL_TYPE_NAMES = [
    "unsignedTx",
    "globalXpub"
];
var $04f625daf5ade9df$var$InputTypes;
(function(InputTypes) {
    InputTypes[InputTypes["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    InputTypes[InputTypes["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    InputTypes[InputTypes["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    InputTypes[InputTypes["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    InputTypes[InputTypes["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    InputTypes[InputTypes["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    InputTypes[InputTypes["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    InputTypes[InputTypes["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    InputTypes[InputTypes["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    InputTypes[InputTypes["POR_COMMITMENT"] = 9] = "POR_COMMITMENT";
    InputTypes[InputTypes["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    InputTypes[InputTypes["TAP_SCRIPT_SIG"] = 20] = "TAP_SCRIPT_SIG";
    InputTypes[InputTypes["TAP_LEAF_SCRIPT"] = 21] = "TAP_LEAF_SCRIPT";
    InputTypes[InputTypes["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
    InputTypes[InputTypes["TAP_INTERNAL_KEY"] = 23] = "TAP_INTERNAL_KEY";
    InputTypes[InputTypes["TAP_MERKLE_ROOT"] = 24] = "TAP_MERKLE_ROOT";
})($04f625daf5ade9df$var$InputTypes = module.exports.InputTypes || (module.exports.InputTypes = {}));
module.exports.INPUT_TYPE_NAMES = [
    "nonWitnessUtxo",
    "witnessUtxo",
    "partialSig",
    "sighashType",
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "finalScriptSig",
    "finalScriptWitness",
    "porCommitment",
    "tapKeySig",
    "tapScriptSig",
    "tapLeafScript",
    "tapBip32Derivation",
    "tapInternalKey",
    "tapMerkleRoot"
];
var $04f625daf5ade9df$var$OutputTypes;
(function(OutputTypes) {
    OutputTypes[OutputTypes["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    OutputTypes[OutputTypes["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    OutputTypes[OutputTypes["BIP32_DERIVATION"] = 2] = "BIP32_DERIVATION";
    OutputTypes[OutputTypes["TAP_INTERNAL_KEY"] = 5] = "TAP_INTERNAL_KEY";
    OutputTypes[OutputTypes["TAP_TREE"] = 6] = "TAP_TREE";
    OutputTypes[OutputTypes["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($04f625daf5ade9df$var$OutputTypes = module.exports.OutputTypes || (module.exports.OutputTypes = {}));
module.exports.OUTPUT_TYPE_NAMES = [
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "tapInternalKey",
    "tapTree",
    "tapBip32Derivation"
];

});

parcelRegister("2M3mP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2052ad254c60a4b2$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
const $2052ad254c60a4b2$var$range = (n)=>[
        ...Array(n).keys()
    ];
function $2052ad254c60a4b2$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.GlobalTypes.GLOBAL_XPUB) throw new Error("Decode Error: could not decode globalXpub with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 79 || ![
        2,
        3
    ].includes(keyVal.key[46])) throw new Error("Decode Error: globalXpub has invalid extended pubkey in key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Global GLOBAL_XPUB value length should be multiple of 4");
    const extendedPubkey = keyVal.key.slice(1);
    const data = {
        masterFingerprint: keyVal.value.slice(0, 4),
        extendedPubkey: extendedPubkey,
        path: "m"
    };
    for (const i of $2052ad254c60a4b2$var$range(keyVal.value.length / 4 - 1)){
        const val = keyVal.value.readUInt32LE(i * 4 + 4);
        const isHard = !!(val & 0x80000000);
        const idx = val & 0x7fffffff;
        data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
    }
    return data;
}
module.exports.decode = $2052ad254c60a4b2$var$decode;
function $2052ad254c60a4b2$var$encode(data) {
    const head = $2052ad254c60a4b2$require$Buffer.from([
        $qpq9i.GlobalTypes.GLOBAL_XPUB
    ]);
    const key = $2052ad254c60a4b2$require$Buffer.concat([
        head,
        data.extendedPubkey
    ]);
    const splitPath = data.path.split("/");
    const value = $2052ad254c60a4b2$require$Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    let offset = 4;
    splitPath.slice(1).forEach((level)=>{
        const isHard = level.slice(-1) === "'";
        let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
        if (isHard) num += 0x80000000;
        value.writeUInt32LE(num, offset);
        offset += 4;
    });
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $2052ad254c60a4b2$var$encode;
module.exports.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
function $2052ad254c60a4b2$var$check(data) {
    const epk = data.extendedPubkey;
    const mfp = data.masterFingerprint;
    const p = data.path;
    return $2052ad254c60a4b2$require$Buffer.isBuffer(epk) && epk.length === 78 && [
        2,
        3
    ].indexOf(epk[45]) > -1 && $2052ad254c60a4b2$require$Buffer.isBuffer(mfp) && mfp.length === 4 && typeof p === "string" && !!p.match(/^m(\/\d+'?)*$/);
}
module.exports.check = $2052ad254c60a4b2$var$check;
function $2052ad254c60a4b2$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.extendedPubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.extendedPubkey.equals(item.extendedPubkey)).length === 0;
}
module.exports.canAddToArray = $2052ad254c60a4b2$var$canAddToArray;

});

parcelRegister("9CSLb", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $702223ddf4530a73$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $702223ddf4530a73$var$encode(data) {
    return {
        key: $702223ddf4530a73$require$Buffer.from([
            $qpq9i.GlobalTypes.UNSIGNED_TX
        ]),
        value: data.toBuffer()
    };
}
module.exports.encode = $702223ddf4530a73$var$encode;

});

parcelRegister("bHI13", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8855da8654d9bb8f$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8855da8654d9bb8f$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTSIG) throw new Error("Decode Error: could not decode finalScriptSig with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $8855da8654d9bb8f$var$decode;
function $8855da8654d9bb8f$var$encode(data) {
    const key = $8855da8654d9bb8f$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTSIG
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $8855da8654d9bb8f$var$encode;
module.exports.expected = "Buffer";
function $8855da8654d9bb8f$var$check(data) {
    return $8855da8654d9bb8f$require$Buffer.isBuffer(data);
}
module.exports.check = $8855da8654d9bb8f$var$check;
function $8855da8654d9bb8f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptSig === undefined;
}
module.exports.canAdd = $8855da8654d9bb8f$var$canAdd;

});

parcelRegister("gsMQz", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bfc526d659a6650b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $bfc526d659a6650b$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTWITNESS) throw new Error("Decode Error: could not decode finalScriptWitness with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $bfc526d659a6650b$var$decode;
function $bfc526d659a6650b$var$encode(data) {
    const key = $bfc526d659a6650b$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTWITNESS
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $bfc526d659a6650b$var$encode;
module.exports.expected = "Buffer";
function $bfc526d659a6650b$var$check(data) {
    return $bfc526d659a6650b$require$Buffer.isBuffer(data);
}
module.exports.check = $bfc526d659a6650b$var$check;
function $bfc526d659a6650b$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptWitness === undefined;
}
module.exports.canAdd = $bfc526d659a6650b$var$canAdd;

});

parcelRegister("fmNoO", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b2ff3ac145fbf7ad$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b2ff3ac145fbf7ad$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.NON_WITNESS_UTXO) throw new Error("Decode Error: could not decode nonWitnessUtxo with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $b2ff3ac145fbf7ad$var$decode;
function $b2ff3ac145fbf7ad$var$encode(data) {
    return {
        key: $b2ff3ac145fbf7ad$require$Buffer.from([
            $qpq9i.InputTypes.NON_WITNESS_UTXO
        ]),
        value: data
    };
}
module.exports.encode = $b2ff3ac145fbf7ad$var$encode;
module.exports.expected = "Buffer";
function $b2ff3ac145fbf7ad$var$check(data) {
    return $b2ff3ac145fbf7ad$require$Buffer.isBuffer(data);
}
module.exports.check = $b2ff3ac145fbf7ad$var$check;
function $b2ff3ac145fbf7ad$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.nonWitnessUtxo === undefined;
}
module.exports.canAdd = $b2ff3ac145fbf7ad$var$canAdd;

});

parcelRegister("9vZgw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6ed6885f6d3c4155$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $6ed6885f6d3c4155$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.PARTIAL_SIG) throw new Error("Decode Error: could not decode partialSig with key 0x" + keyVal.key.toString("hex"));
    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![
        2,
        3,
        4
    ].includes(keyVal.key[1])) throw new Error("Decode Error: partialSig has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1);
    return {
        pubkey: pubkey,
        signature: keyVal.value
    };
}
module.exports.decode = $6ed6885f6d3c4155$var$decode;
function $6ed6885f6d3c4155$var$encode(pSig) {
    const head = $6ed6885f6d3c4155$require$Buffer.from([
        $qpq9i.InputTypes.PARTIAL_SIG
    ]);
    return {
        key: $6ed6885f6d3c4155$require$Buffer.concat([
            head,
            pSig.pubkey
        ]),
        value: pSig.signature
    };
}
module.exports.encode = $6ed6885f6d3c4155$var$encode;
module.exports.expected = "{ pubkey: Buffer; signature: Buffer; }";
function $6ed6885f6d3c4155$var$check(data) {
    return $6ed6885f6d3c4155$require$Buffer.isBuffer(data.pubkey) && $6ed6885f6d3c4155$require$Buffer.isBuffer(data.signature) && [
        33,
        65
    ].includes(data.pubkey.length) && [
        2,
        3,
        4
    ].includes(data.pubkey[0]) && $6ed6885f6d3c4155$var$isDerSigWithSighash(data.signature);
}
module.exports.check = $6ed6885f6d3c4155$var$check;
function $6ed6885f6d3c4155$var$isDerSigWithSighash(buf) {
    if (!$6ed6885f6d3c4155$require$Buffer.isBuffer(buf) || buf.length < 9) return false;
    if (buf[0] !== 0x30) return false;
    if (buf.length !== buf[1] + 3) return false;
    if (buf[2] !== 0x02) return false;
    const rLen = buf[3];
    if (rLen > 33 || rLen < 1) return false;
    if (buf[3 + rLen + 1] !== 0x02) return false;
    const sLen = buf[3 + rLen + 2];
    if (sLen > 33 || sLen < 1) return false;
    if (buf.length !== 3 + rLen + 2 + sLen + 2) return false;
    return true;
}
function $6ed6885f6d3c4155$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
}
module.exports.canAddToArray = $6ed6885f6d3c4155$var$canAddToArray;

});

parcelRegister("ckVfp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8fb3c27476d0f9f4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8fb3c27476d0f9f4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.POR_COMMITMENT) throw new Error("Decode Error: could not decode porCommitment with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.toString("utf8");
}
module.exports.decode = $8fb3c27476d0f9f4$var$decode;
function $8fb3c27476d0f9f4$var$encode(data) {
    const key = $8fb3c27476d0f9f4$require$Buffer.from([
        $qpq9i.InputTypes.POR_COMMITMENT
    ]);
    return {
        key: key,
        value: $8fb3c27476d0f9f4$require$Buffer.from(data, "utf8")
    };
}
module.exports.encode = $8fb3c27476d0f9f4$var$encode;
module.exports.expected = "string";
function $8fb3c27476d0f9f4$var$check(data) {
    return typeof data === "string";
}
module.exports.check = $8fb3c27476d0f9f4$var$check;
function $8fb3c27476d0f9f4$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.porCommitment === undefined;
}
module.exports.canAdd = $8fb3c27476d0f9f4$var$canAdd;

});

parcelRegister("eOKUK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ac9a206413f62f80$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $ac9a206413f62f80$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.SIGHASH_TYPE) throw new Error("Decode Error: could not decode sighashType with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.readUInt32LE(0);
}
module.exports.decode = $ac9a206413f62f80$var$decode;
function $ac9a206413f62f80$var$encode(data) {
    const key = $ac9a206413f62f80$require$Buffer.from([
        $qpq9i.InputTypes.SIGHASH_TYPE
    ]);
    const value = $ac9a206413f62f80$require$Buffer.allocUnsafe(4);
    value.writeUInt32LE(data, 0);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $ac9a206413f62f80$var$encode;
module.exports.expected = "number";
function $ac9a206413f62f80$var$check(data) {
    return typeof data === "number";
}
module.exports.check = $ac9a206413f62f80$var$check;
function $ac9a206413f62f80$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.sighashType === undefined;
}
module.exports.canAdd = $ac9a206413f62f80$var$canAdd;

});

parcelRegister("bn4w6", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $847558a6a72418a0$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $847558a6a72418a0$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_KEY_SIG || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapKeySig with key 0x" + keyVal.key.toString("hex"));
    if (!$847558a6a72418a0$var$check(keyVal.value)) throw new Error("Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature");
    return keyVal.value;
}
module.exports.decode = $847558a6a72418a0$var$decode;
function $847558a6a72418a0$var$encode(value) {
    const key = $847558a6a72418a0$require$Buffer.from([
        $qpq9i.InputTypes.TAP_KEY_SIG
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $847558a6a72418a0$var$encode;
module.exports.expected = "Buffer";
function $847558a6a72418a0$var$check(data) {
    return $847558a6a72418a0$require$Buffer.isBuffer(data) && (data.length === 64 || data.length === 65);
}
module.exports.check = $847558a6a72418a0$var$check;
function $847558a6a72418a0$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapKeySig === undefined;
}
module.exports.canAdd = $847558a6a72418a0$var$canAdd;

});

parcelRegister("gJHsk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c2f28ec33344129a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c2f28ec33344129a$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_LEAF_SCRIPT) throw new Error("Decode Error: could not decode tapLeafScript with key 0x" + keyVal.key.toString("hex"));
    if ((keyVal.key.length - 2) % 32 !== 0) throw new Error("Decode Error: tapLeafScript has invalid control block in key 0x" + keyVal.key.toString("hex"));
    const leafVersion = keyVal.value[keyVal.value.length - 1];
    if ((keyVal.key[1] & 0xfe) !== leafVersion) throw new Error("Decode Error: tapLeafScript bad leaf version in key 0x" + keyVal.key.toString("hex"));
    const script = keyVal.value.slice(0, -1);
    const controlBlock = keyVal.key.slice(1);
    return {
        controlBlock: controlBlock,
        script: script,
        leafVersion: leafVersion
    };
}
module.exports.decode = $c2f28ec33344129a$var$decode;
function $c2f28ec33344129a$var$encode(tScript) {
    const head = $c2f28ec33344129a$require$Buffer.from([
        $qpq9i.InputTypes.TAP_LEAF_SCRIPT
    ]);
    const verBuf = $c2f28ec33344129a$require$Buffer.from([
        tScript.leafVersion
    ]);
    return {
        key: $c2f28ec33344129a$require$Buffer.concat([
            head,
            tScript.controlBlock
        ]),
        value: $c2f28ec33344129a$require$Buffer.concat([
            tScript.script,
            verBuf
        ])
    };
}
module.exports.encode = $c2f28ec33344129a$var$encode;
module.exports.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
function $c2f28ec33344129a$var$check(data) {
    return $c2f28ec33344129a$require$Buffer.isBuffer(data.controlBlock) && (data.controlBlock.length - 1) % 32 === 0 && (data.controlBlock[0] & 0xfe) === data.leafVersion && $c2f28ec33344129a$require$Buffer.isBuffer(data.script);
}
module.exports.check = $c2f28ec33344129a$var$check;
function $c2f28ec33344129a$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.controlBlock.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.controlBlock.equals(item.controlBlock)).length === 0;
}
module.exports.canAddToArray = $c2f28ec33344129a$var$canAddToArray;

});

parcelRegister("gOgEP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c3ce3caf0cf5c395$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c3ce3caf0cf5c395$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_MERKLE_ROOT || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapMerkleRoot with key 0x" + keyVal.key.toString("hex"));
    if (!$c3ce3caf0cf5c395$var$check(keyVal.value)) throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
    return keyVal.value;
}
module.exports.decode = $c3ce3caf0cf5c395$var$decode;
function $c3ce3caf0cf5c395$var$encode(value) {
    const key = $c3ce3caf0cf5c395$require$Buffer.from([
        $qpq9i.InputTypes.TAP_MERKLE_ROOT
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $c3ce3caf0cf5c395$var$encode;
module.exports.expected = "Buffer";
function $c3ce3caf0cf5c395$var$check(data) {
    return $c3ce3caf0cf5c395$require$Buffer.isBuffer(data) && data.length === 32;
}
module.exports.check = $c3ce3caf0cf5c395$var$check;
function $c3ce3caf0cf5c395$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapMerkleRoot === undefined;
}
module.exports.canAdd = $c3ce3caf0cf5c395$var$canAdd;

});

parcelRegister("fvNw3", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b4b0291bb9cf8fc4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b4b0291bb9cf8fc4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_SCRIPT_SIG) throw new Error("Decode Error: could not decode tapScriptSig with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length !== 64 && keyVal.value.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid signature in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1, 33);
    const leafHash = keyVal.key.slice(33);
    return {
        pubkey: pubkey,
        leafHash: leafHash,
        signature: keyVal.value
    };
}
module.exports.decode = $b4b0291bb9cf8fc4$var$decode;
function $b4b0291bb9cf8fc4$var$encode(tSig) {
    const head = $b4b0291bb9cf8fc4$require$Buffer.from([
        $qpq9i.InputTypes.TAP_SCRIPT_SIG
    ]);
    return {
        key: $b4b0291bb9cf8fc4$require$Buffer.concat([
            head,
            tSig.pubkey,
            tSig.leafHash
        ]),
        value: tSig.signature
    };
}
module.exports.encode = $b4b0291bb9cf8fc4$var$encode;
module.exports.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
function $b4b0291bb9cf8fc4$var$check(data) {
    return $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.pubkey) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.leafHash) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.signature) && data.pubkey.length === 32 && data.leafHash.length === 32 && (data.signature.length === 64 || data.signature.length === 65);
}
module.exports.check = $b4b0291bb9cf8fc4$var$check;
function $b4b0291bb9cf8fc4$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex") + item.leafHash.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey) && v.leafHash.equals(item.leafHash)).length === 0;
}
module.exports.canAddToArray = $b4b0291bb9cf8fc4$var$canAddToArray;

});

parcelRegister("eweRk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a91f948fd34f9dcc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");
function $a91f948fd34f9dcc$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.WITNESS_UTXO) throw new Error("Decode Error: could not decode witnessUtxo with key 0x" + keyVal.key.toString("hex"));
    const value = $3cFg7.readUInt64LE(keyVal.value, 0);
    let _offset = 8;
    const scriptLen = $gjBY1.decode(keyVal.value, _offset);
    _offset += $gjBY1.encodingLength(scriptLen);
    const script = keyVal.value.slice(_offset);
    if (script.length !== scriptLen) throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
    return {
        script: script,
        value: value
    };
}
module.exports.decode = $a91f948fd34f9dcc$var$decode;
function $a91f948fd34f9dcc$var$encode(data) {
    const { script: script, value: value } = data;
    const varintLen = $gjBY1.encodingLength(script.length);
    const result = $a91f948fd34f9dcc$require$Buffer.allocUnsafe(8 + varintLen + script.length);
    $3cFg7.writeUInt64LE(result, value, 0);
    $gjBY1.encode(script.length, result, 8);
    script.copy(result, 8 + varintLen);
    return {
        key: $a91f948fd34f9dcc$require$Buffer.from([
            $qpq9i.InputTypes.WITNESS_UTXO
        ]),
        value: result
    };
}
module.exports.encode = $a91f948fd34f9dcc$var$encode;
module.exports.expected = "{ script: Buffer; value: number; }";
function $a91f948fd34f9dcc$var$check(data) {
    return $a91f948fd34f9dcc$require$Buffer.isBuffer(data.script) && typeof data.value === "number";
}
module.exports.check = $a91f948fd34f9dcc$var$check;
function $a91f948fd34f9dcc$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.witnessUtxo === undefined;
}
module.exports.canAdd = $a91f948fd34f9dcc$var$canAdd;

});
parcelRegister("3cFg7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $25527f468d6fb9e3$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");
module.exports.range = (n)=>[
        ...Array(n).keys()
    ];
function $25527f468d6fb9e3$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $25527f468d6fb9e3$var$reverseBuffer;
function $25527f468d6fb9e3$var$keyValsToBuffer(keyVals) {
    const buffers = keyVals.map($25527f468d6fb9e3$var$keyValToBuffer);
    buffers.push($25527f468d6fb9e3$require$Buffer.from([
        0
    ]));
    return $25527f468d6fb9e3$require$Buffer.concat(buffers);
}
module.exports.keyValsToBuffer = $25527f468d6fb9e3$var$keyValsToBuffer;
function $25527f468d6fb9e3$var$keyValToBuffer(keyVal) {
    const keyLen = keyVal.key.length;
    const valLen = keyVal.value.length;
    const keyVarIntLen = $gjBY1.encodingLength(keyLen);
    const valVarIntLen = $gjBY1.encodingLength(valLen);
    const buffer = $25527f468d6fb9e3$require$Buffer.allocUnsafe(keyVarIntLen + keyLen + valVarIntLen + valLen);
    $gjBY1.encode(keyLen, buffer, 0);
    keyVal.key.copy(buffer, keyVarIntLen);
    $gjBY1.encode(valLen, buffer, keyVarIntLen + keyLen);
    keyVal.value.copy(buffer, keyVarIntLen + keyLen + valVarIntLen);
    return buffer;
}
module.exports.keyValToBuffer = $25527f468d6fb9e3$var$keyValToBuffer;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $25527f468d6fb9e3$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $25527f468d6fb9e3$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $25527f468d6fb9e3$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $25527f468d6fb9e3$var$readUInt64LE;
function $25527f468d6fb9e3$var$writeUInt64LE(buffer, value, offset) {
    $25527f468d6fb9e3$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $25527f468d6fb9e3$var$writeUInt64LE;

});
parcelRegister("gjBY1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $be0bdf280ebbccbc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Number.MAX_SAFE_INTEGER
const $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER = 9007199254740991;
function $be0bdf280ebbccbc$var$checkUInt53(n) {
    if (n < 0 || n > $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $be0bdf280ebbccbc$var$encode(_number, buffer, offset) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    if (!buffer) buffer = $be0bdf280ebbccbc$require$Buffer.allocUnsafe($be0bdf280ebbccbc$var$encodingLength(_number));
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (_number < 0xfd) {
        buffer.writeUInt8(_number, offset);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 1
        });
    // 16 bit
    } else if (_number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 3
        });
    // 32 bit
    } else if (_number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 5
        });
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(_number >>> 0, offset + 1);
        buffer.writeUInt32LE(_number / 0x100000000 | 0, offset + 5);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 9
        });
    }
    return buffer;
}
module.exports.encode = $be0bdf280ebbccbc$var$encode;
function $be0bdf280ebbccbc$var$decode(buffer, offset) {
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    const first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 1
        });
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 3
        });
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 5
        });
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 9
        });
        const lo = buffer.readUInt32LE(offset + 1);
        const hi = buffer.readUInt32LE(offset + 5);
        const _number = hi * 0x0100000000 + lo;
        $be0bdf280ebbccbc$var$checkUInt53(_number);
        return _number;
    }
}
module.exports.decode = $be0bdf280ebbccbc$var$decode;
function $be0bdf280ebbccbc$var$encodingLength(_number) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    return _number < 0xfd ? 1 : _number <= 0xffff ? 3 : _number <= 0xffffffff ? 5 : 9;
}
module.exports.encodingLength = $be0bdf280ebbccbc$var$encodingLength;

});



parcelRegister("jO9dJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e6b9d6da4db2882d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $gjBY1 = parcelRequire("gjBY1");
function $e6b9d6da4db2882d$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.OutputTypes.TAP_TREE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapTree with key 0x" + keyVal.key.toString("hex"));
    let _offset = 0;
    const data = [];
    while(_offset < keyVal.value.length){
        const depth = keyVal.value[_offset++];
        const leafVersion = keyVal.value[_offset++];
        const scriptLen = $gjBY1.decode(keyVal.value, _offset);
        _offset += $gjBY1.encodingLength(scriptLen);
        data.push({
            depth: depth,
            leafVersion: leafVersion,
            script: keyVal.value.slice(_offset, _offset + scriptLen)
        });
        _offset += scriptLen;
    }
    return {
        leaves: data
    };
}
module.exports.decode = $e6b9d6da4db2882d$var$decode;
function $e6b9d6da4db2882d$var$encode(tree) {
    const key = $e6b9d6da4db2882d$require$Buffer.from([
        $qpq9i.OutputTypes.TAP_TREE
    ]);
    const bufs = [].concat(...tree.leaves.map((tapLeaf)=>[
            $e6b9d6da4db2882d$require$Buffer.of(tapLeaf.depth, tapLeaf.leafVersion),
            $gjBY1.encode(tapLeaf.script.length),
            tapLeaf.script
        ]));
    return {
        key: key,
        value: $e6b9d6da4db2882d$require$Buffer.concat(bufs)
    };
}
module.exports.encode = $e6b9d6da4db2882d$var$encode;
module.exports.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
function $e6b9d6da4db2882d$var$check(data) {
    return Array.isArray(data.leaves) && data.leaves.every((tapLeaf)=>tapLeaf.depth >= 0 && tapLeaf.depth <= 128 && (tapLeaf.leafVersion & 0xfe) === tapLeaf.leafVersion && $e6b9d6da4db2882d$require$Buffer.isBuffer(tapLeaf.script));
}
module.exports.check = $e6b9d6da4db2882d$var$check;
function $e6b9d6da4db2882d$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapTree === undefined;
}
module.exports.canAdd = $e6b9d6da4db2882d$var$canAdd;

});

parcelRegister("7YFpq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5cee41fc3b21e94a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $5cee41fc3b21e94a$var$range = (n)=>[
        ...Array(n).keys()
    ];
const $5cee41fc3b21e94a$var$isValidDERKey = (pubkey)=>pubkey.length === 33 && [
        2,
        3
    ].includes(pubkey[0]) || pubkey.length === 65 && 4 === pubkey[0];
function $5cee41fc3b21e94a$var$makeConverter(TYPE_BYTE, isValidPubkey = $5cee41fc3b21e94a$var$isValidDERKey) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode bip32Derivation with key 0x" + keyVal.key.toString("hex"));
        const pubkey = keyVal.key.slice(1);
        if (!isValidPubkey(pubkey)) throw new Error("Decode Error: bip32Derivation has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Input BIP32_DERIVATION value length should be multiple of 4");
        const data = {
            masterFingerprint: keyVal.value.slice(0, 4),
            pubkey: pubkey,
            path: "m"
        };
        for (const i of $5cee41fc3b21e94a$var$range(keyVal.value.length / 4 - 1)){
            const val = keyVal.value.readUInt32LE(i * 4 + 4);
            const isHard = !!(val & 0x80000000);
            const idx = val & 0x7fffffff;
            data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
        }
        return data;
    }
    function encode(data) {
        const head = $5cee41fc3b21e94a$require$Buffer.from([
            TYPE_BYTE
        ]);
        const key = $5cee41fc3b21e94a$require$Buffer.concat([
            head,
            data.pubkey
        ]);
        const splitPath = data.path.split("/");
        const value = $5cee41fc3b21e94a$require$Buffer.allocUnsafe(splitPath.length * 4);
        data.masterFingerprint.copy(value, 0);
        let offset = 4;
        splitPath.slice(1).forEach((level)=>{
            const isHard = level.slice(-1) === "'";
            let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
            if (isHard) num += 0x80000000;
            value.writeUInt32LE(num, offset);
            offset += 4;
        });
        return {
            key: key,
            value: value
        };
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
    function check(data) {
        return $5cee41fc3b21e94a$require$Buffer.isBuffer(data.pubkey) && $5cee41fc3b21e94a$require$Buffer.isBuffer(data.masterFingerprint) && typeof data.path === "string" && isValidPubkey(data.pubkey) && data.masterFingerprint.length === 4;
    }
    function canAddToArray(array, item, dupeSet) {
        const dupeString = item.pubkey.toString("hex");
        if (dupeSet.has(dupeString)) return false;
        dupeSet.add(dupeString);
        return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: canAddToArray
    };
}
module.exports.makeConverter = $5cee41fc3b21e94a$var$makeConverter;

});

parcelRegister("iVrTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $dc7330b71df5261e$var$makeChecker(pubkeyTypes) {
    return checkPubkey;
    function checkPubkey(keyVal) {
        let pubkey;
        if (pubkeyTypes.includes(keyVal.key[0])) {
            pubkey = keyVal.key.slice(1);
            if (!(pubkey.length === 33 || pubkey.length === 65) || ![
                2,
                3,
                4
            ].includes(pubkey[0])) throw new Error("Format Error: invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        }
        return pubkey;
    }
}
module.exports.makeChecker = $dc7330b71df5261e$var$makeChecker;

});

parcelRegister("62Nv9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $466953f25b3e332a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $466953f25b3e332a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode redeemScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $466953f25b3e332a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $466953f25b3e332a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.redeemScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $466953f25b3e332a$var$makeConverter;

});

parcelRegister("3RTes", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d112a507e908169$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");

var $7YFpq = parcelRequire("7YFpq");
const $2d112a507e908169$var$isValidBIP340Key = (pubkey)=>pubkey.length === 32;
function $2d112a507e908169$var$makeConverter(TYPE_BYTE) {
    const parent = $7YFpq.makeConverter(TYPE_BYTE, $2d112a507e908169$var$isValidBIP340Key);
    function decode(keyVal) {
        const nHashes = $gjBY1.decode(keyVal.value);
        const nHashesLen = $gjBY1.encodingLength(nHashes);
        const base = parent.decode({
            key: keyVal.key,
            value: keyVal.value.slice(nHashesLen + nHashes * 32)
        });
        const leafHashes = new Array(nHashes);
        for(let i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32)leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
        return Object.assign({}, base, {
            leafHashes: leafHashes
        });
    }
    function encode(data) {
        const base = parent.encode(data);
        const nHashesLen = $gjBY1.encodingLength(data.leafHashes.length);
        const nHashesBuf = $2d112a507e908169$require$Buffer.allocUnsafe(nHashesLen);
        $gjBY1.encode(data.leafHashes.length, nHashesBuf);
        const value = $2d112a507e908169$require$Buffer.concat([
            nHashesBuf,
            ...data.leafHashes,
            base.value
        ]);
        return Object.assign({}, base, {
            value: value
        });
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function check(data) {
        return Array.isArray(data.leafHashes) && data.leafHashes.every((leafHash)=>$2d112a507e908169$require$Buffer.isBuffer(leafHash) && leafHash.length === 32) && parent.check(data);
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: parent.canAddToArray
    };
}
module.exports.makeConverter = $2d112a507e908169$var$makeConverter;

});

parcelRegister("1Ya0J", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $16f329006747ada3$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $16f329006747ada3$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapInternalKey with key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length !== 32) throw new Error("Decode Error: tapInternalKey not a 32-byte x-only pubkey");
        return keyVal.value;
    }
    function encode(value) {
        const key = $16f329006747ada3$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: value
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $16f329006747ada3$require$Buffer.isBuffer(data) && data.length === 32;
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.tapInternalKey === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $16f329006747ada3$var$makeConverter;

});

parcelRegister("kSfZv", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f3254142a84d7e3a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f3254142a84d7e3a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode witnessScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $f3254142a84d7e3a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $f3254142a84d7e3a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.witnessScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $f3254142a84d7e3a$var$makeConverter;

});



parcelRegister("iWOny", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $dcb4b8fdd10c0711$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");
function $dcb4b8fdd10c0711$var$psbtToBuffer({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    const { globalKeyVals: globalKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals } = $dcb4b8fdd10c0711$var$psbtToKeyVals({
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    });
    const globalBuffer = $3cFg7.keyValsToBuffer(globalKeyVals);
    const keyValsOrEmptyToBuffer = (keyVals)=>keyVals.length === 0 ? [
            $dcb4b8fdd10c0711$require$Buffer.from([
                0
            ])
        ] : keyVals.map($3cFg7.keyValsToBuffer);
    const inputBuffers = keyValsOrEmptyToBuffer(inputKeyVals);
    const outputBuffers = keyValsOrEmptyToBuffer(outputKeyVals);
    const header = $dcb4b8fdd10c0711$require$Buffer.allocUnsafe(5);
    header.writeUIntBE(0x70736274ff, 0, 5);
    return $dcb4b8fdd10c0711$require$Buffer.concat([
        header,
        globalBuffer
    ].concat(inputBuffers, outputBuffers));
}
module.exports.psbtToBuffer = $dcb4b8fdd10c0711$var$psbtToBuffer;
const $dcb4b8fdd10c0711$var$sortKeyVals = (a, b)=>{
    return a.key.compare(b.key);
};
function $dcb4b8fdd10c0711$var$keyValsFromMap(keyValMap, converterFactory) {
    const keyHexSet = new Set();
    const keyVals = Object.entries(keyValMap).reduce((result, [key, value])=>{
        if (key === "unknownKeyVals") return result;
        // We are checking for undefined anyways. So ignore TS error
        // @ts-ignore
        const converter = converterFactory[key];
        if (converter === undefined) return result;
        const encodedKeyVals = (Array.isArray(value) ? value : [
            value
        ]).map(converter.encode);
        const keyHexes = encodedKeyVals.map((kv)=>kv.key.toString("hex"));
        keyHexes.forEach((hex)=>{
            if (keyHexSet.has(hex)) throw new Error("Serialize Error: Duplicate key: " + hex);
            keyHexSet.add(hex);
        });
        return result.concat(encodedKeyVals);
    }, []);
    // Get other keyVals that have not yet been gotten
    const otherKeyVals = keyValMap.unknownKeyVals ? keyValMap.unknownKeyVals.filter((keyVal)=>{
        return !keyHexSet.has(keyVal.key.toString("hex"));
    }) : [];
    return keyVals.concat(otherKeyVals).sort($dcb4b8fdd10c0711$var$sortKeyVals);
}
function $dcb4b8fdd10c0711$var$psbtToKeyVals({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    // First parse the global keyVals
    // Get any extra keyvals to pass along
    return {
        globalKeyVals: $dcb4b8fdd10c0711$var$keyValsFromMap(globalMap, $7H7c4.globals),
        inputKeyVals: inputs.map((i)=>$dcb4b8fdd10c0711$var$keyValsFromMap(i, $7H7c4.inputs)),
        outputKeyVals: outputs.map((o)=>$dcb4b8fdd10c0711$var$keyValsFromMap(o, $7H7c4.outputs))
    };
}
module.exports.psbtToKeyVals = $dcb4b8fdd10c0711$var$psbtToKeyVals;

});



parcelRegister("geRUU", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bd27c6f06c7d7c23$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");
function $bd27c6f06c7d7c23$var$checkForInput(inputs, inputIndex) {
    const input = inputs[inputIndex];
    if (input === undefined) throw new Error(`No input #${inputIndex}`);
    return input;
}
module.exports.checkForInput = $bd27c6f06c7d7c23$var$checkForInput;
function $bd27c6f06c7d7c23$var$checkForOutput(outputs, outputIndex) {
    const output = outputs[outputIndex];
    if (output === undefined) throw new Error(`No output #${outputIndex}`);
    return output;
}
module.exports.checkForOutput = $bd27c6f06c7d7c23$var$checkForOutput;
function $bd27c6f06c7d7c23$var$checkHasKey(checkKeyVal, keyVals, enumLength) {
    if (checkKeyVal.key[0] < enumLength) throw new Error(`Use the method for your specific key instead of addUnknownKeyVal*`);
    if (keyVals && keyVals.filter((kv)=>kv.key.equals(checkKeyVal.key)).length !== 0) throw new Error(`Duplicate Key: ${checkKeyVal.key.toString("hex")}`);
}
module.exports.checkHasKey = $bd27c6f06c7d7c23$var$checkHasKey;
function $bd27c6f06c7d7c23$var$getEnumLength(myenum) {
    let count = 0;
    Object.keys(myenum).forEach((val)=>{
        if (Number(isNaN(Number(val)))) count++;
    });
    return count;
}
module.exports.getEnumLength = $bd27c6f06c7d7c23$var$getEnumLength;
function $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized(inputIndex, input) {
    let result = false;
    if (input.nonWitnessUtxo || input.witnessUtxo) {
        const needScriptSig = !!input.redeemScript;
        const needWitnessScript = !!input.witnessScript;
        const scriptSigOK = !needScriptSig || !!input.finalScriptSig;
        const witnessScriptOK = !needWitnessScript || !!input.finalScriptWitness;
        const hasOneFinal = !!input.finalScriptSig || !!input.finalScriptWitness;
        result = scriptSigOK && witnessScriptOK && hasOneFinal;
    }
    if (result === false) throw new Error(`Input #${inputIndex} has too much or too little data to clean`);
}
module.exports.inputCheckUncleanFinalized = $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized;
function $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data) {
    throw new Error(`Data for ${typeName} key ${name} is incorrect: Expected ` + `${expected} and got ${JSON.stringify(data)}`);
}
function $bd27c6f06c7d7c23$var$updateMaker(typeName) {
    return (updateData, mainData)=>{
        for (const name of Object.keys(updateData)){
            // @ts-ignore
            const data = updateData[name];
            // @ts-ignore
            const { canAdd: canAdd, canAddToArray: canAddToArray, check: check, expected: expected } = // @ts-ignore
            $7H7c4[typeName + "s"][name] || {};
            const isArray = !!canAddToArray;
            // If unknown data. ignore and do not add
            if (check) {
                if (isArray) {
                    if (!Array.isArray(data) || // @ts-ignore
                    mainData[name] && !Array.isArray(mainData[name])) throw new Error(`Key type ${name} must be an array`);
                    if (!data.every(check)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    // @ts-ignore
                    const arr = mainData[name] || [];
                    const dupeCheckSet = new Set();
                    if (!data.every((v)=>canAddToArray(arr, v, dupeCheckSet))) throw new Error("Can not add duplicate data to array");
                    // @ts-ignore
                    mainData[name] = arr.concat(data);
                } else {
                    if (!check(data)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    if (!canAdd(mainData, data)) throw new Error(`Can not add duplicate data to ${typeName}`);
                    // @ts-ignore
                    mainData[name] = data;
                }
            }
        }
    };
}
module.exports.updateGlobal = $bd27c6f06c7d7c23$var$updateMaker("global");
module.exports.updateInput = $bd27c6f06c7d7c23$var$updateMaker("input");
module.exports.updateOutput = $bd27c6f06c7d7c23$var$updateMaker("output");
function $bd27c6f06c7d7c23$var$addInputAttributes(inputs, data) {
    const index = inputs.length - 1;
    const input = $bd27c6f06c7d7c23$var$checkForInput(inputs, index);
    module.exports.updateInput(data, input);
}
module.exports.addInputAttributes = $bd27c6f06c7d7c23$var$addInputAttributes;
function $bd27c6f06c7d7c23$var$addOutputAttributes(outputs, data) {
    const index = outputs.length - 1;
    const output = $bd27c6f06c7d7c23$var$checkForOutput(outputs, index);
    module.exports.updateOutput(data, output);
}
module.exports.addOutputAttributes = $bd27c6f06c7d7c23$var$addOutputAttributes;
function $bd27c6f06c7d7c23$var$defaultVersionSetter(version, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Version: Invalid Transaction");
    txBuf.writeUInt32LE(version, 0);
    return txBuf;
}
module.exports.defaultVersionSetter = $bd27c6f06c7d7c23$var$defaultVersionSetter;
function $bd27c6f06c7d7c23$var$defaultLocktimeSetter(locktime, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Locktime: Invalid Transaction");
    txBuf.writeUInt32LE(locktime, txBuf.length - 4);
    return txBuf;
}
module.exports.defaultLocktimeSetter = $bd27c6f06c7d7c23$var$defaultLocktimeSetter;

});


parcelRegister("7rkx8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $56aafb8d6d11875d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkTaprootInputForSigs = module.exports.tapTreeFromList = module.exports.tapTreeToList = module.exports.tweakInternalPubKey = module.exports.checkTaprootOutputFields = module.exports.checkTaprootInputFields = module.exports.isTaprootOutput = module.exports.isTaprootInput = module.exports.serializeTaprootSignature = module.exports.tapScriptFinalizer = module.exports.toXOnly = void 0;

var $18Mz5 = parcelRequire("18Mz5");

var $gMJcK = parcelRequire("gMJcK");

var $9txdn = parcelRequire("9txdn");

var $lzIk8 = parcelRequire("lzIk8");

var $j87lX = parcelRequire("j87lX");

var $9txdn = parcelRequire("9txdn");
const $56aafb8d6d11875d$var$toXOnly = (pubKey)=>pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
module.exports.toXOnly = $56aafb8d6d11875d$var$toXOnly;
/**
 * Default tapscript finalizer. It searches for the `tapLeafHashToFinalize` if provided.
 * Otherwise it will search for the tapleaf that has at least one signature and has the shortest path.
 * @param inputIndex the position of the PSBT input.
 * @param input the PSBT input.
 * @param tapLeafHashToFinalize optional, if provided the finalizer will search for a tapleaf that has this hash
 *                              and will try to build the finalScriptWitness.
 * @returns the finalScriptWitness or throws an exception if no tapleaf found.
 */ function $56aafb8d6d11875d$var$tapScriptFinalizer(inputIndex, input, tapLeafHashToFinalize) {
    const tapLeaf = $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, tapLeafHashToFinalize);
    try {
        const sigs = $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf);
        const witness = sigs.concat(tapLeaf.script).concat(tapLeaf.controlBlock);
        return {
            finalScriptWitness: (0, $9txdn.witnessStackToScriptWitness)(witness)
        };
    } catch (err) {
        throw new Error(`Can not finalize taproot input #${inputIndex}: ${err}`);
    }
}
module.exports.tapScriptFinalizer = $56aafb8d6d11875d$var$tapScriptFinalizer;
function $56aafb8d6d11875d$var$serializeTaprootSignature(sig, sighashType) {
    const sighashTypeByte = sighashType ? $56aafb8d6d11875d$require$Buffer.from([
        sighashType
    ]) : $56aafb8d6d11875d$require$Buffer.from([]);
    return $56aafb8d6d11875d$require$Buffer.concat([
        sig,
        sighashTypeByte
    ]);
}
module.exports.serializeTaprootSignature = $56aafb8d6d11875d$var$serializeTaprootSignature;
function $56aafb8d6d11875d$var$isTaprootInput(input) {
    return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || input.witnessUtxo && (0, $9txdn.isP2TR)(input.witnessUtxo.script));
}
module.exports.isTaprootInput = $56aafb8d6d11875d$var$isTaprootInput;
function $56aafb8d6d11875d$var$isTaprootOutput(output, script) {
    return output && !!(output.tapInternalKey || output.tapTree || output.tapBip32Derivation && output.tapBip32Derivation.length || script && (0, $9txdn.isP2TR)(script));
}
module.exports.isTaprootOutput = $56aafb8d6d11875d$var$isTaprootOutput;
function $56aafb8d6d11875d$var$checkTaprootInputFields(inputData, newInputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action);
    $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action);
}
module.exports.checkTaprootInputFields = $56aafb8d6d11875d$var$checkTaprootInputFields;
function $56aafb8d6d11875d$var$checkTaprootOutputFields(outputData, newOutputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(outputData, newOutputData, action);
    $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData);
}
module.exports.checkTaprootOutputFields = $56aafb8d6d11875d$var$checkTaprootOutputFields;
function $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData) {
    if (!newOutputData.tapTree && !newOutputData.tapInternalKey) return;
    const tapInternalKey = newOutputData.tapInternalKey || outputData.tapInternalKey;
    const tapTree = newOutputData.tapTree || outputData.tapTree;
    if (tapInternalKey) {
        const { script: scriptPubkey } = outputData;
        const script = $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree);
        if (scriptPubkey && !scriptPubkey.equals(script)) throw new Error("Error adding output. Script or address missmatch.");
    }
}
function $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree) {
    const scriptTree = tapTree && $56aafb8d6d11875d$var$tapTreeFromList(tapTree.leaves);
    const { output: output } = (0, $j87lX.p2tr)({
        internalPubkey: tapInternalKey,
        scriptTree: scriptTree
    });
    return output;
}
function $56aafb8d6d11875d$var$tweakInternalPubKey(inputIndex, input) {
    const tapInternalKey = input.tapInternalKey;
    const outputKey = tapInternalKey && (0, $lzIk8.tweakKey)(tapInternalKey, input.tapMerkleRoot);
    if (!outputKey) throw new Error(`Cannot tweak tap internal key for input #${inputIndex}. Public key: ${tapInternalKey && tapInternalKey.toString("hex")}`);
    return outputKey.x;
}
module.exports.tweakInternalPubKey = $56aafb8d6d11875d$var$tweakInternalPubKey;
/**
 * Convert a binary tree to a BIP371 type list. Each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @param tree the binary tap tree
 * @returns a list of BIP 371 tapleaves
 */ function $56aafb8d6d11875d$var$tapTreeToList(tree) {
    if (!(0, $18Mz5.isTaptree)(tree)) throw new Error("Cannot convert taptree to tapleaf list. Expecting a tapree structure.");
    return $56aafb8d6d11875d$var$_tapTreeToList(tree);
}
module.exports.tapTreeToList = $56aafb8d6d11875d$var$tapTreeToList;
/**
 * Convert a BIP371 TapLeaf list to a TapTree (binary).
 * @param leaves a list of tapleaves where each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @returns the corresponding taptree, or throws an exception if the tree cannot be reconstructed
 */ function $56aafb8d6d11875d$var$tapTreeFromList(leaves = []) {
    if (leaves.length === 1 && leaves[0].depth === 0) return {
        output: leaves[0].script,
        version: leaves[0].leafVersion
    };
    return $56aafb8d6d11875d$var$instertLeavesInTree(leaves);
}
module.exports.tapTreeFromList = $56aafb8d6d11875d$var$tapTreeFromList;
function $56aafb8d6d11875d$var$checkTaprootInputForSigs(input, action) {
    const sigs = $56aafb8d6d11875d$var$extractTaprootSigs(input);
    return sigs.some((sig)=>(0, $9txdn.signatureBlocksAction)(sig, $56aafb8d6d11875d$var$decodeSchnorrSignature, action));
}
module.exports.checkTaprootInputForSigs = $56aafb8d6d11875d$var$checkTaprootInputForSigs;
function $56aafb8d6d11875d$var$decodeSchnorrSignature(signature) {
    return {
        signature: signature.slice(0, 64),
        hashType: signature.slice(64)[0] || $gMJcK.Transaction.SIGHASH_DEFAULT
    };
}
function $56aafb8d6d11875d$var$extractTaprootSigs(input) {
    const sigs = [];
    if (input.tapKeySig) sigs.push(input.tapKeySig);
    if (input.tapScriptSig) sigs.push(...input.tapScriptSig.map((s)=>s.signature));
    if (!sigs.length) {
        const finalTapKeySig = $56aafb8d6d11875d$var$getTapKeySigFromWithness(input.finalScriptWitness);
        if (finalTapKeySig) sigs.push(finalTapKeySig);
    }
    return sigs;
}
function $56aafb8d6d11875d$var$getTapKeySigFromWithness(finalScriptWitness) {
    if (!finalScriptWitness) return;
    const witness = finalScriptWitness.slice(2);
    // todo: add schnorr signature validation
    if (witness.length === 64 || witness.length === 65) return witness;
}
function $56aafb8d6d11875d$var$_tapTreeToList(tree, leaves = [], depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (!tree) return [];
    if ((0, $18Mz5.isTapleaf)(tree)) {
        leaves.push({
            depth: depth,
            leafVersion: tree.version || $lzIk8.LEAF_VERSION_TAPSCRIPT,
            script: tree.output
        });
        return leaves;
    }
    if (tree[0]) $56aafb8d6d11875d$var$_tapTreeToList(tree[0], leaves, depth + 1);
    if (tree[1]) $56aafb8d6d11875d$var$_tapTreeToList(tree[1], leaves, depth + 1);
    return leaves;
}
function $56aafb8d6d11875d$var$instertLeavesInTree(leaves) {
    let tree;
    for (const leaf of leaves){
        tree = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree);
        if (!tree) throw new Error(`No room left to insert tapleaf in tree`);
    }
    return tree;
}
function $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree, depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (leaf.depth === depth) {
        if (!tree) return {
            output: leaf.script,
            version: leaf.leafVersion
        };
        return;
    }
    if ((0, $18Mz5.isTapleaf)(tree)) return;
    const leftSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[0], depth + 1);
    if (leftSide) return [
        leftSide,
        tree && tree[1]
    ];
    const rightSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[1], depth + 1);
    if (rightSide) return [
        tree && tree[0],
        rightSide
    ];
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootInput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootInput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootInput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData); // todo: bad? use !===
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootOutput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootOutput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootOutput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
function $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action) {
    if (newInputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        const oldLeafsInTree = (inputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        if (!newLeafsInTree || !oldLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    } else if (inputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, inputData.tapMerkleRoot));
        if (!newLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    }
}
function $56aafb8d6d11875d$var$isTapLeafInTree(tapLeaf, merkleRoot) {
    if (!merkleRoot) return true;
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    const rootHash = (0, $lzIk8.rootHashFromPath)(tapLeaf.controlBlock, leafHash);
    return rootHash.equals(merkleRoot);
}
function $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    return (input.tapScriptSig || []).filter((tss)=>tss.leafHash.equals(leafHash)).map((tss)=>$56aafb8d6d11875d$var$addPubkeyPositionInScript(tapLeaf.script, tss)).sort((t1, t2)=>t2.positionInScript - t1.positionInScript).map((t)=>t.signature);
}
function $56aafb8d6d11875d$var$addPubkeyPositionInScript(script, tss) {
    return Object.assign({
        positionInScript: (0, $9txdn.pubkeyPositionInScript)(tss.pubkey, script)
    }, tss);
}
/**
 * Find tapleaf by hash, or get the signed tapleaf with the shortest path.
 */ function $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, leafHashToFinalize) {
    if (!input.tapScriptSig || !input.tapScriptSig.length) throw new Error(`Can not finalize taproot input #${inputIndex}. No tapleaf script signature provided.`);
    const tapLeaf = (input.tapLeafScript || []).sort((a, b)=>a.controlBlock.length - b.controlBlock.length).find((leaf)=>$56aafb8d6d11875d$var$canFinalizeLeaf(leaf, input.tapScriptSig, leafHashToFinalize));
    if (!tapLeaf) throw new Error(`Can not finalize taproot input #${inputIndex}. Signature for tapleaf script not found.`);
    return tapLeaf;
}
function $56aafb8d6d11875d$var$canFinalizeLeaf(leaf, tapScriptSig, hash) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: leaf.script,
        version: leaf.leafVersion
    });
    const whiteListedHash = !hash || hash.equals(leafHash);
    return whiteListedHash && tapScriptSig.find((tss)=>tss.leafHash.equals(leafHash)) !== undefined;
}
function $56aafb8d6d11875d$var$hasNonTaprootFields(io) {
    return io && !!(io.redeemScript || io.witnessScript || io.bip32Derivation && io.bip32Derivation.length);
}

});
parcelRegister("9txdn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6e60963a04e48e3d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signatureBlocksAction = module.exports.checkInputForSig = module.exports.pubkeyInScript = module.exports.pubkeyPositionInScript = module.exports.witnessStackToScriptWitness = module.exports.isP2TR = module.exports.isP2SHScript = module.exports.isP2WSHScript = module.exports.isP2WPKH = module.exports.isP2PKH = module.exports.isP2PK = module.exports.isP2MS = void 0;

var $gjBY1 = parcelRequire("gjBY1");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $lgTFk = parcelRequire("lgTFk");

var $j87lX = parcelRequire("j87lX");
function $6e60963a04e48e3d$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
module.exports.isP2MS = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2ms);
module.exports.isP2PK = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pk);
module.exports.isP2PKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pkh);
module.exports.isP2WPKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wpkh);
module.exports.isP2WSHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wsh);
module.exports.isP2SHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2sh);
module.exports.isP2TR = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2tr);
function $6e60963a04e48e3d$var$witnessStackToScriptWitness(witness) {
    let buffer = $6e60963a04e48e3d$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
module.exports.witnessStackToScriptWitness = $6e60963a04e48e3d$var$witnessStackToScriptWitness;
function $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) {
    const pubkeyHash = (0, $lgTFk.hash160)(pubkey);
    const pubkeyXOnly = pubkey.slice(1, 33); // slice before calling?
    const decompiled = $8wAtk.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.findIndex((element)=>{
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash) || element.equals(pubkeyXOnly);
    });
}
module.exports.pubkeyPositionInScript = $6e60963a04e48e3d$var$pubkeyPositionInScript;
function $6e60963a04e48e3d$var$pubkeyInScript(pubkey, script) {
    return $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) !== -1;
}
module.exports.pubkeyInScript = $6e60963a04e48e3d$var$pubkeyInScript;
function $6e60963a04e48e3d$var$checkInputForSig(input, action) {
    const pSigs = $6e60963a04e48e3d$var$extractPartialSigs(input);
    return pSigs.some((pSig)=>$6e60963a04e48e3d$var$signatureBlocksAction(pSig, $8wAtk.signature.decode, action));
}
module.exports.checkInputForSig = $6e60963a04e48e3d$var$checkInputForSig;
function $6e60963a04e48e3d$var$signatureBlocksAction(signature, signatureDecodeFn, action) {
    const { hashType: hashType } = signatureDecodeFn(signature);
    const whitelist = [];
    const isAnyoneCanPay = hashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY;
    if (isAnyoneCanPay) whitelist.push("addInput");
    const hashMod = hashType & 0x1f;
    switch(hashMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
        case $gMJcK.Transaction.SIGHASH_NONE:
            whitelist.push("addOutput");
            whitelist.push("setInputSequence");
            break;
    }
    if (whitelist.indexOf(action) === -1) return true;
    return false;
}
module.exports.signatureBlocksAction = $6e60963a04e48e3d$var$signatureBlocksAction;
function $6e60963a04e48e3d$var$extractPartialSigs(input) {
    let pSigs = [];
    if ((input.partialSig || []).length === 0) {
        if (!input.finalScriptSig && !input.finalScriptWitness) return [];
        pSigs = $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input);
    } else pSigs = input.partialSig;
    return pSigs.map((p)=>p.signature);
}
function $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $8wAtk.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $8wAtk.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $6e60963a04e48e3d$require$Buffer.isBuffer(item) && $8wAtk.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}

});




parcelRegister("8rRzQ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $626a67a10dc4b88a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.unsafeFrom64bitLE = module.exports.unsafeTo64bitLE = void 0;

var $8GOLq = parcelRequire("8GOLq");
function $626a67a10dc4b88a$var$unsafeTo64bitLE(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const byteArray = $626a67a10dc4b88a$require$Buffer.alloc(8, 0);
    for(let index = 0; index < byteArray.length; index++){
        const byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
module.exports.unsafeTo64bitLE = $626a67a10dc4b88a$var$unsafeTo64bitLE;
function $626a67a10dc4b88a$var$unsafeFrom64bitLE(byteArray) {
    let value = 0;
    if (byteArray.length != 8) throw new Error("Expected Bufffer of lenght 8");
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(let i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
module.exports.unsafeFrom64bitLE = $626a67a10dc4b88a$var$unsafeFrom64bitLE;
class $626a67a10dc4b88a$var$BufferWriter {
    constructor(){
        this.bufs = [];
    }
    write(alloc, fn) {
        const b = $626a67a10dc4b88a$require$Buffer.alloc(alloc);
        fn(b);
        this.bufs.push(b);
    }
    writeUInt8(i) {
        this.write(1, (b)=>b.writeUInt8(i, 0));
    }
    writeInt32(i) {
        this.write(4, (b)=>b.writeInt32LE(i, 0));
    }
    writeUInt32(i) {
        this.write(4, (b)=>b.writeUInt32LE(i, 0));
    }
    writeUInt64(i) {
        const bytes = $626a67a10dc4b88a$var$unsafeTo64bitLE(i);
        this.writeSlice(bytes);
    }
    writeVarInt(i) {
        this.bufs.push((0, $8GOLq.createVarint)(i));
    }
    writeSlice(slice) {
        this.bufs.push($626a67a10dc4b88a$require$Buffer.from(slice));
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    buffer() {
        return $626a67a10dc4b88a$require$Buffer.concat(this.bufs);
    }
}
module.exports.BufferWriter = $626a67a10dc4b88a$var$BufferWriter;
class $626a67a10dc4b88a$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
    }
    available() {
        return this.buffer.length - this.offset;
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const buf = this.readSlice(8);
        return $626a67a10dc4b88a$var$unsafeFrom64bitLE(buf);
    }
    readVarInt() {
        const [vi, vi_size] = (0, $8GOLq.parseVarint)(this.buffer, this.offset);
        this.offset += vi_size;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        const n = (0, $8GOLq.sanitizeBigintToNumber)(this.readVarInt());
        return this.readSlice(n);
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $626a67a10dc4b88a$var$BufferReader;

});
parcelRegister("8GOLq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $65399fa1584d746d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVarint = module.exports.parseVarint = module.exports.sanitizeBigintToNumber = void 0;
function $65399fa1584d746d$var$bigintToSmallEndian(value, length, buffer, offset) {
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error("Buffer too small");
        buffer[i + offset] = Number(value % BigInt(256));
        value = value >> BigInt(8);
    }
}
function $65399fa1584d746d$var$smallEndianToBigint(buffer, offset, length) {
    let result = BigInt(0);
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error("Buffer too small");
        result += BigInt(buffer[i + offset]) << BigInt(i * 8);
    }
    return result;
}
/**
 * Converts a `bigint` to a `number` if it non-negative and at most MAX_SAFE_INTEGER; throws `RangeError` otherwise.
 * Used when converting a Bitcoin-style varint to a `number`, since varints could be larger than what the `Number`
 * class can represent without loss of precision.
 *
 * @param n the number to convert
 * @returns `n` as a `number`
 */ function $65399fa1584d746d$var$sanitizeBigintToNumber(n) {
    if (n < 0) throw RangeError("Negative bigint is not a valid varint");
    if (n > Number.MAX_SAFE_INTEGER) throw RangeError("Too large for a Number");
    return Number(n);
}
module.exports.sanitizeBigintToNumber = $65399fa1584d746d$var$sanitizeBigintToNumber;
function $65399fa1584d746d$var$getVarintSize(value) {
    if (typeof value == "number") value = $65399fa1584d746d$var$sanitizeBigintToNumber(value);
    if (value < BigInt(0)) throw new RangeError("Negative numbers are not supported");
    if (value >= BigInt(1) << BigInt(64)) throw new RangeError("Too large for a Bitcoin-style varint");
    if (value < BigInt(0xfd)) return 1;
    else if (value <= BigInt(0xffff)) return 3;
    else if (value <= BigInt(0xffffffff)) return 5;
    else return 9;
}
/**
 * Parses a Bitcoin-style variable length integer from a buffer, starting at the given `offset`. Returns a pair
 * containing the parsed `BigInt`, and its length in bytes from the buffer.
 *
 * @param data the `Buffer` from which the variable-length integer is read
 * @param offset a non-negative offset to read from
 * @returns a pair where the first element is the parsed BigInt, and the second element is the length in bytes parsed
 * from the buffer.
 *
 * @throws `RangeError` if offset is negative.
 * @throws `Error` if the buffer's end is reached withut parsing being completed.
 */ function $65399fa1584d746d$var$parseVarint(data, offset) {
    if (offset < 0) throw RangeError("Negative offset is invalid");
    if (data[offset] == undefined) throw Error("Buffer too small");
    if (data[offset] < 0xfd) return [
        BigInt(data[offset]),
        1
    ];
    else {
        let size;
        if (data[offset] === 0xfd) size = 2;
        else if (data[offset] === 0xfe) size = 4;
        else size = 8;
        return [
            $65399fa1584d746d$var$smallEndianToBigint(data, offset + 1, size),
            size + 1
        ];
    }
}
module.exports.parseVarint = $65399fa1584d746d$var$parseVarint;
function $65399fa1584d746d$var$createVarint(value) {
    if (typeof value == "number") value = $65399fa1584d746d$var$sanitizeBigintToNumber(value);
    const size = $65399fa1584d746d$var$getVarintSize(value);
    value = BigInt(value);
    const buffer = $65399fa1584d746d$require$Buffer.alloc(size);
    if (size == 1) buffer[0] = Number(value);
    else {
        if (size == 3) buffer[0] = 0xfd;
        else if (size === 5) buffer[0] = 0xfe;
        else buffer[0] = 0xff;
        $65399fa1584d746d$var$bigintToSmallEndian(value, size - 1, buffer, 1);
    }
    return buffer;
}
module.exports.createVarint = $65399fa1584d746d$var$createVarint;

});


parcelRegister("goh0i", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $beec13d4254150cc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashLeaf = module.exports.Merkle = void 0;

var $3wrUl = parcelRequire("3wrUl");
/**
 * This class implements the merkle tree used by Ledger Bitcoin app v2+,
 * which is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md
 */ class $beec13d4254150cc$var$Merkle {
    constructor(leaves, hasher = $3wrUl.crypto.sha256){
        this.leaves = leaves;
        this.h = hasher;
        const nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    getRoot() {
        return this.rootNode.hash;
    }
    size() {
        return this.leaves.length;
    }
    getLeaves() {
        return this.leaves;
    }
    getLeafHash(index) {
        return this.leafNodes[index].hash;
    }
    getProof(index) {
        if (index >= this.leaves.length) throw Error("Index out of bounds");
        return $beec13d4254150cc$var$proveNode(this.leafNodes[index]);
    }
    calculateRoot(leaves) {
        const n = leaves.length;
        if (n == 0) return {
            root: new $beec13d4254150cc$var$Node(undefined, undefined, $beec13d4254150cc$require$Buffer.alloc(32, 0)),
            leaves: []
        };
        if (n == 1) {
            const newNode = new $beec13d4254150cc$var$Node(undefined, undefined, leaves[0]);
            return {
                root: newNode,
                leaves: [
                    newNode
                ]
            };
        }
        const leftCount = $beec13d4254150cc$var$highestPowerOf2LessThan(n);
        const leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
        const rightBranch = this.calculateRoot(leaves.slice(leftCount));
        const leftChild = leftBranch.root;
        const rightChild = rightBranch.root;
        const hash = this.hashNode(leftChild.hash, rightChild.hash);
        const node = new $beec13d4254150cc$var$Node(leftChild, rightChild, hash);
        leftChild.parent = node;
        rightChild.parent = node;
        return {
            root: node,
            leaves: leftBranch.leaves.concat(rightBranch.leaves)
        };
    }
    hashNode(left, right) {
        return this.h($beec13d4254150cc$require$Buffer.concat([
            $beec13d4254150cc$require$Buffer.from([
                1
            ]),
            left,
            right
        ]));
    }
}
module.exports.Merkle = $beec13d4254150cc$var$Merkle;
function $beec13d4254150cc$var$hashLeaf(buf, hashFunction = $3wrUl.crypto.sha256) {
    return $beec13d4254150cc$var$hashConcat($beec13d4254150cc$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
module.exports.hashLeaf = $beec13d4254150cc$var$hashLeaf;
function $beec13d4254150cc$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($beec13d4254150cc$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
class $beec13d4254150cc$var$Node {
    constructor(left, right, hash){
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    isLeaf() {
        return this.leftChild == undefined;
    }
}
function $beec13d4254150cc$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error("Expected right child to exist");
        return [
            node.parent.rightChild.hash,
            ...$beec13d4254150cc$var$proveNode(node.parent)
        ];
    } else {
        if (!node.parent.leftChild) throw new Error("Expected left child to exist");
        return [
            node.parent.leftChild.hash,
            ...$beec13d4254150cc$var$proveNode(node.parent)
        ];
    }
}
function $beec13d4254150cc$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error("Expected n >= 2");
    if ($beec13d4254150cc$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $beec13d4254150cc$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}

});


parcelRegister("bUD38", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8ac337153aed10db$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkelizedPsbt = void 0;

var $flljP = parcelRequire("flljP");

var $fUsjC = parcelRequire("fUsjC");
/**
 * This class merkelizes a PSBTv2, by merkelizing the different
 * maps of the psbt. This is used during the transaction signing process,
 * where the hardware app can request specific parts of the psbt from the
 * client code and be sure that the response data actually belong to the psbt.
 * The reason for this is the limited amount of memory available to the app,
 * so it can't always store the full psbt in memory.
 *
 * The signing process is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#sign_psbt
 */ class $8ac337153aed10db$var$MerkelizedPsbt extends $fUsjC.PsbtV2 {
    constructor(psbt){
        super();
        this.inputMerkleMaps = [];
        this.outputMerkleMaps = [];
        psbt.copy(this);
        this.globalMerkleMap = $8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.globalMap);
        for(let i = 0; i < this.getGlobalInputCount(); i++)this.inputMerkleMaps.push($8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.inputMaps[i]));
        this.inputMapCommitments = [
            ...this.inputMerkleMaps.values()
        ].map((v)=>v.commitment());
        for(let i = 0; i < this.getGlobalOutputCount(); i++)this.outputMerkleMaps.push($8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.outputMaps[i]));
        this.outputMapCommitments = [
            ...this.outputMerkleMaps.values()
        ].map((v)=>v.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
        return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
        return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(map) {
        const sortedKeysStrings = [
            ...map.keys()
        ].sort();
        const values = sortedKeysStrings.map((k)=>{
            const v = map.get(k);
            if (!v) throw new Error("No value for key " + k);
            return v;
        });
        const sortedKeys = sortedKeysStrings.map((k)=>$8ac337153aed10db$require$Buffer.from(k, "hex"));
        return new $flljP.MerkleMap(sortedKeys, values);
    }
}
module.exports.MerkelizedPsbt = $8ac337153aed10db$var$MerkelizedPsbt;

});
parcelRegister("flljP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b2b95aa8c594b0f4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkleMap = void 0;

var $goh0i = parcelRequire("goh0i");

var $8GOLq = parcelRequire("8GOLq");
/**
 * This implements "Merkelized Maps", documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md#merkleized-maps
 *
 * A merkelized map consist of two merkle trees, one for the keys of
 * a map and one for the values of the same map, thus the two merkle
 * trees have the same shape. The commitment is the number elements
 * in the map followed by the keys' merkle root followed by the
 * values' merkle root.
 */ class $b2b95aa8c594b0f4$var$MerkleMap {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */ constructor(keys, values){
        if (keys.length != values.length) throw new Error("keys and values should have the same length");
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(let i = 0; i < keys.length - 1; i++){
            if (keys[i].toString("hex") >= keys[i + 1].toString("hex")) throw new Error("keys must be in strictly increasing order");
        }
        this.keys = keys;
        this.keysTree = new $goh0i.Merkle(keys.map((k)=>(0, $goh0i.hashLeaf)(k)));
        this.values = values;
        this.valuesTree = new $goh0i.Merkle(values.map((v)=>(0, $goh0i.hashLeaf)(v)));
    }
    commitment() {
        // returns a buffer between 65 and 73 (included) bytes long
        return $b2b95aa8c594b0f4$require$Buffer.concat([
            (0, $8GOLq.createVarint)(this.keys.length),
            this.keysTree.getRoot(),
            this.valuesTree.getRoot()
        ]);
    }
}
module.exports.MerkleMap = $b2b95aa8c594b0f4$var$MerkleMap;

});

parcelRegister("fUsjC", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b9520cdb7ab7b6f5$require$Buffer = $6ZWSX.Buffer;
"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */ var $b9520cdb7ab7b6f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9520cdb7ab7b6f5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b9520cdb7ab7b6f5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b9520cdb7ab7b6f5$var$__createBinding(result, mod, k);
    }
    $b9520cdb7ab7b6f5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PsbtV2 = module.exports.NoSuchEntry = module.exports.psbtOut = module.exports.psbtIn = module.exports.psbtGlobal = void 0;

const $b9520cdb7ab7b6f5$var$bjs = $b9520cdb7ab7b6f5$var$__importStar((parcelRequire("3wrUl")));

var $8rRzQ = parcelRequire("8rRzQ");

var $8GOLq = parcelRequire("8GOLq");
var $b9520cdb7ab7b6f5$var$psbtGlobal;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    psbtGlobal[psbtGlobal["XPUB"] = 1] = "XPUB";
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($b9520cdb7ab7b6f5$var$psbtGlobal = module.exports.psbtGlobal || (module.exports.psbtGlobal = {}));
var $b9520cdb7ab7b6f5$var$psbtIn;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($b9520cdb7ab7b6f5$var$psbtIn = module.exports.psbtIn || (module.exports.psbtIn = {}));
var $b9520cdb7ab7b6f5$var$psbtOut;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($b9520cdb7ab7b6f5$var$psbtOut = module.exports.psbtOut || (module.exports.psbtOut = {}));
const $b9520cdb7ab7b6f5$var$PSBT_MAGIC_BYTES = $b9520cdb7ab7b6f5$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
class $b9520cdb7ab7b6f5$var$NoSuchEntry extends Error {
}
module.exports.NoSuchEntry = $b9520cdb7ab7b6f5$var$NoSuchEntry;
/**
 * Implements Partially Signed Bitcoin Transaction version 2, BIP370, as
 * documented at https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki
 * and https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki
 *
 * A psbt is a data structure that can carry all relevant information about a
 * transaction through all stages of the signing process. From constructing an
 * unsigned transaction to extracting the final serialized transaction ready for
 * broadcast.
 *
 * This implementation is limited to what's needed in ledgerjs to carry out its
 * duties, which means that support for features like multisig or taproot script
 * path spending are not implemented. Specifically, it supports p2pkh,
 * p2wpkhWrappedInP2sh, p2wpkh and p2tr key path spending.
 *
 * This class is made purposefully dumb, so it's easy to add support for
 * complemantary fields as needed in the future.
 */ class $b9520cdb7ab7b6f5$var$PsbtV2 {
    constructor(){
        this.globalMap = new Map();
        this.inputMaps = [];
        this.outputMaps = [];
    }
    setGlobalTxVersion(version) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_VERSION, $b9520cdb7ab7b6f5$var$uint32LE(version));
    }
    getGlobalTxVersion() {
        return this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(locktime) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.FALLBACK_LOCKTIME, $b9520cdb7ab7b6f5$var$uint32LE(locktime));
    }
    getGlobalFallbackLocktime() {
        var _a;
        return (_a = this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.FALLBACK_LOCKTIME)) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0);
    }
    setGlobalInputCount(inputCount) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.INPUT_COUNT, $b9520cdb7ab7b6f5$var$varint(inputCount));
    }
    getGlobalInputCount() {
        return $b9520cdb7ab7b6f5$var$fromVarint(this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.INPUT_COUNT));
    }
    setGlobalOutputCount(outputCount) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.OUTPUT_COUNT, $b9520cdb7ab7b6f5$var$varint(outputCount));
    }
    getGlobalOutputCount() {
        return $b9520cdb7ab7b6f5$var$fromVarint(this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(byte) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_MODIFIABLE, byte);
    }
    getGlobalTxModifiable() {
        return this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(psbtVersion) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION, $b9520cdb7ab7b6f5$var$uint32LE(psbtVersion));
    }
    getGlobalPsbtVersion() {
        return this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(inputIndex, transaction) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.NON_WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b(), transaction);
    }
    getInputNonWitnessUtxo(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.NON_WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b());
    }
    setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeSlice($b9520cdb7ab7b6f5$var$uint64LE(amount));
        buf.writeVarSlice(scriptPubKey);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b(), buf.buffer());
    }
    getInputWitnessUtxo(inputIndex) {
        const utxo = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b());
        if (!utxo) return undefined;
        const buf = new $8rRzQ.BufferReader(utxo);
        return {
            amount: (0, $8rRzQ.unsafeFrom64bitLE)(buf.readSlice(8)),
            scriptPubKey: buf.readVarSlice()
        };
    }
    setInputPartialSig(inputIndex, pubkey, signature) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PARTIAL_SIG, pubkey, signature);
    }
    getInputPartialSig(inputIndex, pubkey) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PARTIAL_SIG, pubkey);
    }
    setInputSighashType(inputIndex, sigHashtype) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SIGHASH_TYPE, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(sigHashtype));
    }
    getInputSighashType(inputIndex) {
        const result = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SIGHASH_TYPE, $b9520cdb7ab7b6f5$var$b());
        if (!result) return undefined;
        return result.readUInt32LE(0);
    }
    setInputRedeemScript(inputIndex, redeemScript) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b(), redeemScript);
    }
    getInputRedeemScript(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setInputWitnessScript(inputIndex, witnessScript) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_SCRIPT, $b9520cdb7ab7b6f5$var$b(), witnessScript);
    }
    getInputWitnessScript(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
        if (pubkey.length != 33) throw new Error("Invalid pubkey length: " + pubkey.length);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getInputBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.BIP32_DERIVATION, pubkey);
        if (!buf) return undefined;
        return this.decodeBip32Derivation(buf);
    }
    setInputFinalScriptsig(inputIndex, scriptSig) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTSIG, $b9520cdb7ab7b6f5$var$b(), scriptSig);
    }
    getInputFinalScriptsig(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTSIG, $b9520cdb7ab7b6f5$var$b());
    }
    setInputFinalScriptwitness(inputIndex, scriptWitness) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTWITNESS, $b9520cdb7ab7b6f5$var$b(), scriptWitness);
    }
    getInputFinalScriptwitness(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTWITNESS, $b9520cdb7ab7b6f5$var$b());
    }
    setInputPreviousTxId(inputIndex, txid) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PREVIOUS_TXID, $b9520cdb7ab7b6f5$var$b(), txid);
    }
    getInputPreviousTxid(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PREVIOUS_TXID, $b9520cdb7ab7b6f5$var$b());
    }
    setInputOutputIndex(inputIndex, outputIndex) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.OUTPUT_INDEX, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(outputIndex));
    }
    getInputOutputIndex(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.OUTPUT_INDEX, $b9520cdb7ab7b6f5$var$b()).readUInt32LE(0);
    }
    setInputSequence(inputIndex, sequence) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SEQUENCE, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(sequence));
    }
    getInputSequence(inputIndex) {
        var _a, _b;
        return (_b = (_a = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SEQUENCE, $b9520cdb7ab7b6f5$var$b())) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0)) !== null && _b !== void 0 ? _b : 0xffffffff;
    }
    setInputTapKeySig(inputIndex, sig) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_KEY_SIG, $b9520cdb7ab7b6f5$var$b(), sig);
    }
    getInputTapKeySig(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_KEY_SIG, $b9520cdb7ab7b6f5$var$b());
    }
    setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
        if (pubkey.length != 32) throw new Error("Invalid pubkey length: " + pubkey.length);
        const buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getInputTapBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getInputKeyDatas(inputIndex, keyType) {
        return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
    }
    setOutputRedeemScript(outputIndex, redeemScript) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b(), redeemScript);
    }
    getOutputRedeemScript(outputIndex) {
        return this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getOutputBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.BIP_32_DERIVATION, pubkey);
        return this.decodeBip32Derivation(buf);
    }
    setOutputAmount(outputIndex, amount) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.AMOUNT, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint64LE(amount));
    }
    getOutputAmount(outputIndex) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.AMOUNT, $b9520cdb7ab7b6f5$var$b());
        return (0, $8rRzQ.unsafeFrom64bitLE)(buf);
    }
    setOutputScript(outputIndex, scriptPubKey) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.SCRIPT, $b9520cdb7ab7b6f5$var$b(), scriptPubKey);
    }
    getOutputScript(outputIndex) {
        return this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
        const buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getOutputTapBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    deleteInputEntries(inputIndex, keyTypes) {
        const map = this.inputMaps[inputIndex];
        map.forEach((_v, k, m)=>{
            if (this.isKeyType(k, keyTypes)) m.delete(k);
        });
    }
    copy(to) {
        this.copyMap(this.globalMap, to.globalMap);
        this.copyMaps(this.inputMaps, to.inputMaps);
        this.copyMaps(this.outputMaps, to.outputMaps);
    }
    copyMaps(from, to) {
        from.forEach((m, index)=>{
            const to_index = new Map();
            this.copyMap(m, to_index);
            to[index] = to_index;
        });
    }
    copyMap(from, to) {
        from.forEach((v, k)=>to.set(k, $b9520cdb7ab7b6f5$require$Buffer.from(v)));
    }
    serialize() {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeSlice($b9520cdb7ab7b6f5$require$Buffer.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xff
        ]));
        $b9520cdb7ab7b6f5$var$serializeMap(buf, this.globalMap);
        this.inputMaps.forEach((map)=>{
            $b9520cdb7ab7b6f5$var$serializeMap(buf, map);
        });
        this.outputMaps.forEach((map)=>{
            $b9520cdb7ab7b6f5$var$serializeMap(buf, map);
        });
        return buf.buffer();
    }
    deserialize(psbt) {
        const buf = new $8rRzQ.BufferReader(psbt);
        if (!buf.readSlice(5).equals($b9520cdb7ab7b6f5$var$PSBT_MAGIC_BYTES)) throw new Error("Invalid magic bytes");
        while(this.readKeyPair(this.globalMap, buf));
        let psbtVersion;
        try {
            psbtVersion = this.getGlobalPsbtVersion();
        } catch (_a) {
            psbtVersion = 0;
        }
        if (psbtVersion !== 0 && psbtVersion !== 2) throw new Error("Only PSBTs of version 0 or 2 are supported");
        let nInputs;
        let nOutputs;
        if (psbtVersion == 0) {
            // if PSBTv0, we parse the PSBT_GLOBAL_UNSIGNED_TX field
            const txRaw = this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX);
            const tx = $b9520cdb7ab7b6f5$var$bjs.Transaction.fromBuffer(txRaw);
            nInputs = tx.ins.length;
            nOutputs = tx.outs.length;
        } else {
            // if PSBTv2, we already have the counts
            nInputs = this.getGlobalInputCount();
            nOutputs = this.getGlobalOutputCount();
        }
        for(let i = 0; i < nInputs; i++){
            this.inputMaps[i] = new Map();
            while(this.readKeyPair(this.inputMaps[i], buf));
        }
        for(let i = 0; i < nOutputs; i++){
            this.outputMaps[i] = new Map();
            while(this.readKeyPair(this.outputMaps[i], buf));
        }
        this.normalizeToV2();
    }
    normalizeToV2() {
        var _a;
        // if the psbt is a PsbtV0, convert it to PsbtV2 instead.
        // throw an error for any version other than 0 or 2,
        const psbtVersion = (_a = this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION)) === null || _a === void 0 ? void 0 : _a.readInt32LE(0);
        if (psbtVersion === 2) return;
        else if (psbtVersion !== undefined) throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        // Convert PsbtV0 to PsbtV2 by parsing the PSBT_GLOBAL_UNSIGNED_TX field
        // and filling in the corresponding fields.
        const txRaw = this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX);
        const tx = $b9520cdb7ab7b6f5$var$bjs.Transaction.fromBuffer(txRaw);
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(tx.version);
        this.setGlobalFallbackLocktime(tx.locktime);
        this.setGlobalInputCount(tx.ins.length);
        this.setGlobalOutputCount(tx.outs.length);
        for(let i = 0; i < tx.ins.length; i++){
            this.setInputPreviousTxId(i, tx.ins[i].hash);
            this.setInputOutputIndex(i, tx.ins[i].index);
            this.setInputSequence(i, tx.ins[i].sequence);
        }
        for(let i = 0; i < tx.outs.length; i++){
            this.setOutputAmount(i, tx.outs[i].value);
            this.setOutputScript(i, tx.outs[i].script);
        }
        // PSBT_GLOBAL_UNSIGNED_TX must be removed in a valid PSBTv2
        this.globalMap.delete($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX.toString(16).padStart(2, "0"));
    }
    /**
     * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
     * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
     *
     * Prepares the fields required for signing a Psbt on a Ledger
     * device. It should be used exclusively before calling
     * `appClient.signPsbt()` and not as a general Psbt conversion method.
     *
     * Note: This method supports all the policies that the Ledger is able to
     * sign, with the exception of taproot: tr(@0).
     */ fromBitcoinJS(psbtBJS) {
        function isTaprootInput(input) {
            let isP2TR;
            try {
                $b9520cdb7ab7b6f5$var$bjs.payments.p2tr({
                    output: input.witnessUtxo.script
                });
                isP2TR = true;
            } catch (err) {
                isP2TR = false;
            }
            return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || isP2TR);
        }
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(psbtBJS.version);
        this.setGlobalInputCount(psbtBJS.data.inputs.length);
        this.setGlobalOutputCount(psbtBJS.txOutputs.length);
        if (psbtBJS.locktime !== undefined) this.setGlobalFallbackLocktime(psbtBJS.locktime);
        psbtBJS.data.inputs.forEach((input, index)=>{
            if (isTaprootInput(input)) throw new Error(`Taproot inputs not supported`);
            this.setInputPreviousTxId(index, psbtBJS.txInputs[index].hash);
            if (psbtBJS.txInputs[index].sequence !== undefined) this.setInputSequence(index, psbtBJS.txInputs[index].sequence);
            this.setInputOutputIndex(index, psbtBJS.txInputs[index].index);
            if (input.sighashType !== undefined) this.setInputSighashType(index, input.sighashType);
            if (input.nonWitnessUtxo) this.setInputNonWitnessUtxo(index, input.nonWitnessUtxo);
            if (input.witnessUtxo) this.setInputWitnessUtxo(index, input.witnessUtxo.value, input.witnessUtxo.script);
            if (input.witnessScript) this.setInputWitnessScript(index, input.witnessScript);
            if (input.redeemScript) this.setInputRedeemScript(index, input.redeemScript);
            psbtBJS.data.inputs[index].bip32Derivation.forEach((derivation)=>{
                if (!/^m\//i.test(derivation.path)) throw new Error(`Invalid input bip32 derivation`);
                const pathArray = derivation.path.replace(/m\//i, "").split("/").map((level)=>level.match(/['h]/i) ? parseInt(level) + 0x80000000 : Number(level));
                this.setInputBip32Derivation(index, derivation.pubkey, derivation.masterFingerprint, pathArray);
            });
        });
        psbtBJS.txOutputs.forEach((output, index)=>{
            this.setOutputAmount(index, output.value);
            this.setOutputScript(index, output.script);
        });
        return this;
    }
    readKeyPair(map, buf) {
        const keyLen = (0, $8GOLq.sanitizeBigintToNumber)(buf.readVarInt());
        if (keyLen == 0) return false;
        const keyType = buf.readUInt8();
        const keyData = buf.readSlice(keyLen - 1);
        const value = buf.readVarSlice();
        $b9520cdb7ab7b6f5$var$set(map, keyType, keyData, value);
        return true;
    }
    getKeyDatas(map, keyType) {
        const result = [];
        map.forEach((_v, k)=>{
            if (this.isKeyType(k, [
                keyType
            ])) result.push($b9520cdb7ab7b6f5$require$Buffer.from(k.substring(2), "hex"));
        });
        return result;
    }
    isKeyType(hexKey, keyTypes) {
        const keyType = $b9520cdb7ab7b6f5$require$Buffer.from(hexKey.substring(0, 2), "hex").readUInt8(0);
        return keyTypes.some((k)=>k == keyType);
    }
    setGlobal(keyType, value) {
        const key = new $b9520cdb7ab7b6f5$var$Key(keyType, $b9520cdb7ab7b6f5$require$Buffer.from([]));
        this.globalMap.set(key.toString(), value);
    }
    getGlobal(keyType) {
        return $b9520cdb7ab7b6f5$var$get(this.globalMap, keyType, $b9520cdb7ab7b6f5$var$b(), false);
    }
    getGlobalOptional(keyType) {
        return $b9520cdb7ab7b6f5$var$get(this.globalMap, keyType, $b9520cdb7ab7b6f5$var$b(), true);
    }
    setInput(index, keyType, keyData, value) {
        $b9520cdb7ab7b6f5$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
    }
    getInput(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.inputMaps[index], keyType, keyData, false);
    }
    getInputOptional(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.inputMaps[index], keyType, keyData, true);
    }
    setOutput(index, keyType, keyData, value) {
        $b9520cdb7ab7b6f5$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
    }
    getOutput(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.outputMaps[index], keyType, keyData, false);
    }
    getMap(index, maps) {
        if (maps[index]) return maps[index];
        return maps[index] = new Map();
    }
    encodeBip32Derivation(masterFingerprint, path) {
        const buf = new $8rRzQ.BufferWriter();
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeBip32Derivation(buffer) {
        const buf = new $8rRzQ.BufferReader(buffer);
        return this.readBip32Derivation(buf);
    }
    writeBip32Derivation(buf, masterFingerprint, path) {
        buf.writeSlice(masterFingerprint);
        path.forEach((element)=>{
            buf.writeUInt32(element);
        });
    }
    readBip32Derivation(buf) {
        const masterFingerprint = buf.readSlice(4);
        const path = [];
        while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
        return {
            masterFingerprint: masterFingerprint,
            path: path
        };
    }
    encodeTapBip32Derivation(hashes, masterFingerprint, path) {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeVarInt(hashes.length);
        hashes.forEach((h)=>{
            buf.writeSlice(h);
        });
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeTapBip32Derivation(buffer) {
        const buf = new $8rRzQ.BufferReader(buffer);
        const hashCount = (0, $8GOLq.sanitizeBigintToNumber)(buf.readVarInt());
        const hashes = [];
        for(let i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
        const deriv = this.readBip32Derivation(buf);
        return Object.assign({
            hashes: hashes
        }, deriv);
    }
}
module.exports.PsbtV2 = $b9520cdb7ab7b6f5$var$PsbtV2;
function $b9520cdb7ab7b6f5$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw Error("No such map");
    const key = new $b9520cdb7ab7b6f5$var$Key(keyType, keyData);
    const value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $b9520cdb7ab7b6f5$var$NoSuchEntry(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $b9520cdb7ab7b6f5$require$Buffer.from(value);
}
class $b9520cdb7ab7b6f5$var$Key {
    constructor(keyType, keyData){
        this.keyType = keyType;
        this.keyData = keyData;
    }
    toString() {
        const buf = new $8rRzQ.BufferWriter();
        this.toBuffer(buf);
        return buf.buffer().toString("hex");
    }
    serialize(buf) {
        buf.writeVarInt(1 + this.keyData.length);
        this.toBuffer(buf);
    }
    toBuffer(buf) {
        buf.writeUInt8(this.keyType);
        buf.writeSlice(this.keyData);
    }
}
class $b9520cdb7ab7b6f5$var$KeyPair {
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    serialize(buf) {
        this.key.serialize(buf);
        buf.writeVarSlice(this.value);
    }
}
function $b9520cdb7ab7b6f5$var$createKey(buf) {
    return new $b9520cdb7ab7b6f5$var$Key(buf.readUInt8(0), buf.slice(1));
}
function $b9520cdb7ab7b6f5$var$serializeMap(buf, map) {
    // serialize in lexicographical order of keys
    for (let [key, value] of [
        ...map
    ].sort(([k1], [k2])=>k1.localeCompare(k2))){
        const keyPair = new $b9520cdb7ab7b6f5$var$KeyPair($b9520cdb7ab7b6f5$var$createKey($b9520cdb7ab7b6f5$require$Buffer.from(key, "hex")), value);
        keyPair.serialize(buf);
    }
    buf.writeUInt8(0);
}
function $b9520cdb7ab7b6f5$var$b() {
    return $b9520cdb7ab7b6f5$require$Buffer.from([]);
}
function $b9520cdb7ab7b6f5$var$set(map, keyType, keyData, value) {
    const key = new $b9520cdb7ab7b6f5$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $b9520cdb7ab7b6f5$var$uint32LE(n) {
    const buf = $b9520cdb7ab7b6f5$require$Buffer.alloc(4);
    buf.writeUInt32LE(n, 0);
    return buf;
}
function $b9520cdb7ab7b6f5$var$uint64LE(n) {
    return (0, $8rRzQ.unsafeTo64bitLE)(n);
}
function $b9520cdb7ab7b6f5$var$varint(n) {
    const buf = new $8rRzQ.BufferWriter();
    buf.writeVarInt(n);
    return buf.buffer();
}
function $b9520cdb7ab7b6f5$var$fromVarint(buf) {
    return (0, $8GOLq.sanitizeBigintToNumber)(new $8rRzQ.BufferReader(buf).readVarInt());
}

});



parcelRegister("1Fo37", function(module, exports) {

var $jSdlU = parcelRequire("jSdlU");
var $136c467abd10119c$require$MAX_SAFE_COMPONENT_LENGTH = $jSdlU.MAX_SAFE_COMPONENT_LENGTH;
var $136c467abd10119c$require$MAX_SAFE_BUILD_LENGTH = $jSdlU.MAX_SAFE_BUILD_LENGTH;
var $136c467abd10119c$require$MAX_LENGTH = $jSdlU.MAX_LENGTH;

var $gEWXU = parcelRequire("gEWXU");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $136c467abd10119c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $136c467abd10119c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $gEWXU(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${$136c467abd10119c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$136c467abd10119c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$136c467abd10119c$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken("COERCE", `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken("COERCEFULL", src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
createToken("COERCERTLFULL", src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("jSdlU", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $e77d6af33018f99d$var$SEMVER_SPEC_VERSION = "2.0.0";
const $e77d6af33018f99d$var$MAX_LENGTH = 256;
const $e77d6af33018f99d$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $e77d6af33018f99d$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $e77d6af33018f99d$var$MAX_SAFE_BUILD_LENGTH = $e77d6af33018f99d$var$MAX_LENGTH - 6;
const $e77d6af33018f99d$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $e77d6af33018f99d$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $e77d6af33018f99d$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $e77d6af33018f99d$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $e77d6af33018f99d$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $e77d6af33018f99d$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $e77d6af33018f99d$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("gEWXU", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
const $c20e1f0bb1d4aa00$var$debug = (typeof $hPtJY === "object" && $hPtJY.env && undefined, ()=>{});
module.exports = $c20e1f0bb1d4aa00$var$debug;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("3ByjW", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});

"use strict";
"use strict";
var $ca3e1754e676956d$exports = {};
"use strict";
var $55b335199d6e6d5d$exports = {};
"use strict";
var $55b335199d6e6d5d$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$55b335199d6e6d5d$exports = // eslint-disable-next-line es/no-global-this -- safe
$55b335199d6e6d5d$var$check(typeof globalThis == "object" && globalThis) || $55b335199d6e6d5d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$55b335199d6e6d5d$var$check(typeof self == "object" && self) || $55b335199d6e6d5d$var$check(typeof $parcel$global == "object" && $parcel$global) || $55b335199d6e6d5d$var$check(typeof $55b335199d6e6d5d$exports == "object" && $55b335199d6e6d5d$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
"use strict";
var $ef322a7f89c3ed41$exports = {};
"use strict";
var $6140c9fa18232846$exports = {};
"use strict";
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
"use strict";
var $bcbe62e89adc7d37$exports = {};
"use strict";

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
"use strict";
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
"use strict";
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
"use strict";
var $8239f4c7c6082668$exports = {};
"use strict";
var $43b18aa2f1faac44$exports = {};
"use strict";

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
"use strict";

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === "String" ? $8239f4c7c6082668$var$split(it, "") : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
"use strict";
var $7ce250ddf7b42d4d$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
"use strict";
var $8ffb6b36a733d3c0$exports = {};
"use strict";

var $6a130d390db46c8e$exports = {};
"use strict";
var $70e34a5a2021f756$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == "undefined" && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
"use strict";
var $a5217dbd1b0d33ce$exports = {};
"use strict";


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($55b335199d6e6d5d$exports[namespace]) : $55b335199d6e6d5d$exports[namespace] && $55b335199d6e6d5d$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
"use strict";

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
"use strict";
var $4a39565fee8fe980$exports = {};
"use strict";
var $998d968a5e32cd49$exports = {};
"use strict";

var $492c6dc902f2bf18$exports = {};
"use strict";
$492c6dc902f2bf18$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $998d968a5e32cd49$var$process = $55b335199d6e6d5d$exports.process;
var $998d968a5e32cd49$var$Deno = $55b335199d6e6d5d$exports.Deno;
var $998d968a5e32cd49$var$versions = $998d968a5e32cd49$var$process && $998d968a5e32cd49$var$process.versions || $998d968a5e32cd49$var$Deno && $998d968a5e32cd49$var$Deno.version;
var $998d968a5e32cd49$var$v8 = $998d968a5e32cd49$var$versions && $998d968a5e32cd49$var$versions.v8;
var $998d968a5e32cd49$var$match, $998d968a5e32cd49$var$version;
if ($998d968a5e32cd49$var$v8) {
    $998d968a5e32cd49$var$match = $998d968a5e32cd49$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $998d968a5e32cd49$var$version = $998d968a5e32cd49$var$match[0] > 0 && $998d968a5e32cd49$var$match[0] < 4 ? 1 : +($998d968a5e32cd49$var$match[0] + $998d968a5e32cd49$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$998d968a5e32cd49$var$version && $492c6dc902f2bf18$exports) {
    $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Edge\/(\d+)/);
    if (!$998d968a5e32cd49$var$match || $998d968a5e32cd49$var$match[1] >= 74) {
        $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Chrome\/(\d+)/);
        if ($998d968a5e32cd49$var$match) $998d968a5e32cd49$var$version = +$998d968a5e32cd49$var$match[1];
    }
}
$998d968a5e32cd49$exports = $998d968a5e32cd49$var$version;




var $4a39565fee8fe980$var$$String = $55b335199d6e6d5d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $998d968a5e32cd49$exports && $998d968a5e32cd49$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports("Symbol");
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
"use strict";
var $ae485921c5498156$exports = {};
"use strict";

var $8f0ebae34f61e14c$exports = {};
"use strict";
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
"use strict";



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
"use strict";

var $1946b9b54b48e7fd$exports = {};
"use strict";
var $d00d03e557d638db$exports = {};
"use strict";
var $e0409817d4e03fc4$exports = {};
"use strict";
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($55b335199d6e6d5d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $55b335199d6e6d5d$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = "__core-js_shared__";
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $55b335199d6e6d5d$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: "3.37.0",
    mode: $e0409817d4e03fc4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
"use strict";

var $a2f3ebb5da11db12$exports = {};
"use strict";

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
"use strict";

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $55b335199d6e6d5d$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports("wks");
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol["for"] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol("Symbol." + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, "string");
    return $0b429cc7792c7d26$exports(key) ? key : key + "";
};



var $d45526d8245cb22c$exports = {};
"use strict";


var $15c0c414b89100b1$exports = {};
"use strict";


var $15c0c414b89100b1$var$document = $55b335199d6e6d5d$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
"use strict";


var $161a89d67c436ccf$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
"use strict";

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + " is not an object");
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = "enumerable";
var $2d0ac3aa5e39584b$var$CONFIGURABLE = "configurable";
var $2d0ac3aa5e39584b$var$WRITABLE = "writable";
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
"use strict";


var $09c56ff2ae09b2d7$exports = {};
"use strict";





var $81c64883d194e3b4$exports = {};
"use strict";


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === "something";
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, "name").configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
"use strict";



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
"use strict";
var $47d53bb84a8f3c5b$exports = {};
"use strict";


var $47d53bb84a8f3c5b$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
"use strict";


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports("keys");
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
"use strict";
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3a8bcef306e86159$var$TypeError = $55b335199d6e6d5d$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports("state");
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports("".replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split("String");
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === "Symbol(") name = "[" + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1f868a26fd901990$exports(value, "name") || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, "arity") && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, "constructor") && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, "source")) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, "toString");



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
"use strict";

var $339f2419d379e6c2$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
"use strict";
var $c4fba4611365c4f5$exports = {};
"use strict";



var $f00609c516640f24$exports = {};
"use strict";

var $1ef9432c43157f41$exports = {};
"use strict";
var $b5bb21648546ce5b$exports = {};
"use strict";
var $5395b5a4913a5e32$exports = {};
"use strict";
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
"use strict";
var $4aba983aae3daed3$exports = {};
"use strict";

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
"use strict";
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat("length", "prototype");
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
"use strict";
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
"use strict";


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, ".").toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = "N";
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = "P";
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $55b335199d6e6d5d$exports;
    else if (STATIC) target = $55b335199d6e6d5d$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $55b335199d6e6d5d$exports[TARGET] && $55b335199d6e6d5d$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, "sham", true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};





var $a78806ef4ebb6167$exports = {};
"use strict";
var $43284f0171045916$exports = {};
"use strict";
var $4828cb1b4c7586c8$exports = {};
"use strict";


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === "Function") return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $570a6df80758b4be$exports = {};
"use strict";

var $0fe0dd04b0eb22af$exports = {};
"use strict";
$0fe0dd04b0eb22af$exports = {};


var $570a6df80758b4be$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$570a6df80758b4be$exports = function(it) {
    return it !== undefined && ($0fe0dd04b0eb22af$exports.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};




var $13a4c31eee540026$exports = {};
"use strict";




var $8d560b8b837672a0$exports = {};
"use strict";
var $b07c9aec2f9c74e4$exports = {};
"use strict";
var $a2c149aaa14cc75b$exports = {};
"use strict";

var $a2c149aaa14cc75b$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $a2c149aaa14cc75b$var$test = {};
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = "z";
$a2c149aaa14cc75b$exports = String($a2c149aaa14cc75b$var$test) === "[object z]";





var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $b0ba63bfbfb16088$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b07c9aec2f9c74e4$exports = $a2c149aaa14cc75b$exports ? $b0ba63bfbfb16088$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == "string" ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $b0ba63bfbfb16088$exports(O) : (result = $b0ba63bfbfb16088$exports(O)) === "Object" && $70e34a5a2021f756$exports(O.callee) ? "Arguments" : result;
};






var $8d560b8b837672a0$var$ITERATOR = $842f8f0a18746212$exports("iterator");
$8d560b8b837672a0$exports = function(it) {
    if (!$7ce250ddf7b42d4d$exports(it)) return $eb80dcd0b8a5698c$exports(it, $8d560b8b837672a0$var$ITERATOR) || $eb80dcd0b8a5698c$exports(it, "@@iterator") || $0fe0dd04b0eb22af$exports[$b07c9aec2f9c74e4$exports(it)];
};


var $13a4c31eee540026$var$$TypeError = TypeError;
$13a4c31eee540026$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8d560b8b837672a0$exports(argument) : usingIterator;
    if ($ae485921c5498156$exports(iteratorMethod)) return $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(iteratorMethod, argument));
    throw new $13a4c31eee540026$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not iterable");
};



var $4105790cb9bf2aaa$exports = {};
"use strict";



$4105790cb9bf2aaa$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c845d421b7b0e630$exports(iterator);
    try {
        innerResult = $eb80dcd0b8a5698c$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $881ad37dbe259e8f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c845d421b7b0e630$exports(innerResult);
    return value;
};


var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
$a78806ef4ebb6167$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $43284f0171045916$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $4105790cb9bf2aaa$exports(iterator, "normal", condition);
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c845d421b7b0e630$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8d560b8b837672a0$exports(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($8f0ebae34f61e14c$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($570a6df80758b4be$exports(iterFn)) {
            for(index = 0, length = $04c91bd3815cd64a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $13a4c31eee540026$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $4105790cb9bf2aaa$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};


var $e055c888a6d66079$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $e055c888a6d66079$var$MapPrototype = Map.prototype;
$e055c888a6d66079$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.set),
    get: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.get),
    has: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.has),
    remove: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype["delete"]),
    proto: $e055c888a6d66079$var$MapPrototype
};




var $37e12fa6c9b33441$var$Map = $e055c888a6d66079$exports.Map;
var $37e12fa6c9b33441$var$has = $e055c888a6d66079$exports.has;
var $37e12fa6c9b33441$var$get = $e055c888a6d66079$exports.get;
var $37e12fa6c9b33441$var$set = $e055c888a6d66079$exports.set;
var $37e12fa6c9b33441$var$push = $43b18aa2f1faac44$exports([].push);
var $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES = $e0409817d4e03fc4$exports || $6140c9fa18232846$exports(function() {
    return $37e12fa6c9b33441$var$Map.groupBy("ab", function(it) {
        return it;
    }).get("a").length !== 1;
});
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: $e0409817d4e03fc4$exports || $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $c378177673193450$exports(items);
        $ae485921c5498156$exports(callbackfn);
        var map = new $37e12fa6c9b33441$var$Map();
        var k = 0;
        $a78806ef4ebb6167$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$37e12fa6c9b33441$var$has(map, key)) $37e12fa6c9b33441$var$set(map, key, [
                value
            ]);
            else $37e12fa6c9b33441$var$push($37e12fa6c9b33441$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $d59cfa12048c6a93$exports = {};
"use strict";
var $d7077b1b2482ede0$exports = {};
"use strict";

$d7077b1b2482ede0$exports = $55b335199d6e6d5d$exports;



var $f95af0e9699ed86b$export$2d1720544b23b823;
"use strict";

$f95af0e9699ed86b$export$2d1720544b23b823 = $842f8f0a18746212$exports;



var $d59cfa12048c6a93$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
$d59cfa12048c6a93$exports = function(NAME) {
    var Symbol = $d7077b1b2482ede0$exports.Symbol || ($d7077b1b2482ede0$exports.Symbol = {});
    if (!$1f868a26fd901990$exports(Symbol, NAME)) $d59cfa12048c6a93$require$defineProperty(Symbol, NAME, {
        value: $f95af0e9699ed86b$export$2d1720544b23b823(NAME)
    });
};



var $87873509811afceb$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

var $87873509811afceb$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $87873509811afceb$var$Symbol = $55b335199d6e6d5d$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$d59cfa12048c6a93$exports("dispose");
if ($87873509811afceb$var$Symbol) {
    var $87873509811afceb$var$descriptor = $87873509811afceb$require$getOwnPropertyDescriptor($87873509811afceb$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($87873509811afceb$var$descriptor.enumerable && $87873509811afceb$var$descriptor.configurable && $87873509811afceb$var$descriptor.writable) $87873509811afceb$require$defineProperty($87873509811afceb$var$Symbol, "dispose", {
        value: $87873509811afceb$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";
"use strict";


var $a393da0e05d61ed1$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == "object" && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});






var $b8ce1ad1b6b1e7c1$exports = {};
"use strict";

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports("document", "documentElement");


var $0709cba658bb4ed6$exports = {};
"use strict";

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);



var $7d824954c5058f7d$exports = {};
"use strict";
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError("Not enough arguments");
    return passed;
};


var $05f68a2417343639$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$05f68a2417343639$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($492c6dc902f2bf18$exports);


var $3f8bc2b5488269f3$exports = {};
"use strict";


$3f8bc2b5488269f3$exports = $b0ba63bfbfb16088$exports($55b335199d6e6d5d$exports.process) === "process";


var $a393da0e05d61ed1$var$set = $55b335199d6e6d5d$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $55b335199d6e6d5d$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $55b335199d6e6d5d$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $55b335199d6e6d5d$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $55b335199d6e6d5d$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $55b335199d6e6d5d$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $55b335199d6e6d5d$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $55b335199d6e6d5d$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $55b335199d6e6d5d$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + "//" + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($3f8bc2b5488269f3$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$05f68a2417343639$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($55b335199d6e6d5d$exports.addEventListener && $70e34a5a2021f756$exports($55b335199d6e6d5d$exports.postMessage) && !$55b335199d6e6d5d$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== "file:" && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $55b335199d6e6d5d$exports.addEventListener("message", $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports("script")) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports("script"))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


"use strict";



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
"use strict";



var $99637759dc933969$exports = {};
"use strict";
/* global Bun -- Bun case */ $99637759dc933969$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $f112a170991e44cc$var$Function = $55b335199d6e6d5d$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($492c6dc902f2bf18$exports) || $99637759dc933969$exports && function() {
    var version = $55b335199d6e6d5d$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $55b335199d6e6d5d$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




let $fdd451dd43e0ce6f$var$id = 0;
const $fdd451dd43e0ce6f$var$subscribers = [];
const $fdd451dd43e0ce6f$export$bef1f36f5486a6a3 = (type, message, data)=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
const $fdd451dd43e0ce6f$export$357889f174732d38 = ({ type: type, message: message, data: data, context: context })=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
class $fdd451dd43e0ce6f$export$c9a255a7b61db733 {
    constructor(type, context){
        this.type = type;
        this.context = context;
    }
    trace(message, data) {
        $fdd451dd43e0ce6f$export$357889f174732d38({
            type: this.type,
            message: message,
            data: data,
            context: this.context
        });
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    updateContext(contextToAdd) {
        this.context = Object.assign(Object.assign({}, this.context), contextToAdd);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withType(type) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(type, this.context);
    }
    /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ withContext(context) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, context);
    }
    /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withUpdatedContext(contextToAdd) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, Object.assign(Object.assign({}, this.context), contextToAdd));
    }
}
const $fdd451dd43e0ce6f$export$63174c828edd6ff8 = (cb)=>{
    $fdd451dd43e0ce6f$var$subscribers.push(cb);
    return ()=>{
        const i = $fdd451dd43e0ce6f$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $fdd451dd43e0ce6f$var$subscribers[i] = $fdd451dd43e0ce6f$var$subscribers[$fdd451dd43e0ce6f$var$subscribers.length - 1];
            $fdd451dd43e0ce6f$var$subscribers.pop();
        }
    };
};
function $fdd451dd43e0ce6f$var$dispatch(log) {
    for(let i = 0; i < $fdd451dd43e0ce6f$var$subscribers.length; i++)try {
        $fdd451dd43e0ce6f$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $fdd451dd43e0ce6f$export$63174c828edd6ff8;


var $7a6cef509ca65f26$exports = {};
"use strict";
var $7a6cef509ca65f26$var$__importDefault = $7a6cef509ca65f26$exports && $7a6cef509ca65f26$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7a6cef509ca65f26$exports, "__esModule", {
    value: true
});
$7a6cef509ca65f26$exports.WalletPolicy = $7a6cef509ca65f26$exports.DefaultWalletPolicy = $7a6cef509ca65f26$exports.PsbtV2 = $7a6cef509ca65f26$exports.AppClient = void 0;

const $7a6cef509ca65f26$var$appClient_1 = $7a6cef509ca65f26$var$__importDefault((parcelRequire("pyUmM")));
$7a6cef509ca65f26$exports.AppClient = $7a6cef509ca65f26$var$appClient_1.default;
var $1a44f982b34497b4$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $1a44f982b34497b4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($1a44f982b34497b4$exports, "__esModule", {
    value: true
});
$1a44f982b34497b4$exports.DefaultWalletPolicy = $1a44f982b34497b4$exports.WalletPolicy = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $8rRzQ = parcelRequire("8rRzQ");

var $goh0i = parcelRequire("goh0i");
const $1a44f982b34497b4$var$WALLET_POLICY_V2 = 2;
/**
 * The Bitcon hardware app uses a descriptors-like thing to describe
 * how to construct output scripts from keys. A "Wallet Policy" consists
 * of a "Descriptor Template" and a list of "keys". A key is basically
 * a serialized BIP32 extended public key with some added derivation path
 * information. This is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/wallet.md
 */ class $1a44f982b34497b4$var$WalletPolicy {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */ constructor(name, descriptorTemplate, keys){
        this.name = name;
        this.descriptorTemplate = descriptorTemplate;
        this.keys = keys;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */ getId() {
        return $3wrUl.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */ serialize() {
        const keyBuffers = this.keys.map((k)=>{
            return $1a44f982b34497b4$require$Buffer.from(k, "ascii");
        });
        const m = new $goh0i.Merkle(keyBuffers.map((k)=>(0, $goh0i.hashLeaf)(k)));
        const buf = new $8rRzQ.BufferWriter();
        buf.writeUInt8($1a44f982b34497b4$var$WALLET_POLICY_V2); // wallet version
        // length of wallet name, and wallet name
        buf.writeVarSlice($1a44f982b34497b4$require$Buffer.from(this.name, "ascii"));
        // length of descriptor template
        buf.writeVarInt(this.descriptorTemplate.length);
        // sha256 hash of descriptor template
        buf.writeSlice($3wrUl.crypto.sha256($1a44f982b34497b4$require$Buffer.from(this.descriptorTemplate)));
        // number of keys
        buf.writeVarInt(this.keys.length);
        // root of Merkle tree of keys
        buf.writeSlice(m.getRoot());
        return buf.buffer();
    }
}
$1a44f982b34497b4$exports.WalletPolicy = $1a44f982b34497b4$var$WalletPolicy;
/**
 * Simplified class to handle default wallet policies that can be used without policy registration.
 */ class $1a44f982b34497b4$var$DefaultWalletPolicy extends $1a44f982b34497b4$var$WalletPolicy {
    constructor(descriptorTemplate, key){
        super("", descriptorTemplate, [
            key
        ]);
    }
}
$1a44f982b34497b4$exports.DefaultWalletPolicy = $1a44f982b34497b4$var$DefaultWalletPolicy;


Object.defineProperty($7a6cef509ca65f26$exports, "DefaultWalletPolicy", {
    enumerable: true,
    get: function() {
        return $1a44f982b34497b4$exports.DefaultWalletPolicy;
    }
});
Object.defineProperty($7a6cef509ca65f26$exports, "WalletPolicy", {
    enumerable: true,
    get: function() {
        return $1a44f982b34497b4$exports.WalletPolicy;
    }
});

var $fUsjC = parcelRequire("fUsjC");
Object.defineProperty($7a6cef509ca65f26$exports, "PsbtV2", {
    enumerable: true,
    get: function() {
        return $fUsjC.PsbtV2;
    }
});
$7a6cef509ca65f26$exports.default = $7a6cef509ca65f26$var$appClient_1.default;


var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $50105411ce29e10f$var$errorClasses = {};
const $50105411ce29e10f$var$deserializers = {};
const $50105411ce29e10f$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $50105411ce29e10f$var$deserializers[name] = deserializer;
};
const $50105411ce29e10f$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $50105411ce29e10f$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $50105411ce29e10f$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $50105411ce29e10f$var$isObject(value) {
    return typeof value === "object";
}
const $50105411ce29e10f$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $50105411ce29e10f$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $50105411ce29e10f$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $50105411ce29e10f$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $50105411ce29e10f$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $50105411ce29e10f$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $50105411ce29e10f$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $50105411ce29e10f$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $50105411ce29e10f$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


const $9a194f74559621d2$export$d7dd32b41fc9c3a0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNameRequired");
const $9a194f74559621d2$export$fb9db505804530ec = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNotSupported");
const $9a194f74559621d2$export$c9d6bf2b06944665 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AmountRequired");
const $9a194f74559621d2$export$2628fce2396c23c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BluetoothRequired");
const $9a194f74559621d2$export$75f8b0767ef406f1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BtcUnmatchedApp");
const $9a194f74559621d2$export$f60aa84fd00bc3ee = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantOpenDevice");
const $9a194f74559621d2$export$fc0260506e4022ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("CashAddrNotSupported");
const $9a194f74559621d2$export$1e9e90415b859c28 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ClaimRewardsFeesWarning");
const $9a194f74559621d2$export$e0b1ec53ba36e221 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CurrencyNotSupported");
const $9a194f74559621d2$export$fa9aacd48d3a45c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
const $9a194f74559621d2$export$f21ce806524ab8d4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
const $9a194f74559621d2$export$9c30dc6872fcd74c = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNotGenuine");
const $9a194f74559621d2$export$1d5ae41b109edf1f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardExpected");
const $9a194f74559621d2$export$8eecf64ec9a8cfd7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
const $9a194f74559621d2$export$a5e2071f1ac48fdd = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceInOSUExpected");
const $9a194f74559621d2$export$3be6e7231165f4ac = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceHalted");
const $9a194f74559621d2$export$fa7bfae6dce03474 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNameInvalid");
const $9a194f74559621d2$export$bcce4e5aded80ca0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketFail");
const $9a194f74559621d2$export$944a0f9a7cc1e03a = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$612d1f6d08d4cfb = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$5f6bf7cdd5818529 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnresponsiveDeviceError");
const $9a194f74559621d2$export$1e42f3936938e063 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDevice");
const $9a194f74559621d2$export$2a60f41a2ed2742 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
const $9a194f74559621d2$export$93e2040d8e24d646 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
const $9a194f74559621d2$export$e6aaf90bcb4b2013 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
const $9a194f74559621d2$export$cfbd0adf8f9fdaf9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EnpointConfig");
const $9a194f74559621d2$export$96d8d3c501f1625 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
const $9a194f74559621d2$export$37b49553b7172cb1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeEstimationFailed");
const $9a194f74559621d2$export$d00fd6c398a70fd9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareNotRecognized");
const $9a194f74559621d2$export$3dc3bbf8c134219c = (0, $50105411ce29e10f$export$94baff7bf5134824)("HardResetFail");
const $9a194f74559621d2$export$5e8f7ae1054a2777 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidXRPTag");
const $9a194f74559621d2$export$953b602d2269ceba = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddress");
const $9a194f74559621d2$export$61e75f453df94067 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidNonce");
const $9a194f74559621d2$export$bbdaf7c77a7508eb = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
const $9a194f74559621d2$export$882967e2980534f9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LatestMCUInstalledError");
const $9a194f74559621d2$export$59772a13ac97df0e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnknownMCU");
const $9a194f74559621d2$export$26bf4f7c63d50901 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIError");
const $9a194f74559621d2$export$fdab6afd1b1820af = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
const $9a194f74559621d2$export$c2996b38942cf758 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPINotAvailable");
const $9a194f74559621d2$export$3d81abcc61613a27 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
const $9a194f74559621d2$export$87a9bff9fff141e2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
const $9a194f74559621d2$export$86581a722c4238c0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
const $9a194f74559621d2$export$267a8476044885dd = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
const $9a194f74559621d2$export$bb771ca417eca344 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerDeviceLocked");
const $9a194f74559621d2$export$b634ce25e3ff5229 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
const $9a194f74559621d2$export$2d26f4eadfe37285 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerNotEnoughSpace");
const $9a194f74559621d2$export$ceb7f9bef5a1e481 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerUninstallBTCDep");
const $9a194f74559621d2$export$baadb6886fde1621 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkDown");
const $9a194f74559621d2$export$bae979e68e4dc802 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkError");
const $9a194f74559621d2$export$5cbfa0659f97216a = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAddressesFound");
const $9a194f74559621d2$export$9e00aead3515e5c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalance");
const $9a194f74559621d2$export$5ed90e0e011f4857 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
const $9a194f74559621d2$export$75178c95e66d9630 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
const $9a194f74559621d2$export$e3e2865b29f7e0b0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughSpendableBalance");
const $9a194f74559621d2$export$a84b3634866707ea = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
const $9a194f74559621d2$export$a282f858b69a7326 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAccessToCamera");
const $9a194f74559621d2$export$5111c405c5cacc97 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGas");
const $9a194f74559621d2$export$1cb5c4489aaca4d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGasSwap");
const $9a194f74559621d2$export$626e1fd20d22139c = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotSupportedLegacyAddress");
const $9a194f74559621d2$export$f919e2c9c746346b = (0, $50105411ce29e10f$export$94baff7bf5134824)("GasLessThanEstimate");
const $9a194f74559621d2$export$cc562f3706902d22 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooLow");
const $9a194f74559621d2$export$ee14d05cd43eb762 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooHigh");
const $9a194f74559621d2$export$931458f4b7d53154 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeHigherThanMaxFee");
const $9a194f74559621d2$export$c0ce9cadb94c6b86 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaxFeeTooLow");
const $9a194f74559621d2$export$22c5aa8937c5b423 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordsDontMatch");
const $9a194f74559621d2$export$f57670cd1aaf386 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordIncorrect");
const $9a194f74559621d2$export$3ba22bf10deb1448 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
const $9a194f74559621d2$export$33f73085e1b7871b = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendUndelegation");
const $9a194f74559621d2$export$cd4d967a66d81060 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TimeoutTagged");
const $9a194f74559621d2$export$9375635756d6156e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnexpectedBootloader");
const $9a194f74559621d2$export$90478a5d08d6c2d7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
const $9a194f74559621d2$export$132f0197eaa65535 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecipientRequired");
const $9a194f74559621d2$export$7aee729193ab77ba = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
const $9a194f74559621d2$export$4ec11dc947a3c9d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
const $9a194f74559621d2$export$5e3ed85b946872a1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateFetchFileFail");
const $9a194f74559621d2$export$5db6383ad081f01e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectHash");
const $9a194f74559621d2$export$92c199eb837d8df8 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectSig");
const $9a194f74559621d2$export$85e0c017833c894c = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateYourApp");
const $9a194f74559621d2$export$84115f1b54c874b3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
const $9a194f74559621d2$export$3f4864efb1638333 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAddress");
const $9a194f74559621d2$export$d777e0ef77faca34 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
const $9a194f74559621d2$export$3d8a4f08cd3eb133 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAllowManager");
const $9a194f74559621d2$export$db9b724c3524b5d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $9a194f74559621d2$export$65df6bdf4eb29653 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ExpertModeRequired");
const $9a194f74559621d2$export$9642f061c2494239 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportOpenUserCancelled");
const $9a194f74559621d2$export$fd71e3a51c4bf0ae = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
const $9a194f74559621d2$export$a02f8f98115efd5d = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportPendingOperation");
const $9a194f74559621d2$export$c0ffbdd94649bd06 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
const $9a194f74559621d2$export$28149f687a2e30c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransactionHasBeenValidatedError");
const $9a194f74559621d2$export$448663d307bde953 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportExchangeTimeoutError");
const $9a194f74559621d2$export$4800af3cc6204928 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceShouldStayInApp");
const $9a194f74559621d2$export$101490ec073327e1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionError");
const $9a194f74559621d2$export$219228963d86b069 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionFailed");
const $9a194f74559621d2$export$25b49ca0efdfe5d1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccount");
const $9a194f74559621d2$export$4de3709f8e2844ca = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountPayout");
const $9a194f74559621d2$export$b7651c38a977157 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountRefund");
const $9a194f74559621d2$export$63498b46122d8a23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongAppForCurrency");
const $9a194f74559621d2$export$707f317a4761c46d = (0, $50105411ce29e10f$export$94baff7bf5134824)("ETHAddressNonEIP");
const $9a194f74559621d2$export$a5d8da2f27618c16 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantScanQRCode");
const $9a194f74559621d2$export$3f2d8a7775aab6cc = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoaded");
const $9a194f74559621d2$export$3ae46f8c8f45dbe7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoadedSwap");
const $9a194f74559621d2$export$ffbf6641e9ab88d3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeRequired");
const $9a194f74559621d2$export$53e797c2fa09aff3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeTooHigh");
const $9a194f74559621d2$export$cb0b645e3d7170ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("PendingOperation");
const $9a194f74559621d2$export$2aca4567d80fd933 = (0, $50105411ce29e10f$export$94baff7bf5134824)("SyncError");
const $9a194f74559621d2$export$a2d6658d365c43df = (0, $50105411ce29e10f$export$94baff7bf5134824)("PairingFailed");
const $9a194f74559621d2$export$4400fa093e7d20ad = (0, $50105411ce29e10f$export$94baff7bf5134824)("PeerRemovedPairing");
const $9a194f74559621d2$export$3f7ba18f3c84cced = (0, $50105411ce29e10f$export$94baff7bf5134824)("GenuineCheckFailed");
const $9a194f74559621d2$export$437e6aac14cab3d9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI4xx");
const $9a194f74559621d2$export$309835543e52bf92 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI5xx");
const $9a194f74559621d2$export$c282cdb2f7fdc27a = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
const $9a194f74559621d2$export$aba9024c0d586a15 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ReplacementTransactionUnderpriced");
const $9a194f74559621d2$export$51a1e1b4f21df9f4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("OpReturnSizeLimit");
const $9a194f74559621d2$export$1d49177380419e3d = (0, $50105411ce29e10f$export$94baff7bf5134824)("DustLimit");
const $9a194f74559621d2$export$28f62a162580c9c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LanguageNotFound");
const $9a194f74559621d2$export$d3cadb9f4e1fa40d = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoDBPathGiven");
const $9a194f74559621d2$export$de46c919e379f03f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBWrongPassword");
const $9a194f74559621d2$export$e1c94c135b0a553e = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBNotReset");
const $9a194f74559621d2$export$35de8a1f557fb8bb = (0, $50105411ce29e10f$export$94baff7bf5134824)("SequenceNumberError");
const $9a194f74559621d2$export$df2168717eaf23c6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisabledTransactionBroadcastError");
var $9a194f74559621d2$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($9a194f74559621d2$export$62e86095f76df800 || ($9a194f74559621d2$export$62e86095f76df800 = {}));
class $9a194f74559621d2$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $9a194f74559621d2$export$ef5ffbe444ecd147.prototype);
    }
}
class $9a194f74559621d2$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportError", (e)=>new $9a194f74559621d2$export$8e68de6fb26f2236(e.message, e.id));
const $9a194f74559621d2$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CUSTOM_IMAGE_BOOTLOADER: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102
};
function $9a194f74559621d2$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $9a194f74559621d2$export$78917f4716d96cfe extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($9a194f74559621d2$export$efd5569f873811b1).find((k)=>$9a194f74559621d2$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $9a194f74559621d2$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $9a194f74559621d2$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE) return new $9a194f74559621d2$export$1fb6667702a70644(message);
    }
}
class $9a194f74559621d2$export$1fb6667702a70644 extends $9a194f74559621d2$export$78917f4716d96cfe {
    constructor(message){
        super($9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $9a194f74559621d2$export$1fb6667702a70644.prototype);
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportStatusError", (e)=>new $9a194f74559621d2$export$78917f4716d96cfe(e.statusCode));




var $6ZWSX = parcelRequire("6ZWSX");
var $375818ecee1623c3$require$Buffer = $6ZWSX.Buffer;
var $375818ecee1623c3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $375818ecee1623c3$var$DEFAULT_LOG_TYPE = "transport";
/**
 * The Transport class defines a generic interface for communicating with a Ledger hardware wallet.
 * There are different kind of transports based on the technology (channels like U2F, HID, Bluetooth, Webusb) and environment (Node, Web,...).
 * It is an abstract class that needs to be implemented.
 */ class $375818ecee1623c3$var$Transport {
    constructor({ context: context, logType: logType } = {}){
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, (/*@__PURE__*/$parcel$interopDefault($5440e9199a418654$exports)))();
        /**
         * Send data to the device using the higher level API.
         *
         * @param {number} cla - The instruction class for the command.
         * @param {number} ins - The instruction code for the command.
         * @param {number} p1 - The first parameter for the instruction.
         * @param {number} p2 - The second parameter for the instruction.
         * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
         * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
         * @param {Object} options - Contains optional options for the exchange function
         *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
         *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
         * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
         */ this.send = (cla, ins, p1, p2, data = $375818ecee1623c3$require$Buffer.alloc(0), statusList = [
            (0, $9a194f74559621d2$export$efd5569f873811b1).OK
        ], { abortTimeoutMs: abortTimeoutMs } = {})=>$375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
                const tracer = this.tracer.withUpdatedContext({
                    function: "send"
                });
                if (data.length >= 256) {
                    tracer.trace("data.length exceeded 256 bytes limit", {
                        dataLength: data.length
                    });
                    throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                }
                tracer.trace("Starting an exchange", {
                    abortTimeoutMs: abortTimeoutMs
                });
                const response = yield this.exchange(// The size of the data is added in 1 byte just before `data`
                $375818ecee1623c3$require$Buffer.concat([
                    $375818ecee1623c3$require$Buffer.from([
                        cla,
                        ins,
                        p1,
                        p2
                    ]),
                    $375818ecee1623c3$require$Buffer.from([
                        data.length
                    ]),
                    data
                ]), {
                    abortTimeoutMs: abortTimeoutMs
                });
                tracer.trace("Received response from exchange");
                const sw = response.readUInt16BE(response.length - 2);
                if (!statusList.some((s)=>s === sw)) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(sw);
                return response;
            });
        this._appAPIlock = null;
        this.tracer = new (0, $fdd451dd43e0ce6f$export$c9a255a7b61db733)(logType !== null && logType !== void 0 ? logType : $375818ecee1623c3$var$DEFAULT_LOG_TYPE, context);
    }
    /**
     * Send data to the device using a low level API.
     * It's recommended to use the "send" method for a higher level API.
     * @param {Buffer} apdu - The data to send.
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */ exchange(_apdu, { abortTimeoutMs: _abortTimeoutMs } = {}) {
        throw new Error("exchange not implemented");
    }
    /**
     * Send apdus in batch to the device using a low level API.
     * The default implementation is to call exchange for each apdu.
     * @param {Array<Buffer>} apdus - array of apdus to send.
     * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
     * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
     */ exchangeBulk(apdus, observer) {
        let unsubscribed = false;
        const unsubscribe = ()=>{
            unsubscribed = true;
        };
        const main = ()=>$375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
                if (unsubscribed) return;
                for (const apdu of apdus){
                    const r = yield this.exchange(apdu);
                    if (unsubscribed) return;
                    const status = r.readUInt16BE(r.length - 2);
                    if (status !== (0, $9a194f74559621d2$export$efd5569f873811b1).OK) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(status);
                    observer.next(r);
                }
            });
        main().then(()=>!unsubscribed && observer.complete(), (e)=>!unsubscribed && observer.error(e));
        return {
            unsubscribe: unsubscribe
        };
    }
    /**
     * Set the "scramble key" for the next data exchanges with the device.
     * Each app can have a different scramble key and it is set internally during instantiation.
     * @param {string} key - The scramble key to set.
     * deprecated This method is no longer needed for modern transports and should be migrated away from.
     * no @ before deprecated as it breaks documentationjs on version 14.0.2
     * https://github.com/documentationjs/documentation/issues/1596
     */ setScrambleKey(_key) {}
    /**
     * Close the connection with the device.
     *
     * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
     * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
     * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
     *
     * @returns {Promise<void>} A promise that resolves when the transport is closed.
     */ close() {
        return Promise.resolve();
    }
    /**
     * Listen for an event on the transport instance.
     * Transport implementations may have specific events. Common events include:
     * "disconnect" : triggered when the transport is disconnected.
     * @param {string} eventName - The name of the event to listen for.
     * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
     */ on(eventName, cb) {
        this._events.on(eventName, cb);
    }
    /**
     * Stop listening to an event on an instance of transport.
     */ off(eventName, cb) {
        this._events.removeListener(eventName, cb);
    }
    emit(event, ...args) {
        this._events.emit(event, ...args);
    }
    /**
     * Enable or not logs of the binary exchange
     */ setDebugMode() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    }
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ setExchangeTimeout(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    }
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ setExchangeUnresponsiveTimeout(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    }
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ static create(openTimeout = 3000, listenTimeout) {
        return new Promise((resolve, reject)=>{
            let found = false;
            const sub = this.listen({
                next: (e)=>{
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: (e)=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: ()=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            const listenTimeoutId = listenTimeout ? setTimeout(()=>{
                sub.unsubscribe();
                reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    }
    /**
     * Wrapper to make an exchange "atomic" (blocking any other exchange)
     *
     * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
     *
     * @param f The exchange job, using the transport to run
     * @returns a Promise resolving with the output of the given job
     */ exchangeAtomicImpl(f) {
        return $375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
            const tracer = this.tracer.withUpdatedContext({
                function: "exchangeAtomicImpl",
                unresponsiveTimeout: this.unresponsiveTimeout
            });
            if (this.exchangeBusyPromise) {
                tracer.trace("Atomic exchange is already busy");
                throw new (0, $9a194f74559621d2$export$a02f8f98115efd5d)("An action was already pending on the Ledger device. Please deny or reconnect.");
            }
            // Sets the atomic guard
            let resolveBusy;
            const busyPromise = new Promise((r)=>{
                resolveBusy = r;
            });
            this.exchangeBusyPromise = busyPromise;
            // The device unresponsiveness handler
            let unresponsiveReached = false;
            const timeout = setTimeout(()=>{
                tracer.trace(`Timeout reached, emitting Transport event "unresponsive"`, {
                    unresponsiveTimeout: this.unresponsiveTimeout
                });
                unresponsiveReached = true;
                this.emit("unresponsive");
            }, this.unresponsiveTimeout);
            try {
                const res = yield f();
                if (unresponsiveReached) {
                    tracer.trace("Device was unresponsive, emitting responsive");
                    this.emit("responsive");
                }
                return res;
            } finally{
                tracer.trace("Finalize, clearing busy guard");
                clearTimeout(timeout);
                if (resolveBusy) resolveBusy();
                this.exchangeBusyPromise = null;
            }
        });
    }
    decorateAppAPIMethods(self, methods, scrambleKey) {
        for (const methodName of methods)self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
    }
    decorateAppAPIMethod(methodName, f, ctx, scrambleKey) {
        return (...args)=>$375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
                const { _appAPIlock: _appAPIlock } = this;
                if (_appAPIlock) return Promise.reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"));
                try {
                    this._appAPIlock = methodName;
                    this.setScrambleKey(scrambleKey);
                    return yield f.apply(ctx, args);
                } finally{
                    this._appAPIlock = null;
                }
            });
    }
    /**
     * Sets the context used by the logging/tracing mechanism
     *
     * Useful when re-using (cached) the same Transport instance,
     * but with a new tracing context.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ setTraceContext(context) {
        this.tracer = this.tracer.withContext(context);
    }
    /**
     * Updates the context used by the logging/tracing mechanism
     *
     * The update only overrides the key-value that are already defined in the current context.
     *
     * @param contextToAdd A TraceContext that will be added to the current context
     */ updateTraceContext(contextToAdd) {
        this.tracer.updateContext(contextToAdd);
    }
    /**
     * Gets the tracing context of the transport instance
     */ getTraceContext() {
        return this.tracer.getContext();
    }
}
$375818ecee1623c3$var$Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
$375818ecee1623c3$var$Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
var $375818ecee1623c3$export$2e2bcd8739ae039 = $375818ecee1623c3$var$Transport;




var $6ZWSX = parcelRequire("6ZWSX");
var $f6e657627868bf3a$require$Buffer = $6ZWSX.Buffer;
const $f6e657627868bf3a$var$Tag = 0x05;
function $f6e657627868bf3a$var$asUInt16BE(value) {
    const b = $f6e657627868bf3a$require$Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
const $f6e657627868bf3a$var$initialAcc = {
    data: $f6e657627868bf3a$require$Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 * Object to handle HID frames (encoding and decoding)
 *
 * @param channel
 * @param packetSize The HID protocol packet size in bytes (usually 64)
 */ const $f6e657627868bf3a$var$createHIDframing = (channel, packetSize)=>{
    return {
        /**
         * Frames/encodes an APDU message into HID USB packets/frames
         *
         * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
         * @returns an array of HID USB frames ready to be sent
         */ makeBlocks (apdu) {
            // Encodes the APDU length in 2 bytes before the APDU itself.
            // The length is measured as the number of bytes.
            // As the size of the APDU `data` should have been added in 1 byte just before `data`,
            // the minimum size of an APDU is 5 bytes.
            let data = $f6e657627868bf3a$require$Buffer.concat([
                $f6e657627868bf3a$var$asUInt16BE(apdu.length),
                apdu
            ]);
            const blockSize = packetSize - 5;
            const nbBlocks = Math.ceil(data.length / blockSize);
            // Fills data with 0-padding
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                $f6e657627868bf3a$require$Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            const blocks = [];
            for(let i = 0; i < nbBlocks; i++){
                const head = $f6e657627868bf3a$require$Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8($f6e657627868bf3a$var$Tag, 2);
                head.writeUInt16BE(i, 3);
                // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array
                const chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push($f6e657627868bf3a$require$Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        /**
         * Reduces HID USB packets/frames to one response.
         *
         * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
         *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
         * @param chunk Current chunk to reduce into accumulator
         * @returns An accumulator value updated with the current chunk
         */ reduceResponse (acc, chunk) {
            let { data: data, dataLength: dataLength, sequence: sequence } = acc || $f6e657627868bf3a$var$initialAcc;
            if (chunk.readUInt16BE(0) !== channel) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== $f6e657627868bf3a$var$Tag) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid sequence", "InvalidSequence");
            // Gets the total length of the response from the 1st frame
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            // The total length on the 1st frame takes 2 more bytes
            const chunkData = chunk.slice(acc ? 5 : 7);
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                chunkData
            ]);
            // Removes any 0 padding
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data: data,
                dataLength: dataLength,
                sequence: sequence
            };
        },
        /**
         * Returns the response message that has been reduced from the HID USB frames
         *
         * @param acc The accumulator
         * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
         *   accumulator is incorrect (message length is not valid)
         */ getReducedResult (acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
var $f6e657627868bf3a$export$2e2bcd8739ae039 = $f6e657627868bf3a$var$createHIDframing;


var $539d2896e2490cc0$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $1Fo37 = parcelRequire("1Fo37");

var $jSdlU = parcelRequire("jSdlU");
var $1e4473f8e581e095$exports = {};

var $gEWXU = parcelRequire("gEWXU");

var $jSdlU = parcelRequire("jSdlU");
var $1e4473f8e581e095$require$MAX_LENGTH = $jSdlU.MAX_LENGTH;
var $1e4473f8e581e095$require$MAX_SAFE_INTEGER = $jSdlU.MAX_SAFE_INTEGER;

var $1Fo37 = parcelRequire("1Fo37");
var $1e4473f8e581e095$require$re = $1Fo37.safeRe;
var $1e4473f8e581e095$require$t = $1Fo37.t;
var $bd954d9ecda20689$exports = {};
// parse out just the options we care about
const $bd954d9ecda20689$var$looseOption = Object.freeze({
    loose: true
});
const $bd954d9ecda20689$var$emptyOpts = Object.freeze({});
const $bd954d9ecda20689$var$parseOptions = (options)=>{
    if (!options) return $bd954d9ecda20689$var$emptyOpts;
    if (typeof options !== "object") return $bd954d9ecda20689$var$looseOption;
    return options;
};
$bd954d9ecda20689$exports = $bd954d9ecda20689$var$parseOptions;


var $fd34b0b3a3ee3537$exports = {};
const $fd34b0b3a3ee3537$var$numeric = /^[0-9]+$/;
const $fd34b0b3a3ee3537$var$compareIdentifiers = (a, b)=>{
    const anum = $fd34b0b3a3ee3537$var$numeric.test(a);
    const bnum = $fd34b0b3a3ee3537$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $fd34b0b3a3ee3537$var$rcompareIdentifiers = (a, b)=>$fd34b0b3a3ee3537$var$compareIdentifiers(b, a);
$fd34b0b3a3ee3537$exports = {
    compareIdentifiers: $fd34b0b3a3ee3537$var$compareIdentifiers,
    rcompareIdentifiers: $fd34b0b3a3ee3537$var$rcompareIdentifiers
};


var $1e4473f8e581e095$require$compareIdentifiers = $fd34b0b3a3ee3537$exports.compareIdentifiers;
class $1e4473f8e581e095$var$SemVer {
    constructor(version, options){
        options = $bd954d9ecda20689$exports(options);
        if (version instanceof $1e4473f8e581e095$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $1e4473f8e581e095$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$1e4473f8e581e095$require$MAX_LENGTH} characters`);
        $gEWXU("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $1e4473f8e581e095$require$re[$1e4473f8e581e095$require$t.LOOSE] : $1e4473f8e581e095$require$re[$1e4473f8e581e095$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $1e4473f8e581e095$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $1e4473f8e581e095$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $1e4473f8e581e095$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $1e4473f8e581e095$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $gEWXU("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $1e4473f8e581e095$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $1e4473f8e581e095$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $1e4473f8e581e095$var$SemVer)) other = new $1e4473f8e581e095$var$SemVer(other, this.options);
        return $1e4473f8e581e095$require$compareIdentifiers(this.major, other.major) || $1e4473f8e581e095$require$compareIdentifiers(this.minor, other.minor) || $1e4473f8e581e095$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $1e4473f8e581e095$var$SemVer)) other = new $1e4473f8e581e095$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $gEWXU("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $1e4473f8e581e095$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $1e4473f8e581e095$var$SemVer)) other = new $1e4473f8e581e095$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $gEWXU("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $1e4473f8e581e095$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($1e4473f8e581e095$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$1e4473f8e581e095$exports = $1e4473f8e581e095$var$SemVer;



var $ac50e3518c9e1cf2$exports = {};

const $ac50e3518c9e1cf2$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $1e4473f8e581e095$exports) return version;
    try {
        return new $1e4473f8e581e095$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$ac50e3518c9e1cf2$exports = $ac50e3518c9e1cf2$var$parse;


var $db95228cb732f3ae$exports = {};

const $db95228cb732f3ae$var$valid = (version, options)=>{
    const v = $ac50e3518c9e1cf2$exports(version, options);
    return v ? v.version : null;
};
$db95228cb732f3ae$exports = $db95228cb732f3ae$var$valid;


var $d7c6e8ddfdf69ba0$exports = {};

const $d7c6e8ddfdf69ba0$var$clean = (version, options)=>{
    const s = $ac50e3518c9e1cf2$exports(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
$d7c6e8ddfdf69ba0$exports = $d7c6e8ddfdf69ba0$var$clean;


var $2adff7932296b4a1$exports = {};

const $2adff7932296b4a1$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $1e4473f8e581e095$exports(version instanceof $1e4473f8e581e095$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$2adff7932296b4a1$exports = $2adff7932296b4a1$var$inc;


var $ea16ec42f5b92986$exports = {};

const $ea16ec42f5b92986$var$diff = (version1, version2)=>{
    const v1 = $ac50e3518c9e1cf2$exports(version1, null, true);
    const v2 = $ac50e3518c9e1cf2$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
$ea16ec42f5b92986$exports = $ea16ec42f5b92986$var$diff;


var $a9f772bf2ec82c37$exports = {};

const $a9f772bf2ec82c37$var$major = (a, loose)=>new $1e4473f8e581e095$exports(a, loose).major;
$a9f772bf2ec82c37$exports = $a9f772bf2ec82c37$var$major;


var $200c8f484cecd1b4$exports = {};

const $200c8f484cecd1b4$var$minor = (a, loose)=>new $1e4473f8e581e095$exports(a, loose).minor;
$200c8f484cecd1b4$exports = $200c8f484cecd1b4$var$minor;


var $c2da00223bba0b8c$exports = {};

const $c2da00223bba0b8c$var$patch = (a, loose)=>new $1e4473f8e581e095$exports(a, loose).patch;
$c2da00223bba0b8c$exports = $c2da00223bba0b8c$var$patch;


var $60d6acf9d2bdd3b1$exports = {};

const $60d6acf9d2bdd3b1$var$prerelease = (version, options)=>{
    const parsed = $ac50e3518c9e1cf2$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$60d6acf9d2bdd3b1$exports = $60d6acf9d2bdd3b1$var$prerelease;


var $42aeb1291fd03fc0$exports = {};

const $42aeb1291fd03fc0$var$compare = (a, b, loose)=>new $1e4473f8e581e095$exports(a, loose).compare(new $1e4473f8e581e095$exports(b, loose));
$42aeb1291fd03fc0$exports = $42aeb1291fd03fc0$var$compare;


var $c6d663ec58e3e7cf$exports = {};

const $c6d663ec58e3e7cf$var$rcompare = (a, b, loose)=>$42aeb1291fd03fc0$exports(b, a, loose);
$c6d663ec58e3e7cf$exports = $c6d663ec58e3e7cf$var$rcompare;


var $6fec160e5a73e282$exports = {};

const $6fec160e5a73e282$var$compareLoose = (a, b)=>$42aeb1291fd03fc0$exports(a, b, true);
$6fec160e5a73e282$exports = $6fec160e5a73e282$var$compareLoose;


var $8385fbf3937ed3fc$exports = {};

const $8385fbf3937ed3fc$var$compareBuild = (a, b, loose)=>{
    const versionA = new $1e4473f8e581e095$exports(a, loose);
    const versionB = new $1e4473f8e581e095$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$8385fbf3937ed3fc$exports = $8385fbf3937ed3fc$var$compareBuild;


var $cb1ac480c631008e$exports = {};

const $cb1ac480c631008e$var$sort = (list, loose)=>list.sort((a, b)=>$8385fbf3937ed3fc$exports(a, b, loose));
$cb1ac480c631008e$exports = $cb1ac480c631008e$var$sort;


var $ca4c2d54ccf32f90$exports = {};

const $ca4c2d54ccf32f90$var$rsort = (list, loose)=>list.sort((a, b)=>$8385fbf3937ed3fc$exports(b, a, loose));
$ca4c2d54ccf32f90$exports = $ca4c2d54ccf32f90$var$rsort;


var $1cfd9dd6d5d8642b$exports = {};

const $1cfd9dd6d5d8642b$var$gt = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) > 0;
$1cfd9dd6d5d8642b$exports = $1cfd9dd6d5d8642b$var$gt;


var $67be25f2a57c1f4b$exports = {};

const $67be25f2a57c1f4b$var$lt = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) < 0;
$67be25f2a57c1f4b$exports = $67be25f2a57c1f4b$var$lt;


var $ae13d80577a02a8c$exports = {};

const $ae13d80577a02a8c$var$eq = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) === 0;
$ae13d80577a02a8c$exports = $ae13d80577a02a8c$var$eq;


var $0347570ff01aa9a7$exports = {};

const $0347570ff01aa9a7$var$neq = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) !== 0;
$0347570ff01aa9a7$exports = $0347570ff01aa9a7$var$neq;


var $c8f1ecff3479a8a9$exports = {};

const $c8f1ecff3479a8a9$var$gte = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) >= 0;
$c8f1ecff3479a8a9$exports = $c8f1ecff3479a8a9$var$gte;


var $8ba759eb19d04fe3$exports = {};

const $8ba759eb19d04fe3$var$lte = (a, b, loose)=>$42aeb1291fd03fc0$exports(a, b, loose) <= 0;
$8ba759eb19d04fe3$exports = $8ba759eb19d04fe3$var$lte;


var $f63679aa696cc7c2$exports = {};






const $f63679aa696cc7c2$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $ae13d80577a02a8c$exports(a, b, loose);
        case "!=":
            return $0347570ff01aa9a7$exports(a, b, loose);
        case ">":
            return $1cfd9dd6d5d8642b$exports(a, b, loose);
        case ">=":
            return $c8f1ecff3479a8a9$exports(a, b, loose);
        case "<":
            return $67be25f2a57c1f4b$exports(a, b, loose);
        case "<=":
            return $8ba759eb19d04fe3$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$f63679aa696cc7c2$exports = $f63679aa696cc7c2$var$cmp;


var $c04e66671d64d088$exports = {};



var $1Fo37 = parcelRequire("1Fo37");
var $c04e66671d64d088$require$re = $1Fo37.safeRe;
var $c04e66671d64d088$require$t = $1Fo37.t;
const $c04e66671d64d088$var$coerce = (version, options)=>{
    if (version instanceof $1e4473f8e581e095$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $c04e66671d64d088$require$re[$c04e66671d64d088$require$t.COERCEFULL] : $c04e66671d64d088$require$re[$c04e66671d64d088$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $c04e66671d64d088$require$re[$c04e66671d64d088$require$t.COERCERTLFULL] : $c04e66671d64d088$require$re[$c04e66671d64d088$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || "0";
    const patch = match[4] || "0";
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "";
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
    return $ac50e3518c9e1cf2$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$c04e66671d64d088$exports = $c04e66671d64d088$var$coerce;


var $23c2aa77ee272450$exports = {};
const $23c2aa77ee272450$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $23c2aa77ee272450$var$Comparator {
    static get ANY() {
        return $23c2aa77ee272450$var$ANY;
    }
    constructor(comp, options){
        options = $bd954d9ecda20689$exports(options);
        if (comp instanceof $23c2aa77ee272450$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $gEWXU("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $23c2aa77ee272450$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $gEWXU("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $23c2aa77ee272450$require$re[$23c2aa77ee272450$require$t.COMPARATORLOOSE] : $23c2aa77ee272450$require$re[$23c2aa77ee272450$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $23c2aa77ee272450$var$ANY;
        else this.semver = new $1e4473f8e581e095$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $gEWXU("Comparator.test", version, this.options.loose);
        if (this.semver === $23c2aa77ee272450$var$ANY || version === $23c2aa77ee272450$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $1e4473f8e581e095$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $f63679aa696cc7c2$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $23c2aa77ee272450$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $f2fea88ed1a42bf2$exports(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $f2fea88ed1a42bf2$exports(this.value, options).test(comp.semver);
        }
        options = $bd954d9ecda20689$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($f63679aa696cc7c2$exports(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($f63679aa696cc7c2$exports(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
$23c2aa77ee272450$exports = $23c2aa77ee272450$var$Comparator;


var $1Fo37 = parcelRequire("1Fo37");
var $23c2aa77ee272450$require$re = $1Fo37.safeRe;
var $23c2aa77ee272450$require$t = $1Fo37.t;


var $gEWXU = parcelRequire("gEWXU");

var $f2fea88ed1a42bf2$exports = {};
// hoisted class for cyclic dependency
class $f2fea88ed1a42bf2$var$Range {
    constructor(range, options){
        options = $bd954d9ecda20689$exports(options);
        if (range instanceof $f2fea88ed1a42bf2$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $f2fea88ed1a42bf2$var$Range(range.raw, options);
        }
        if (range instanceof $23c2aa77ee272450$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$f2fea88ed1a42bf2$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $f2fea88ed1a42bf2$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $f2fea88ed1a42bf2$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $f2fea88ed1a42bf2$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $f2fea88ed1a42bf2$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.HYPHENRANGELOOSE] : $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.HYPHENRANGE];
        range = range.replace(hr, $f2fea88ed1a42bf2$var$hyphenReplace(this.options.includePrerelease));
        $gEWXU("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.COMPARATORTRIM], $f2fea88ed1a42bf2$require$comparatorTrimReplace);
        $gEWXU("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.TILDETRIM], $f2fea88ed1a42bf2$require$tildeTrimReplace);
        $gEWXU("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.CARETTRIM], $f2fea88ed1a42bf2$require$caretTrimReplace);
        $gEWXU("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$f2fea88ed1a42bf2$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$f2fea88ed1a42bf2$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $gEWXU("loose invalid filter", comp, this.options);
            return !!comp.match($f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.COMPARATORLOOSE]);
        });
        $gEWXU("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $23c2aa77ee272450$exports(comp, this.options));
        for (const comp of comparators){
            if ($f2fea88ed1a42bf2$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $f2fea88ed1a42bf2$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $f2fea88ed1a42bf2$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $f2fea88ed1a42bf2$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $f2fea88ed1a42bf2$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $1e4473f8e581e095$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($f2fea88ed1a42bf2$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$f2fea88ed1a42bf2$exports = $f2fea88ed1a42bf2$var$Range;
var $f1b33d607deec3e4$exports = {};
"use strict";
var $77e415249fc12733$exports = {};
"use strict";
$77e415249fc12733$exports = $77e415249fc12733$var$Yallist;
$77e415249fc12733$var$Yallist.Node = $77e415249fc12733$var$Node;
$77e415249fc12733$var$Yallist.create = $77e415249fc12733$var$Yallist;
function $77e415249fc12733$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $77e415249fc12733$var$Yallist)) self = new $77e415249fc12733$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$77e415249fc12733$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$77e415249fc12733$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$77e415249fc12733$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$77e415249fc12733$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$77e415249fc12733$var$push(this, arguments[i]);
    return this.length;
};
$77e415249fc12733$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$77e415249fc12733$var$unshift(this, arguments[i]);
    return this.length;
};
$77e415249fc12733$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$77e415249fc12733$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$77e415249fc12733$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$77e415249fc12733$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$77e415249fc12733$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$77e415249fc12733$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$77e415249fc12733$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $77e415249fc12733$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$77e415249fc12733$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $77e415249fc12733$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$77e415249fc12733$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$77e415249fc12733$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$77e415249fc12733$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$77e415249fc12733$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$77e415249fc12733$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $77e415249fc12733$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$77e415249fc12733$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $77e415249fc12733$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$77e415249fc12733$var$Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $77e415249fc12733$var$insert(this, walker, nodes[i]);
    return ret;
};
$77e415249fc12733$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $77e415249fc12733$var$insert(self, node, value) {
    var inserted = node === self.head ? new $77e415249fc12733$var$Node(value, null, node, self) : new $77e415249fc12733$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $77e415249fc12733$var$push(self, item) {
    self.tail = new $77e415249fc12733$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $77e415249fc12733$var$unshift(self, item) {
    self.head = new $77e415249fc12733$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $77e415249fc12733$var$Node(value, prev, next, list) {
    if (!(this instanceof $77e415249fc12733$var$Node)) return new $77e415249fc12733$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("3ByjW"))($77e415249fc12733$var$Yallist);
} catch (er) {}


const $f1b33d607deec3e4$var$MAX = Symbol("max");
const $f1b33d607deec3e4$var$LENGTH = Symbol("length");
const $f1b33d607deec3e4$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $f1b33d607deec3e4$var$ALLOW_STALE = Symbol("allowStale");
const $f1b33d607deec3e4$var$MAX_AGE = Symbol("maxAge");
const $f1b33d607deec3e4$var$DISPOSE = Symbol("dispose");
const $f1b33d607deec3e4$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $f1b33d607deec3e4$var$LRU_LIST = Symbol("lruList");
const $f1b33d607deec3e4$var$CACHE = Symbol("cache");
const $f1b33d607deec3e4$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $f1b33d607deec3e4$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $f1b33d607deec3e4$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$f1b33d607deec3e4$var$MAX] = options.max || Infinity;
        const lc = options.length || $f1b33d607deec3e4$var$naiveLength;
        this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $f1b33d607deec3e4$var$naiveLength : lc;
        this[$f1b33d607deec3e4$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$f1b33d607deec3e4$var$MAX_AGE] = options.maxAge || 0;
        this[$f1b33d607deec3e4$var$DISPOSE] = options.dispose;
        this[$f1b33d607deec3e4$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$f1b33d607deec3e4$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$f1b33d607deec3e4$var$MAX] = mL || Infinity;
        $f1b33d607deec3e4$var$trim(this);
    }
    get max() {
        return this[$f1b33d607deec3e4$var$MAX];
    }
    set allowStale(allowStale) {
        this[$f1b33d607deec3e4$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$f1b33d607deec3e4$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$f1b33d607deec3e4$var$MAX_AGE] = mA;
        $f1b33d607deec3e4$var$trim(this);
    }
    get maxAge() {
        return this[$f1b33d607deec3e4$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $f1b33d607deec3e4$var$naiveLength;
        if (lC !== this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR]) {
            this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR] = lC;
            this[$f1b33d607deec3e4$var$LENGTH] = 0;
            this[$f1b33d607deec3e4$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$f1b33d607deec3e4$var$LENGTH] += hit.length;
            });
        }
        $f1b33d607deec3e4$var$trim(this);
    }
    get lengthCalculator() {
        return this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$f1b33d607deec3e4$var$LENGTH];
    }
    get itemCount() {
        return this[$f1b33d607deec3e4$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$f1b33d607deec3e4$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $f1b33d607deec3e4$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$f1b33d607deec3e4$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $f1b33d607deec3e4$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$f1b33d607deec3e4$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$f1b33d607deec3e4$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$f1b33d607deec3e4$var$DISPOSE] && this[$f1b33d607deec3e4$var$LRU_LIST] && this[$f1b33d607deec3e4$var$LRU_LIST].length) this[$f1b33d607deec3e4$var$LRU_LIST].forEach((hit)=>this[$f1b33d607deec3e4$var$DISPOSE](hit.key, hit.value));
        this[$f1b33d607deec3e4$var$CACHE] = new Map() // hash of items by key
        ;
        this[$f1b33d607deec3e4$var$LRU_LIST] = new $77e415249fc12733$exports() // list of items in order of use recency
        ;
        this[$f1b33d607deec3e4$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$f1b33d607deec3e4$var$LRU_LIST].map((hit)=>$f1b33d607deec3e4$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$f1b33d607deec3e4$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$f1b33d607deec3e4$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$f1b33d607deec3e4$var$LENGTH_CALCULATOR](value, key);
        if (this[$f1b33d607deec3e4$var$CACHE].has(key)) {
            if (len > this[$f1b33d607deec3e4$var$MAX]) {
                $f1b33d607deec3e4$var$del(this, this[$f1b33d607deec3e4$var$CACHE].get(key));
                return false;
            }
            const node = this[$f1b33d607deec3e4$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$f1b33d607deec3e4$var$DISPOSE]) {
                if (!this[$f1b33d607deec3e4$var$NO_DISPOSE_ON_SET]) this[$f1b33d607deec3e4$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$f1b33d607deec3e4$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $f1b33d607deec3e4$var$trim(this);
            return true;
        }
        const hit = new $f1b33d607deec3e4$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$f1b33d607deec3e4$var$MAX]) {
            if (this[$f1b33d607deec3e4$var$DISPOSE]) this[$f1b33d607deec3e4$var$DISPOSE](key, value);
            return false;
        }
        this[$f1b33d607deec3e4$var$LENGTH] += hit.length;
        this[$f1b33d607deec3e4$var$LRU_LIST].unshift(hit);
        this[$f1b33d607deec3e4$var$CACHE].set(key, this[$f1b33d607deec3e4$var$LRU_LIST].head);
        $f1b33d607deec3e4$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$f1b33d607deec3e4$var$CACHE].has(key)) return false;
        const hit = this[$f1b33d607deec3e4$var$CACHE].get(key).value;
        return !$f1b33d607deec3e4$var$isStale(this, hit);
    }
    get(key) {
        return $f1b33d607deec3e4$var$get(this, key, true);
    }
    peek(key) {
        return $f1b33d607deec3e4$var$get(this, key, false);
    }
    pop() {
        const node = this[$f1b33d607deec3e4$var$LRU_LIST].tail;
        if (!node) return null;
        $f1b33d607deec3e4$var$del(this, node);
        return node.value;
    }
    del(key) {
        $f1b33d607deec3e4$var$del(this, this[$f1b33d607deec3e4$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$f1b33d607deec3e4$var$CACHE].forEach((value, key)=>$f1b33d607deec3e4$var$get(this, key, false));
    }
}
const $f1b33d607deec3e4$var$get = (self, key, doUse)=>{
    const node = self[$f1b33d607deec3e4$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($f1b33d607deec3e4$var$isStale(self, hit)) {
            $f1b33d607deec3e4$var$del(self, node);
            if (!self[$f1b33d607deec3e4$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$f1b33d607deec3e4$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$f1b33d607deec3e4$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $f1b33d607deec3e4$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$f1b33d607deec3e4$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$f1b33d607deec3e4$var$MAX_AGE] && diff > self[$f1b33d607deec3e4$var$MAX_AGE];
};
const $f1b33d607deec3e4$var$trim = (self)=>{
    if (self[$f1b33d607deec3e4$var$LENGTH] > self[$f1b33d607deec3e4$var$MAX]) for(let walker = self[$f1b33d607deec3e4$var$LRU_LIST].tail; self[$f1b33d607deec3e4$var$LENGTH] > self[$f1b33d607deec3e4$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $f1b33d607deec3e4$var$del(self, walker);
        walker = prev;
    }
};
const $f1b33d607deec3e4$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$f1b33d607deec3e4$var$DISPOSE]) self[$f1b33d607deec3e4$var$DISPOSE](hit.key, hit.value);
        self[$f1b33d607deec3e4$var$LENGTH] -= hit.length;
        self[$f1b33d607deec3e4$var$CACHE].delete(hit.key);
        self[$f1b33d607deec3e4$var$LRU_LIST].removeNode(node);
    }
};
class $f1b33d607deec3e4$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $f1b33d607deec3e4$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($f1b33d607deec3e4$var$isStale(self, hit)) {
        $f1b33d607deec3e4$var$del(self, node);
        if (!self[$f1b33d607deec3e4$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
$f1b33d607deec3e4$exports = $f1b33d607deec3e4$var$LRUCache;


const $f2fea88ed1a42bf2$var$cache = new $f1b33d607deec3e4$exports({
    max: 1000
});



var $gEWXU = parcelRequire("gEWXU");


var $1Fo37 = parcelRequire("1Fo37");
var $f2fea88ed1a42bf2$require$re = $1Fo37.safeRe;
var $f2fea88ed1a42bf2$require$t = $1Fo37.t;
var $f2fea88ed1a42bf2$require$comparatorTrimReplace = $1Fo37.comparatorTrimReplace;
var $f2fea88ed1a42bf2$require$tildeTrimReplace = $1Fo37.tildeTrimReplace;
var $f2fea88ed1a42bf2$require$caretTrimReplace = $1Fo37.caretTrimReplace;

var $jSdlU = parcelRequire("jSdlU");
var $f2fea88ed1a42bf2$require$FLAG_INCLUDE_PRERELEASE = $jSdlU.FLAG_INCLUDE_PRERELEASE;
var $f2fea88ed1a42bf2$require$FLAG_LOOSE = $jSdlU.FLAG_LOOSE;
const $f2fea88ed1a42bf2$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $f2fea88ed1a42bf2$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $f2fea88ed1a42bf2$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $f2fea88ed1a42bf2$var$parseComparator = (comp, options)=>{
    $gEWXU("comp", comp, options);
    comp = $f2fea88ed1a42bf2$var$replaceCarets(comp, options);
    $gEWXU("caret", comp);
    comp = $f2fea88ed1a42bf2$var$replaceTildes(comp, options);
    $gEWXU("tildes", comp);
    comp = $f2fea88ed1a42bf2$var$replaceXRanges(comp, options);
    $gEWXU("xrange", comp);
    comp = $f2fea88ed1a42bf2$var$replaceStars(comp, options);
    $gEWXU("stars", comp);
    return comp;
};
const $f2fea88ed1a42bf2$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $f2fea88ed1a42bf2$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$f2fea88ed1a42bf2$var$replaceTilde(c, options)).join(" ");
};
const $f2fea88ed1a42bf2$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.TILDELOOSE] : $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $gEWXU("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($f2fea88ed1a42bf2$var$isX(M)) ret = "";
        else if ($f2fea88ed1a42bf2$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($f2fea88ed1a42bf2$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $gEWXU("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $gEWXU("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $f2fea88ed1a42bf2$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$f2fea88ed1a42bf2$var$replaceCaret(c, options)).join(" ");
};
const $f2fea88ed1a42bf2$var$replaceCaret = (comp, options)=>{
    $gEWXU("caret", comp, options);
    const r = options.loose ? $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.CARETLOOSE] : $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $gEWXU("caret", comp, _, M, m, p, pr);
        let ret;
        if ($f2fea88ed1a42bf2$var$isX(M)) ret = "";
        else if ($f2fea88ed1a42bf2$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($f2fea88ed1a42bf2$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $gEWXU("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $gEWXU("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $gEWXU("caret return", ret);
        return ret;
    });
};
const $f2fea88ed1a42bf2$var$replaceXRanges = (comp, options)=>{
    $gEWXU("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$f2fea88ed1a42bf2$var$replaceXRange(c, options)).join(" ");
};
const $f2fea88ed1a42bf2$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.XRANGELOOSE] : $f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $gEWXU("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $f2fea88ed1a42bf2$var$isX(M);
        const xm = xM || $f2fea88ed1a42bf2$var$isX(m);
        const xp = xm || $f2fea88ed1a42bf2$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $gEWXU("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $f2fea88ed1a42bf2$var$replaceStars = (comp, options)=>{
    $gEWXU("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($f2fea88ed1a42bf2$require$re[$f2fea88ed1a42bf2$require$t.STAR], "");
};
const $f2fea88ed1a42bf2$var$replaceGTE0 = (comp, options)=>{
    $gEWXU("replaceGTE0", comp, options);
    return comp.trim().replace($f2fea88ed1a42bf2$require$re[options.includePrerelease ? $f2fea88ed1a42bf2$require$t.GTE0PRE : $f2fea88ed1a42bf2$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const $f2fea88ed1a42bf2$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if ($f2fea88ed1a42bf2$var$isX(fM)) from = "";
        else if ($f2fea88ed1a42bf2$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($f2fea88ed1a42bf2$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($f2fea88ed1a42bf2$var$isX(tM)) to = "";
        else if ($f2fea88ed1a42bf2$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($f2fea88ed1a42bf2$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $f2fea88ed1a42bf2$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $gEWXU(set[i].semver);
            if (set[i].semver === $23c2aa77ee272450$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $f133c999a2800a69$exports = {};

const $f133c999a2800a69$var$satisfies = (version, range, options)=>{
    try {
        range = new $f2fea88ed1a42bf2$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$f133c999a2800a69$exports = $f133c999a2800a69$var$satisfies;


var $c1babdbfb864e5fa$exports = {};

// Mostly just for testing and legacy API reasons
const $c1babdbfb864e5fa$var$toComparators = (range, options)=>new $f2fea88ed1a42bf2$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
$c1babdbfb864e5fa$exports = $c1babdbfb864e5fa$var$toComparators;


var $227feb2c2e1f8148$exports = {};


const $227feb2c2e1f8148$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $f2fea88ed1a42bf2$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $1e4473f8e581e095$exports(max, options);
            }
        }
    });
    return max;
};
$227feb2c2e1f8148$exports = $227feb2c2e1f8148$var$maxSatisfying;


var $6d60cc5111feaad6$exports = {};


const $6d60cc5111feaad6$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $f2fea88ed1a42bf2$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $1e4473f8e581e095$exports(min, options);
            }
        }
    });
    return min;
};
$6d60cc5111feaad6$exports = $6d60cc5111feaad6$var$minSatisfying;


var $58a6fea5bacc5f32$exports = {};



const $58a6fea5bacc5f32$var$minVersion = (range, loose)=>{
    range = new $f2fea88ed1a42bf2$exports(range, loose);
    let minver = new $1e4473f8e581e095$exports("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $1e4473f8e581e095$exports("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $1e4473f8e581e095$exports(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $1cfd9dd6d5d8642b$exports(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $1cfd9dd6d5d8642b$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$58a6fea5bacc5f32$exports = $58a6fea5bacc5f32$var$minVersion;


var $d9be8e75e1acd804$exports = {};

const $d9be8e75e1acd804$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $f2fea88ed1a42bf2$exports(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
$d9be8e75e1acd804$exports = $d9be8e75e1acd804$var$validRange;


var $f3ff839f6a966182$exports = {};


const { ANY: $f3ff839f6a966182$var$ANY } = $23c2aa77ee272450$exports;






const $f3ff839f6a966182$var$outside = (version, range, hilo, options)=>{
    version = new $1e4473f8e581e095$exports(version, options);
    range = new $f2fea88ed1a42bf2$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $1cfd9dd6d5d8642b$exports;
            ltefn = $8ba759eb19d04fe3$exports;
            ltfn = $67be25f2a57c1f4b$exports;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $67be25f2a57c1f4b$exports;
            ltefn = $c8f1ecff3479a8a9$exports;
            ltfn = $1cfd9dd6d5d8642b$exports;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($f133c999a2800a69$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $f3ff839f6a966182$var$ANY) comparator = new $23c2aa77ee272450$exports(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$f3ff839f6a966182$exports = $f3ff839f6a966182$var$outside;


var $d8028209cb026184$exports = {};
// Determine if version is greater than all the versions possible in the range.

const $d8028209cb026184$var$gtr = (version, range, options)=>$f3ff839f6a966182$exports(version, range, ">", options);
$d8028209cb026184$exports = $d8028209cb026184$var$gtr;


var $0e5bd06d669b372c$exports = {};

// Determine if version is less than all the versions possible in the range
const $0e5bd06d669b372c$var$ltr = (version, range, options)=>$f3ff839f6a966182$exports(version, range, "<", options);
$0e5bd06d669b372c$exports = $0e5bd06d669b372c$var$ltr;


var $5175712e5cddb65c$exports = {};

const $5175712e5cddb65c$var$intersects = (r1, r2, options)=>{
    r1 = new $f2fea88ed1a42bf2$exports(r1, options);
    r2 = new $f2fea88ed1a42bf2$exports(r2, options);
    return r1.intersects(r2, options);
};
$5175712e5cddb65c$exports = $5175712e5cddb65c$var$intersects;


var $3868a49c4ae492eb$exports = {};
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.


$3868a49c4ae492eb$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$42aeb1291fd03fc0$exports(a, b, options));
    for (const version of v){
        const included = $f133c999a2800a69$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $96131c64a2bc287a$exports = {};


const { ANY: $96131c64a2bc287a$var$ANY } = $23c2aa77ee272450$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $96131c64a2bc287a$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $f2fea88ed1a42bf2$exports(sub, options);
    dom = new $f2fea88ed1a42bf2$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $96131c64a2bc287a$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $96131c64a2bc287a$var$minimumVersionWithPreRelease = [
    new $23c2aa77ee272450$exports(">=0.0.0-0")
];
const $96131c64a2bc287a$var$minimumVersion = [
    new $23c2aa77ee272450$exports(">=0.0.0")
];
const $96131c64a2bc287a$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $96131c64a2bc287a$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $96131c64a2bc287a$var$ANY) return true;
        else if (options.includePrerelease) sub = $96131c64a2bc287a$var$minimumVersionWithPreRelease;
        else sub = $96131c64a2bc287a$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $96131c64a2bc287a$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $96131c64a2bc287a$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $96131c64a2bc287a$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $96131c64a2bc287a$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $42aeb1291fd03fc0$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$f133c999a2800a69$exports(eq, String(gt), options)) return null;
        if (lt && !$f133c999a2800a69$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$f133c999a2800a69$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $96131c64a2bc287a$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$f133c999a2800a69$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $96131c64a2bc287a$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$f133c999a2800a69$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $96131c64a2bc287a$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $42aeb1291fd03fc0$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $96131c64a2bc287a$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $42aeb1291fd03fc0$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
$96131c64a2bc287a$exports = $96131c64a2bc287a$var$subset;


$539d2896e2490cc0$exports = {
    parse: $ac50e3518c9e1cf2$exports,
    valid: $db95228cb732f3ae$exports,
    clean: $d7c6e8ddfdf69ba0$exports,
    inc: $2adff7932296b4a1$exports,
    diff: $ea16ec42f5b92986$exports,
    major: $a9f772bf2ec82c37$exports,
    minor: $200c8f484cecd1b4$exports,
    patch: $c2da00223bba0b8c$exports,
    prerelease: $60d6acf9d2bdd3b1$exports,
    compare: $42aeb1291fd03fc0$exports,
    rcompare: $c6d663ec58e3e7cf$exports,
    compareLoose: $6fec160e5a73e282$exports,
    compareBuild: $8385fbf3937ed3fc$exports,
    sort: $cb1ac480c631008e$exports,
    rsort: $ca4c2d54ccf32f90$exports,
    gt: $1cfd9dd6d5d8642b$exports,
    lt: $67be25f2a57c1f4b$exports,
    eq: $ae13d80577a02a8c$exports,
    neq: $0347570ff01aa9a7$exports,
    gte: $c8f1ecff3479a8a9$exports,
    lte: $8ba759eb19d04fe3$exports,
    cmp: $f63679aa696cc7c2$exports,
    coerce: $c04e66671d64d088$exports,
    Comparator: $23c2aa77ee272450$exports,
    Range: $f2fea88ed1a42bf2$exports,
    satisfies: $f133c999a2800a69$exports,
    toComparators: $c1babdbfb864e5fa$exports,
    maxSatisfying: $227feb2c2e1f8148$exports,
    minSatisfying: $6d60cc5111feaad6$exports,
    minVersion: $58a6fea5bacc5f32$exports,
    validRange: $d9be8e75e1acd804$exports,
    outside: $f3ff839f6a966182$exports,
    gtr: $d8028209cb026184$exports,
    ltr: $0e5bd06d669b372c$exports,
    intersects: $5175712e5cddb65c$exports,
    simplifyRange: $3868a49c4ae492eb$exports,
    subset: $96131c64a2bc287a$exports,
    SemVer: $1e4473f8e581e095$exports,
    re: $1Fo37.re,
    src: $1Fo37.src,
    tokens: $1Fo37.t,
    SEMVER_SPEC_VERSION: $jSdlU.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $jSdlU.RELEASE_TYPES,
    compareIdentifiers: $fd34b0b3a3ee3537$exports.compareIdentifiers,
    rcompareIdentifiers: $fd34b0b3a3ee3537$exports.rcompareIdentifiers
};


const $5dec73da4f32e22b$export$36f742de2ed7d90b = 0x01;
const $5dec73da4f32e22b$export$54bc2e040474338c = 0x02;
const $5dec73da4f32e22b$export$9368aec5a4b02506 = 0x04;
const $5dec73da4f32e22b$export$95f5e559ebc551b3 = 0x08;
const $5dec73da4f32e22b$export$18b064749618be01 = 0x10;
var $5dec73da4f32e22b$export$b8d24b2c0d9c5549;
(function(DeviceModelId) {
    DeviceModelId["blue"] = "blue";
    DeviceModelId["nanoS"] = "nanoS";
    DeviceModelId["nanoSP"] = "nanoSP";
    DeviceModelId["nanoX"] = "nanoX";
    DeviceModelId["stax"] = "stax";
    DeviceModelId["europa"] = "europa";
})($5dec73da4f32e22b$export$b8d24b2c0d9c5549 || ($5dec73da4f32e22b$export$b8d24b2c0d9c5549 = {}));
const $5dec73da4f32e22b$var$devices = {
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
        productName: "Ledger\xa0Blue",
        productIdMM: 0x00,
        legacyUsbProductId: 0x0000,
        usbOnly: true,
        memorySize: 491520,
        masks: [
            0x31000000,
            0x31010000
        ],
        getBlockSize: (_firwareVersion)=>4096
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
        productName: "Ledger\xa0Nano\xa0S",
        productIdMM: 0x10,
        legacyUsbProductId: 0x0001,
        usbOnly: true,
        memorySize: 327680,
        masks: [
            0x31100000
        ],
        getBlockSize: (firmwareVersion)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($539d2896e2490cc0$exports))).lt((_a = (0, (/*@__PURE__*/$parcel$interopDefault($539d2896e2490cc0$exports))).coerce(firmwareVersion)) !== null && _a !== void 0 ? _a : "", "2.0.0") ? 4096 : 2048;
        }
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
        productName: "Ledger\xa0Nano\xa0X",
        productIdMM: 0x40,
        legacyUsbProductId: 0x0004,
        usbOnly: false,
        memorySize: 2097152,
        masks: [
            0x33000000
        ],
        getBlockSize: (_firwareVersion)=>4096,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
        productName: "Ledger Nano S Plus",
        productIdMM: 0x50,
        legacyUsbProductId: 0x0005,
        usbOnly: true,
        memorySize: 1569792,
        masks: [
            0x33100000
        ],
        getBlockSize: (_firmwareVersion)=>32
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
        productName: "Ledger\xa0Stax",
        productIdMM: 0x60,
        legacyUsbProductId: 0x0006,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33200000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa,
        productName: "Ledger Europa",
        productIdMM: 0x70,
        legacyUsbProductId: 0x0007,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33300000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
            }
        ]
    }
};
const $5dec73da4f32e22b$var$productMap = {
    Blue: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
    "Nano S": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
    "Nano S Plus": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
    "Nano X": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
    Stax: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
    Europa: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa
};
const $5dec73da4f32e22b$var$devicesList = Object.values($5dec73da4f32e22b$var$devices);
const $5dec73da4f32e22b$export$268c42a4ddec87f3 = 0x2c97;
const $5dec73da4f32e22b$export$289d48518583cbd7 = (id)=>{
    const info = $5dec73da4f32e22b$var$devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
const $5dec73da4f32e22b$export$f656be11ec4fd95b = (targetId)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find(({ masks: masks })=>masks.find((mask)=>(targetId & 0xffff0000) === mask));
    return deviceModel;
};
const $5dec73da4f32e22b$export$df8f4444a7c73154 = (usbProductId)=>{
    const legacy = $5dec73da4f32e22b$var$devicesList.find((d)=>d.legacyUsbProductId === usbProductId);
    if (legacy) return legacy;
    const mm = usbProductId >> 8;
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.productIdMM === mm);
    return deviceModel;
};
const $5dec73da4f32e22b$export$dce0906e1912b553 = (productName)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.id === $5dec73da4f32e22b$var$productMap[productName]);
    return deviceModel;
};
const $5dec73da4f32e22b$var$bluetoothServices = [];
const $5dec73da4f32e22b$var$serviceUuidToInfos = {};
for(const id in $5dec73da4f32e22b$var$devices){
    const deviceModel = $5dec73da4f32e22b$var$devices[id];
    const { bluetoothSpec: bluetoothSpec } = deviceModel;
    if (bluetoothSpec) for(let i = 0; i < bluetoothSpec.length; i++){
        const spec = bluetoothSpec[i];
        $5dec73da4f32e22b$var$bluetoothServices.push(spec.serviceUuid);
        $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid] = $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid.replace(/-/g, "")] = Object.assign({
            deviceModel: deviceModel
        }, spec);
    }
}
const $5dec73da4f32e22b$export$1f1251c1c71d84cf = ()=>$5dec73da4f32e22b$var$bluetoothServices;
const $5dec73da4f32e22b$export$8c98567a3882f79e = (uuid)=>$5dec73da4f32e22b$var$serviceUuidToInfos[uuid.toLowerCase()];





var $b3a6d5950238cf2e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b3a6d5950238cf2e$var$ledgerDevices = [
    {
        vendorId: (0, $5dec73da4f32e22b$export$268c42a4ddec87f3)
    }
];
function $b3a6d5950238cf2e$export$5e45f905eefbea79() {
    return $b3a6d5950238cf2e$var$__awaiter(this, void 0, void 0, function*() {
        const device = yield navigator.usb.requestDevice({
            filters: $b3a6d5950238cf2e$var$ledgerDevices
        });
        return device;
    });
}
function $b3a6d5950238cf2e$export$36755904a34d5197() {
    return $b3a6d5950238cf2e$var$__awaiter(this, void 0, void 0, function*() {
        const devices = yield navigator.usb.getDevices();
        return devices.filter((d)=>d.vendorId === (0, $5dec73da4f32e22b$export$268c42a4ddec87f3));
    });
}
function $b3a6d5950238cf2e$export$527d8164321a6e6c() {
    return $b3a6d5950238cf2e$var$__awaiter(this, void 0, void 0, function*() {
        const existingDevices = yield $b3a6d5950238cf2e$export$36755904a34d5197();
        if (existingDevices.length > 0) return existingDevices[0];
        return $b3a6d5950238cf2e$export$5e45f905eefbea79();
    });
}
const $b3a6d5950238cf2e$export$48c17662a6902497 = ()=>Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices === "function");



var $6ZWSX = parcelRequire("6ZWSX");
var $8d7dfafe1dbfbf06$require$Buffer = $6ZWSX.Buffer;
var $8d7dfafe1dbfbf06$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8d7dfafe1dbfbf06$var$configurationValue = 1;
const $8d7dfafe1dbfbf06$var$endpointNumber = 3;
/**
 * WebUSB Transport implementation
 * @example
 * import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
 * ...
 * TransportWebUSB.create().then(transport => ...)
 */ class $8d7dfafe1dbfbf06$var$TransportWebUSB extends (0, $375818ecee1623c3$export$2e2bcd8739ae039) {
    constructor(device, interfaceNumber){
        super();
        this.channel = Math.floor(Math.random() * 0xffff);
        this.packetSize = 64;
        this._disconnectEmitted = false;
        this._emitDisconnect = (e)=>{
            if (this._disconnectEmitted) return;
            this._disconnectEmitted = true;
            this.emit("disconnect", e);
        };
        this.device = device;
        this.interfaceNumber = interfaceNumber;
        this.deviceModel = (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId);
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ static request() {
        return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
            const device = yield (0, $b3a6d5950238cf2e$export$5e45f905eefbea79)();
            return $8d7dfafe1dbfbf06$var$TransportWebUSB.open(device);
        });
    }
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ static openConnected() {
        return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
            const devices = yield (0, $b3a6d5950238cf2e$export$36755904a34d5197)();
            if (devices.length === 0) return null;
            return $8d7dfafe1dbfbf06$var$TransportWebUSB.open(devices[0]);
        });
    }
    /**
     * Create a Ledger transport with a USBDevice
     */ static open(device) {
        return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
            yield device.open();
            if (device.configuration === null) yield device.selectConfiguration($8d7dfafe1dbfbf06$var$configurationValue);
            yield $8d7dfafe1dbfbf06$var$gracefullyResetDevice(device);
            const iface = device.configurations[0].interfaces.find(({ alternates: alternates })=>alternates.some((a)=>a.interfaceClass === 255));
            if (!iface) throw new (0, $9a194f74559621d2$export$fd71e3a51c4bf0ae)("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
            const interfaceNumber = iface.interfaceNumber;
            try {
                yield device.claimInterface(interfaceNumber);
            } catch (e) {
                yield device.close();
                throw new (0, $9a194f74559621d2$export$fd71e3a51c4bf0ae)(e.message);
            }
            const transport = new $8d7dfafe1dbfbf06$var$TransportWebUSB(device, interfaceNumber);
            const onDisconnect = (e)=>{
                if (device === e.device) {
                    // $FlowFixMe
                    navigator.usb.removeEventListener("disconnect", onDisconnect);
                    transport._emitDisconnect(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
                }
            };
            // $FlowFixMe
            navigator.usb.addEventListener("disconnect", onDisconnect);
            return transport;
        });
    }
    /**
     * Release the transport device
     */ close() {
        return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
            yield this.exchangeBusyPromise;
            yield this.device.releaseInterface(this.interfaceNumber);
            yield $8d7dfafe1dbfbf06$var$gracefullyResetDevice(this.device);
            yield this.device.close();
        });
    }
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ exchange(apdu) {
        return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
            const b = yield this.exchangeAtomicImpl(()=>$8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
                    const { channel: channel, packetSize: packetSize } = this;
                    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
                    const framing = (0, $f6e657627868bf3a$export$2e2bcd8739ae039)(channel, packetSize);
                    // Write...
                    const blocks = framing.makeBlocks(apdu);
                    for(let i = 0; i < blocks.length; i++)yield this.device.transferOut($8d7dfafe1dbfbf06$var$endpointNumber, blocks[i]);
                    // Read...
                    let result;
                    let acc;
                    while(!(result = framing.getReducedResult(acc))){
                        const r = yield this.device.transferIn($8d7dfafe1dbfbf06$var$endpointNumber, packetSize);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const buffer = $8d7dfafe1dbfbf06$require$Buffer.from(r.data.buffer);
                        acc = framing.reduceResponse(acc, buffer);
                    }
                    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
                    return result;
                })).catch((e)=>{
                if (e && e.message && e.message.includes("disconnected")) {
                    this._emitDisconnect(e);
                    throw new (0, $9a194f74559621d2$export$2a60f41a2ed2742)(e.message);
                }
                throw e;
            });
            return b;
        });
    }
    setScrambleKey() {}
}
/**
 * Check if WebUSB transport is supported.
 */ $8d7dfafe1dbfbf06$var$TransportWebUSB.isSupported = (0, $b3a6d5950238cf2e$export$48c17662a6902497);
/**
 * List the WebUSB devices that was previously authorized by the user.
 */ $8d7dfafe1dbfbf06$var$TransportWebUSB.list = (0, $b3a6d5950238cf2e$export$36755904a34d5197);
/**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */ $8d7dfafe1dbfbf06$var$TransportWebUSB.listen = (observer)=>{
    let unsubscribed = false;
    (0, $b3a6d5950238cf2e$export$527d8164321a6e6c)().then((device)=>{
        if (!unsubscribed) {
            const deviceModel = (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId);
            observer.next({
                type: "add",
                descriptor: device,
                deviceModel: deviceModel
            });
            observer.complete();
        }
    }, (error)=>{
        if (window.DOMException && error instanceof window.DOMException && error.code === 18) observer.error(new (0, $9a194f74559621d2$export$c0ffbdd94649bd06)(error.message));
        else observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
    });
    function unsubscribe() {
        unsubscribed = true;
    }
    return {
        unsubscribe: unsubscribe
    };
};
var $8d7dfafe1dbfbf06$export$2e2bcd8739ae039 = $8d7dfafe1dbfbf06$var$TransportWebUSB;
function $8d7dfafe1dbfbf06$var$gracefullyResetDevice(device) {
    return $8d7dfafe1dbfbf06$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield device.reset();
        } catch (err) {
            console.warn(err);
        }
    });
}


// Keep this import if you want to use a Ledger Nano S/X/S Plus with the HID protocol and delete the @ledgerhq/hw-transport-webusb import
// import TransportWebHID from '@ledgerhq/hw-transport-webhid'
//Display the header in the div which has the ID "main"
const $2b6e161c9edcf319$var$initial = "<h1>Click anywhere to connect to Ledger...</h1>";
const $2b6e161c9edcf319$var$$main = document.getElementById("main");
if (!$2b6e161c9edcf319$var$$main) throw new Error("no main");
$2b6e161c9edcf319$var$$main.innerHTML = $2b6e161c9edcf319$var$initial;
document.body.addEventListener("click", async ()=>{
    $2b6e161c9edcf319$var$$main.innerHTML = $2b6e161c9edcf319$var$initial;
    try {
        // Keep if you chose the USB protocol
        const transport = await (0, $8d7dfafe1dbfbf06$export$2e2bcd8739ae039).create();
        // Keep if you chose the HID protocol
        // const transport = await TransportWebHID.create()
        // Listen to the events which are sent by the Ledger packages in order to debug the app
        (0, $fdd451dd43e0ce6f$export$63174c828edd6ff8)((log)=>console.log(log));
        const app = new (0, $7a6cef509ca65f26$exports.AppClient)(transport);
        // Get the master key fingerprint
        const fpr = await app.getMasterFingerprint();
        console.log("Master key fingerprint:", fpr.toString("hex"));
        // Get App and Version
        const version = await app.getAppAndVersion();
        console.log("App and version:", version);
        // const ourPubkey = await app.getExtendedPubkey("m/48'/1'/0'/2'");
        // console.log('Our extended public key:', ourPubkey)
        // ERROR Ledger device: UNKNOWN_ERROR (0x6a82)
        // NOT working
        // const miniscriptPolicy = new WalletPolicy('Miniscript', "wsh(or_d(pk([558f6baa/48'/0'/0'/2']xpub6Dihm9N27y9sKx5zdn8XFuaM4umXe46eTJgQvhkoyQs6KrMNFHiZXxaaKcB9M5YhHMcB4oAYiXAWF1dHfk4h6GL1aVRZF2erfsiQPHcskxd/<0;1>/*),and_v(v:pkh([d65e423f/48'/0'/0'/2']xpub6DrgPQnhLamrvunhTnKngmdRP9aahxQtSaRcXMtzzq6cC7kJPpM9H5SEJXzzsmXCeEGxsDpGeF5rsw9ViQr7FBLJhQ4fLuoZTCjuJi8Yxsu/<0;1>/*),older(65535))))#7r9me7ca", [])
        // NOT working
        // const miniscriptPolicy = new WalletPolicy('Miniscript', "and_v(or_c(pk(B),or_c(pk(C),v:older(1000))),pk(A))", [
        //   "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
        //   "xpub6BosfCnifzxcFwrSzQiqu2DBVTshkCXacvNsWGYJVVhhawA7d4R5WSWGFNbi8Aw6ZRc1brxMyWMzG3DSSSSoekkudhUd9yLb6qx39T9nMdj",
        //   "xpub6C6nQwHaWbSrzs5tZ1q7m5R9cPK9eYpNMFesiXsYrgc1P8bvLLAet9JfHjYXKjToD8cBRswJXXbbFpXgwsswVPAZzKMa1jUp2kVkGVUaJa7"
        // ])
        // WORKGIN
        // const miniscriptPolicy = new WalletPolicy('Miniscript', "pkh(@0/**)", [
        //   "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
        // ])
        // WORKING
        // const miniscriptPolicy = new WalletPolicy('Miniscript', "wsh(or_d(pk(@0/<0;1>/*),and_v(v:pkh(@1/<0;1>/*),older(65535))))", [
        //   "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
        //   "xpub6BosfCnifzxcFwrSzQiqu2DBVTshkCXacvNsWGYJVVhhawA7d4R5WSWGFNbi8Aw6ZRc1brxMyWMzG3DSSSSoekkudhUd9yLb6qx39T9nMdj"
        // ])
        // WORKING
        // const miniscriptPolicy = new WalletPolicy('Miniscript', "wsh(or_d(or_d(pk(@0/<0;1>/*),pk(@1/<0;1>/*)),and_v(v:pkh(@2/<0;1>/*),older(65535))))", [
        //   "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
        //   "xpub6BosfCnifzxcFwrSzQiqu2DBVTshkCXacvNsWGYJVVhhawA7d4R5WSWGFNbi8Aw6ZRc1brxMyWMzG3DSSSSoekkudhUd9yLb6qx39T9nMdj",
        //   "xpub6C6nQwHaWbSrzs5tZ1q7m5R9cPK9eYpNMFesiXsYrgc1P8bvLLAet9JfHjYXKjToD8cBRswJXXbbFpXgwsswVPAZzKMa1jUp2kVkGVUaJa7"
        // ])
        // NOT working
        // const script = `
        // wsh(
        //   or_d(
        //     or_d(
        //       pk(@0/<0;1>/*),
        //       or_d(
        //         pk(@1/<0;1>/*),
        //         pk(@2/<0;1>/*)
        //       )
        //     ),
        //     sha256(@3/<0;1>/*)
        //   )
        // )`
        // const miniscriptPolicy = new WalletPolicy('Miniscript', scriptWithoutWhitespaces, [
        //   "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
        //   "xpub6BosfCnifzxcFwrSzQiqu2DBVTshkCXacvNsWGYJVVhhawA7d4R5WSWGFNbi8Aw6ZRc1brxMyWMzG3DSSSSoekkudhUd9yLb6qx39T9nMdj",
        //   "xpub6C6nQwHaWbSrzs5tZ1q7m5R9cPK9eYpNMFesiXsYrgc1P8bvLLAet9JfHjYXKjToD8cBRswJXXbbFpXgwsswVPAZzKMa1jUp2kVkGVUaJa7",
        //   "xpub6CatWdiZiodmUeTDp8LT5or8nmbKNcuyvz7WyksVFkKB4RHwCD3XyuvPEbvqAQY3rAPshWcMLoP2fMFMKHPJ4ZeZXYVUhLv1VMrjPC7PW6V"
        // ])
        // WORKING
        //     const script = `
        // wsh(
        //   or_d(
        //     or_d(
        //       pk(@0/<0;1>/*),
        //       pk(@1/<0;1>/*)
        //     ),
        //     and_v(
        //       v:pkh(@2/<0;1>/*),
        //       older(65535)
        //     )
        //   )
        // )`
        const script = `
    wsh(
      or_d(
        or_d(
          pk(@0/<0;1>/*),
          or_d(
            pk(@1/<0;1>/*),
            pk(@2/<0;1>/*)
          )
        ),
        and_v(
          v:pkh(@3/<0;1>/*),
          older(65535)
        )
      )
    )`;
        const scriptWithoutWhitespaces = script.replace(/\s+/g, "");
        console.log(scriptWithoutWhitespaces);
        const miniscriptPolicy = new (0, $7a6cef509ca65f26$exports.WalletPolicy)("Miniscript", scriptWithoutWhitespaces, [
            "xpub67yMUMbr2gAnBgnYvXcbJq8iUBe54Ev2dbUYKGN8jGY21AHJFeR7mnZqhbUNze4UbpRE9S1fWvmFCsFN4EvU1rWdqegW7dzoa7vZmYCLAAy",
            "xpub6BosfCnifzxcFwrSzQiqu2DBVTshkCXacvNsWGYJVVhhawA7d4R5WSWGFNbi8Aw6ZRc1brxMyWMzG3DSSSSoekkudhUd9yLb6qx39T9nMdj",
            "xpub6C6nQwHaWbSrzs5tZ1q7m5R9cPK9eYpNMFesiXsYrgc1P8bvLLAet9JfHjYXKjToD8cBRswJXXbbFpXgwsswVPAZzKMa1jUp2kVkGVUaJa7",
            "xpub6CatWdiZiodmUeTDp8LT5or8nmbKNcuyvz7WyksVFkKB4RHwCD3XyuvPEbvqAQY3rAPshWcMLoP2fMFMKHPJ4ZeZXYVUhLv1VMrjPC7PW6V"
        ]);
        const [policyId, policyHmac] = await app.registerWallet(miniscriptPolicy);
        console.log(policyId, policyHmac);
    // const ourKeyInfo = `[${fpr}/48'/1'/0'/2']${ourPubkey}`;
    // const otherKeyInfo = "[76223a6e/48'/1'/0'/2']tpubDE7NQymr4AFtewpAsWtnreyq9ghkzQBXpCZjWLFVRAvnbf7vya2eMTvT2fPapNqL8SuVvLQdbUbMfWLVDCZKnsEBqp6UK93QEzL8Ck23AwF";
    // const multisigPolicy = new WalletPolicy(
    //   "Cold storage",
    //   "wsh(sortedmulti(2,@0/**,@1/**))", // a 2-of-2 multisig policy template
    //   [
    //     otherKeyInfo, // some other bitcoiner
    //     ourKeyInfo,   // that's us
    //   ]
    // )
    // Display your bitcoin address on the screen
    // const h2 = document.createElement('h2')
    // h2.textContent = bitcoinAddress
    // $main.innerHTML = '<h1>Your first Bitcoin address:</h1>'
    // $main.appendChild(h2)
    } catch (e) {
        //Catch any error thrown and displays it on the screen
        console.error(e);
        const $err = document.createElement("code");
        $err.style.color = "#f66";
        $err.textContent = String(e.message || e);
        $2b6e161c9edcf319$var$$main.appendChild($err);
    }
});


//# sourceMappingURL=index.17895c67.js.map
